/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports
        ? (module.exports = e.document
              ? t(e, !0)
              : function (e) {
                    if (!e.document) throw new Error("jQuery requires a window with a document");
                    return t(e);
                })
        : t(e);
})("undefined" != typeof window ? window : this, function (C, e) {
    "use strict";
    var t = [],
        r = Object.getPrototypeOf,
        s = t.slice,
        g = t.flat
            ? function (e) {
                  return t.flat.call(e);
              }
            : function (e) {
                  return t.concat.apply([], e);
              },
        u = t.push,
        i = t.indexOf,
        n = {},
        o = n.toString,
        v = n.hasOwnProperty,
        a = v.toString,
        l = a.call(Object),
        y = {},
        m = function (e) {
            return "function" == typeof e && "number" != typeof e.nodeType;
        },
        x = function (e) {
            return null != e && e === e.window;
        },
        E = C.document,
        c = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function b(e, t, n) {
        var r,
            i,
            o = (n = n || E).createElement("script");
        if (((o.text = e), t)) for (r in c) (i = t[r] || (t.getAttribute && t.getAttribute(r))) && o.setAttribute(r, i);
        n.head.appendChild(o).parentNode.removeChild(o);
    }
    function w(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? n[o.call(e)] || "object" : typeof e;
    }
    var f = "3.5.1",
        S = function (e, t) {
            return new S.fn.init(e, t);
        };
    function p(e) {
        var t = !!e && "length" in e && e.length,
            n = w(e);
        return !m(e) && !x(e) && ("array" === n || 0 === t || ("number" == typeof t && 0 < t && t - 1 in e));
    }
    (S.fn = S.prototype = {
        jquery: f,
        constructor: S,
        length: 0,
        toArray: function () {
            return s.call(this);
        },
        get: function (e) {
            return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
        },
        pushStack: function (e) {
            var t = S.merge(this.constructor(), e);
            return (t.prevObject = this), t;
        },
        each: function (e) {
            return S.each(this, e);
        },
        map: function (n) {
            return this.pushStack(
                S.map(this, function (e, t) {
                    return n.call(e, t, e);
                })
            );
        },
        slice: function () {
            return this.pushStack(s.apply(this, arguments));
        },
        first: function () {
            return this.eq(0);
        },
        last: function () {
            return this.eq(-1);
        },
        even: function () {
            return this.pushStack(
                S.grep(this, function (e, t) {
                    return (t + 1) % 2;
                })
            );
        },
        odd: function () {
            return this.pushStack(
                S.grep(this, function (e, t) {
                    return t % 2;
                })
            );
        },
        eq: function (e) {
            var t = this.length,
                n = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= n && n < t ? [this[n]] : []);
        },
        end: function () {
            return this.prevObject || this.constructor();
        },
        push: u,
        sort: t.sort,
        splice: t.splice,
    }),
        (S.extend = S.fn.extend = function () {
            var e,
                t,
                n,
                r,
                i,
                o,
                a = arguments[0] || {},
                s = 1,
                u = arguments.length,
                l = !1;
            for (
                "boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++),
                    "object" == typeof a || m(a) || (a = {}),
                    s === u && ((a = this), s--);
                s < u;
                s++
            )
                if (null != (e = arguments[s]))
                    for (t in e)
                        (r = e[t]),
                            "__proto__" !== t &&
                                a !== r &&
                                (l && r && (S.isPlainObject(r) || (i = Array.isArray(r)))
                                    ? ((n = a[t]),
                                      (o = i && !Array.isArray(n) ? [] : i || S.isPlainObject(n) ? n : {}),
                                      (i = !1),
                                      (a[t] = S.extend(l, o, r)))
                                    : void 0 !== r && (a[t] = r));
            return a;
        }),
        S.extend({
            expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (e) {
                throw new Error(e);
            },
            noop: function () {},
            isPlainObject: function (e) {
                var t, n;
                return (
                    !(!e || "[object Object]" !== o.call(e)) &&
                    (!(t = r(e)) || ("function" == typeof (n = v.call(t, "constructor") && t.constructor) && a.call(n) === l))
                );
            },
            isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
            },
            globalEval: function (e, t, n) {
                b(e, { nonce: t && t.nonce }, n);
            },
            each: function (e, t) {
                var n,
                    r = 0;
                if (p(e)) {
                    for (n = e.length; r < n; r++) if (!1 === t.call(e[r], r, e[r])) break;
                } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
                return e;
            },
            makeArray: function (e, t) {
                var n = t || [];
                return null != e && (p(Object(e)) ? S.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n;
            },
            inArray: function (e, t, n) {
                return null == t ? -1 : i.call(t, e, n);
            },
            merge: function (e, t) {
                for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
                return (e.length = i), e;
            },
            grep: function (e, t, n) {
                for (var r = [], i = 0, o = e.length, a = !n; i < o; i++) !t(e[i], i) !== a && r.push(e[i]);
                return r;
            },
            map: function (e, t, n) {
                var r,
                    i,
                    o = 0,
                    a = [];
                if (p(e)) for (r = e.length; o < r; o++) null != (i = t(e[o], o, n)) && a.push(i);
                else for (o in e) null != (i = t(e[o], o, n)) && a.push(i);
                return g(a);
            },
            guid: 1,
            support: y,
        }),
        "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]),
        S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            n["[object " + t + "]"] = t.toLowerCase();
        });
    var d = (function (n) {
        var e,
            d,
            b,
            o,
            i,
            h,
            f,
            g,
            w,
            u,
            l,
            T,
            C,
            a,
            E,
            v,
            s,
            c,
            y,
            S = "sizzle" + 1 * new Date(),
            p = n.document,
            k = 0,
            r = 0,
            m = ue(),
            x = ue(),
            A = ue(),
            N = ue(),
            D = function (e, t) {
                return e === t && (l = !0), 0;
            },
            j = {}.hasOwnProperty,
            t = [],
            q = t.pop,
            L = t.push,
            H = t.push,
            O = t.slice,
            P = function (e, t) {
                for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
                return -1;
            },
            R = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            M = "[\\x20\\t\\r\\n\\f]",
            I = "(?:\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            W =
                "\\[" +
                M +
                "*(" +
                I +
                ")(?:" +
                M +
                "*([*^$|!~]?=)" +
                M +
                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                I +
                "))|)" +
                M +
                "*\\]",
            F = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + W + ")*)|.*)\\)|)",
            B = new RegExp(M + "+", "g"),
            $ = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
            _ = new RegExp("^" + M + "*," + M + "*"),
            z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
            U = new RegExp(M + "|>"),
            X = new RegExp(F),
            V = new RegExp("^" + I + "$"),
            G = {
                ID: new RegExp("^#(" + I + ")"),
                CLASS: new RegExp("^\\.(" + I + ")"),
                TAG: new RegExp("^(" + I + "|[*])"),
                ATTR: new RegExp("^" + W),
                PSEUDO: new RegExp("^" + F),
                CHILD: new RegExp(
                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                        M +
                        "*(even|odd|(([+-]|)(\\d*)n|)" +
                        M +
                        "*(?:([+-]|)" +
                        M +
                        "*(\\d+)|))" +
                        M +
                        "*\\)|)",
                    "i"
                ),
                bool: new RegExp("^(?:" + R + ")$", "i"),
                needsContext: new RegExp(
                    "^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)",
                    "i"
                ),
            },
            Y = /HTML$/i,
            Q = /^(?:input|select|textarea|button)$/i,
            J = /^h\d$/i,
            K = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"),
            ne = function (e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320));
            },
            re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ie = function (e, t) {
                return t ? ("\0" === e ? "\ufffd" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
            },
            oe = function () {
                T();
            },
            ae = be(
                function (e) {
                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                },
                { dir: "parentNode", next: "legend" }
            );
        try {
            H.apply((t = O.call(p.childNodes)), p.childNodes), t[p.childNodes.length].nodeType;
        } catch (e) {
            H = {
                apply: t.length
                    ? function (e, t) {
                          L.apply(e, O.call(t));
                      }
                    : function (e, t) {
                          var n = e.length,
                              r = 0;
                          while ((e[n++] = t[r++]));
                          e.length = n - 1;
                      },
            };
        }
        function se(t, e, n, r) {
            var i,
                o,
                a,
                s,
                u,
                l,
                c,
                f = e && e.ownerDocument,
                p = e ? e.nodeType : 9;
            if (((n = n || []), "string" != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))) return n;
            if (!r && (T(e), (e = e || C), E)) {
                if (11 !== p && (u = Z.exec(t)))
                    if ((i = u[1])) {
                        if (9 === p) {
                            if (!(a = e.getElementById(i))) return n;
                            if (a.id === i) return n.push(a), n;
                        } else if (f && (a = f.getElementById(i)) && y(e, a) && a.id === i) return n.push(a), n;
                    } else {
                        if (u[2]) return H.apply(n, e.getElementsByTagName(t)), n;
                        if ((i = u[3]) && d.getElementsByClassName && e.getElementsByClassName) return H.apply(n, e.getElementsByClassName(i)), n;
                    }
                if (d.qsa && !N[t + " "] && (!v || !v.test(t)) && (1 !== p || "object" !== e.nodeName.toLowerCase())) {
                    if (((c = t), (f = e), 1 === p && (U.test(t) || z.test(t)))) {
                        ((f = (ee.test(t) && ye(e.parentNode)) || e) === e && d.scope) ||
                            ((s = e.getAttribute("id")) ? (s = s.replace(re, ie)) : e.setAttribute("id", (s = S))),
                            (o = (l = h(t)).length);
                        while (o--) l[o] = (s ? "#" + s : ":scope") + " " + xe(l[o]);
                        c = l.join(",");
                    }
                    try {
                        return H.apply(n, f.querySelectorAll(c)), n;
                    } catch (e) {
                        N(t, !0);
                    } finally {
                        s === S && e.removeAttribute("id");
                    }
                }
            }
            return g(t.replace($, "$1"), e, n, r);
        }
        function ue() {
            var r = [];
            return function e(t, n) {
                return r.push(t + " ") > b.cacheLength && delete e[r.shift()], (e[t + " "] = n);
            };
        }
        function le(e) {
            return (e[S] = !0), e;
        }
        function ce(e) {
            var t = C.createElement("fieldset");
            try {
                return !!e(t);
            } catch (e) {
                return !1;
            } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
        }
        function fe(e, t) {
            var n = e.split("|"),
                r = n.length;
            while (r--) b.attrHandle[n[r]] = t;
        }
        function pe(e, t) {
            var n = t && e,
                r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (r) return r;
            if (n) while ((n = n.nextSibling)) if (n === t) return -1;
            return e ? 1 : -1;
        }
        function de(t) {
            return function (e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t;
            };
        }
        function he(n) {
            return function (e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t || "button" === t) && e.type === n;
            };
        }
        function ge(t) {
            return function (e) {
                return "form" in e
                    ? e.parentNode && !1 === e.disabled
                        ? "label" in e
                            ? "label" in e.parentNode
                                ? e.parentNode.disabled === t
                                : e.disabled === t
                            : e.isDisabled === t || (e.isDisabled !== !t && ae(e) === t)
                        : e.disabled === t
                    : "label" in e && e.disabled === t;
            };
        }
        function ve(a) {
            return le(function (o) {
                return (
                    (o = +o),
                    le(function (e, t) {
                        var n,
                            r = a([], e.length, o),
                            i = r.length;
                        while (i--) e[(n = r[i])] && (e[n] = !(t[n] = e[n]));
                    })
                );
            });
        }
        function ye(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e;
        }
        for (e in ((d = se.support = {}),
        (i = se.isXML = function (e) {
            var t = e.namespaceURI,
                n = (e.ownerDocument || e).documentElement;
            return !Y.test(t || (n && n.nodeName) || "HTML");
        }),
        (T = se.setDocument = function (e) {
            var t,
                n,
                r = e ? e.ownerDocument || e : p;
            return (
                r != C &&
                    9 === r.nodeType &&
                    r.documentElement &&
                    ((a = (C = r).documentElement),
                    (E = !i(C)),
                    p != C &&
                        (n = C.defaultView) &&
                        n.top !== n &&
                        (n.addEventListener ? n.addEventListener("unload", oe, !1) : n.attachEvent && n.attachEvent("onunload", oe)),
                    (d.scope = ce(function (e) {
                        return (
                            a.appendChild(e).appendChild(C.createElement("div")),
                            "undefined" != typeof e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
                        );
                    })),
                    (d.attributes = ce(function (e) {
                        return (e.className = "i"), !e.getAttribute("className");
                    })),
                    (d.getElementsByTagName = ce(function (e) {
                        return e.appendChild(C.createComment("")), !e.getElementsByTagName("*").length;
                    })),
                    (d.getElementsByClassName = K.test(C.getElementsByClassName)),
                    (d.getById = ce(function (e) {
                        return (a.appendChild(e).id = S), !C.getElementsByName || !C.getElementsByName(S).length;
                    })),
                    d.getById
                        ? ((b.filter.ID = function (e) {
                              var t = e.replace(te, ne);
                              return function (e) {
                                  return e.getAttribute("id") === t;
                              };
                          }),
                          (b.find.ID = function (e, t) {
                              if ("undefined" != typeof t.getElementById && E) {
                                  var n = t.getElementById(e);
                                  return n ? [n] : [];
                              }
                          }))
                        : ((b.filter.ID = function (e) {
                              var n = e.replace(te, ne);
                              return function (e) {
                                  var t = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                                  return t && t.value === n;
                              };
                          }),
                          (b.find.ID = function (e, t) {
                              if ("undefined" != typeof t.getElementById && E) {
                                  var n,
                                      r,
                                      i,
                                      o = t.getElementById(e);
                                  if (o) {
                                      if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                      (i = t.getElementsByName(e)), (r = 0);
                                      while ((o = i[r++])) if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                  }
                                  return [];
                              }
                          })),
                    (b.find.TAG = d.getElementsByTagName
                        ? function (e, t) {
                              return "undefined" != typeof t.getElementsByTagName
                                  ? t.getElementsByTagName(e)
                                  : d.qsa
                                  ? t.querySelectorAll(e)
                                  : void 0;
                          }
                        : function (e, t) {
                              var n,
                                  r = [],
                                  i = 0,
                                  o = t.getElementsByTagName(e);
                              if ("*" === e) {
                                  while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                                  return r;
                              }
                              return o;
                          }),
                    (b.find.CLASS =
                        d.getElementsByClassName &&
                        function (e, t) {
                            if ("undefined" != typeof t.getElementsByClassName && E) return t.getElementsByClassName(e);
                        }),
                    (s = []),
                    (v = []),
                    (d.qsa = K.test(C.querySelectorAll)) &&
                        (ce(function (e) {
                            var t;
                            (a.appendChild(e).innerHTML =
                                "<a id='" + S + "'></a><select id='" + S + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + M + "*(?:''|\"\")"),
                                e.querySelectorAll("[selected]").length || v.push("\\[" + M + "*(?:value|" + R + ")"),
                                e.querySelectorAll("[id~=" + S + "-]").length || v.push("~="),
                                (t = C.createElement("input")).setAttribute("name", ""),
                                e.appendChild(t),
                                e.querySelectorAll("[name='']").length || v.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"),
                                e.querySelectorAll(":checked").length || v.push(":checked"),
                                e.querySelectorAll("a#" + S + "+*").length || v.push(".#.+[+~]"),
                                e.querySelectorAll("\\\f"),
                                v.push("[\\r\\n\\f]");
                        }),
                        ce(function (e) {
                            e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                            var t = C.createElement("input");
                            t.setAttribute("type", "hidden"),
                                e.appendChild(t).setAttribute("name", "D"),
                                e.querySelectorAll("[name=d]").length && v.push("name" + M + "*[*^$|!~]?="),
                                2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"),
                                (a.appendChild(e).disabled = !0),
                                2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"),
                                e.querySelectorAll("*,:x"),
                                v.push(",.*:");
                        })),
                    (d.matchesSelector = K.test(
                        (c = a.matches || a.webkitMatchesSelector || a.mozMatchesSelector || a.oMatchesSelector || a.msMatchesSelector)
                    )) &&
                        ce(function (e) {
                            (d.disconnectedMatch = c.call(e, "*")), c.call(e, "[s!='']:x"), s.push("!=", F);
                        }),
                    (v = v.length && new RegExp(v.join("|"))),
                    (s = s.length && new RegExp(s.join("|"))),
                    (t = K.test(a.compareDocumentPosition)),
                    (y =
                        t || K.test(a.contains)
                            ? function (e, t) {
                                  var n = 9 === e.nodeType ? e.documentElement : e,
                                      r = t && t.parentNode;
                                  return (
                                      e === r ||
                                      !(
                                          !r ||
                                          1 !== r.nodeType ||
                                          !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))
                                      )
                                  );
                              }
                            : function (e, t) {
                                  if (t) while ((t = t.parentNode)) if (t === e) return !0;
                                  return !1;
                              }),
                    (D = t
                        ? function (e, t) {
                              if (e === t) return (l = !0), 0;
                              var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                              return (
                                  n ||
                                  (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) ||
                                  (!d.sortDetached && t.compareDocumentPosition(e) === n)
                                      ? e == C || (e.ownerDocument == p && y(p, e))
                                          ? -1
                                          : t == C || (t.ownerDocument == p && y(p, t))
                                          ? 1
                                          : u
                                          ? P(u, e) - P(u, t)
                                          : 0
                                      : 4 & n
                                      ? -1
                                      : 1)
                              );
                          }
                        : function (e, t) {
                              if (e === t) return (l = !0), 0;
                              var n,
                                  r = 0,
                                  i = e.parentNode,
                                  o = t.parentNode,
                                  a = [e],
                                  s = [t];
                              if (!i || !o) return e == C ? -1 : t == C ? 1 : i ? -1 : o ? 1 : u ? P(u, e) - P(u, t) : 0;
                              if (i === o) return pe(e, t);
                              n = e;
                              while ((n = n.parentNode)) a.unshift(n);
                              n = t;
                              while ((n = n.parentNode)) s.unshift(n);
                              while (a[r] === s[r]) r++;
                              return r ? pe(a[r], s[r]) : a[r] == p ? -1 : s[r] == p ? 1 : 0;
                          })),
                C
            );
        }),
        (se.matches = function (e, t) {
            return se(e, null, null, t);
        }),
        (se.matchesSelector = function (e, t) {
            if ((T(e), d.matchesSelector && E && !N[t + " "] && (!s || !s.test(t)) && (!v || !v.test(t))))
                try {
                    var n = c.call(e, t);
                    if (n || d.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return n;
                } catch (e) {
                    N(t, !0);
                }
            return 0 < se(t, C, null, [e]).length;
        }),
        (se.contains = function (e, t) {
            return (e.ownerDocument || e) != C && T(e), y(e, t);
        }),
        (se.attr = function (e, t) {
            (e.ownerDocument || e) != C && T(e);
            var n = b.attrHandle[t.toLowerCase()],
                r = n && j.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0;
            return void 0 !== r ? r : d.attributes || !E ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
        }),
        (se.escape = function (e) {
            return (e + "").replace(re, ie);
        }),
        (se.error = function (e) {
            throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (se.uniqueSort = function (e) {
            var t,
                n = [],
                r = 0,
                i = 0;
            if (((l = !d.detectDuplicates), (u = !d.sortStable && e.slice(0)), e.sort(D), l)) {
                while ((t = e[i++])) t === e[i] && (r = n.push(i));
                while (r--) e.splice(n[r], 1);
            }
            return (u = null), e;
        }),
        (o = se.getText = function (e) {
            var t,
                n = "",
                r = 0,
                i = e.nodeType;
            if (i) {
                if (1 === i || 9 === i || 11 === i) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
                } else if (3 === i || 4 === i) return e.nodeValue;
            } else while ((t = e[r++])) n += o(t);
            return n;
        }),
        ((b = se.selectors = {
            cacheLength: 50,
            createPseudo: le,
            match: G,
            attrHandle: {},
            find: {},
            relative: {
                ">": { dir: "parentNode", first: !0 },
                " ": { dir: "parentNode" },
                "+": { dir: "previousSibling", first: !0 },
                "~": { dir: "previousSibling" },
            },
            preFilter: {
                ATTR: function (e) {
                    return (
                        (e[1] = e[1].replace(te, ne)),
                        (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
                        "~=" === e[2] && (e[3] = " " + e[3] + " "),
                        e.slice(0, 4)
                    );
                },
                CHILD: function (e) {
                    return (
                        (e[1] = e[1].toLowerCase()),
                        "nth" === e[1].slice(0, 3)
                            ? (e[3] || se.error(e[0]),
                              (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))),
                              (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                            : e[3] && se.error(e[0]),
                        e
                    );
                },
                PSEUDO: function (e) {
                    var t,
                        n = !e[6] && e[2];
                    return G.CHILD.test(e[0])
                        ? null
                        : (e[3]
                              ? (e[2] = e[4] || e[5] || "")
                              : n &&
                                X.test(n) &&
                                (t = h(n, !0)) &&
                                (t = n.indexOf(")", n.length - t) - n.length) &&
                                ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                          e.slice(0, 3));
                },
            },
            filter: {
                TAG: function (e) {
                    var t = e.replace(te, ne).toLowerCase();
                    return "*" === e
                        ? function () {
                              return !0;
                          }
                        : function (e) {
                              return e.nodeName && e.nodeName.toLowerCase() === t;
                          };
                },
                CLASS: function (e) {
                    var t = m[e + " "];
                    return (
                        t ||
                        ((t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) &&
                            m(e, function (e) {
                                return t.test(
                                    ("string" == typeof e.className && e.className) ||
                                        ("undefined" != typeof e.getAttribute && e.getAttribute("class")) ||
                                        ""
                                );
                            }))
                    );
                },
                ATTR: function (n, r, i) {
                    return function (e) {
                        var t = se.attr(e, n);
                        return null == t
                            ? "!=" === r
                            : !r ||
                                  ((t += ""),
                                  "=" === r
                                      ? t === i
                                      : "!=" === r
                                      ? t !== i
                                      : "^=" === r
                                      ? i && 0 === t.indexOf(i)
                                      : "*=" === r
                                      ? i && -1 < t.indexOf(i)
                                      : "$=" === r
                                      ? i && t.slice(-i.length) === i
                                      : "~=" === r
                                      ? -1 < (" " + t.replace(B, " ") + " ").indexOf(i)
                                      : "|=" === r && (t === i || t.slice(0, i.length + 1) === i + "-"));
                    };
                },
                CHILD: function (h, e, t, g, v) {
                    var y = "nth" !== h.slice(0, 3),
                        m = "last" !== h.slice(-4),
                        x = "of-type" === e;
                    return 1 === g && 0 === v
                        ? function (e) {
                              return !!e.parentNode;
                          }
                        : function (e, t, n) {
                              var r,
                                  i,
                                  o,
                                  a,
                                  s,
                                  u,
                                  l = y !== m ? "nextSibling" : "previousSibling",
                                  c = e.parentNode,
                                  f = x && e.nodeName.toLowerCase(),
                                  p = !n && !x,
                                  d = !1;
                              if (c) {
                                  if (y) {
                                      while (l) {
                                          a = e;
                                          while ((a = a[l])) if (x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) return !1;
                                          u = l = "only" === h && !u && "nextSibling";
                                      }
                                      return !0;
                                  }
                                  if (((u = [m ? c.firstChild : c.lastChild]), m && p)) {
                                      (d =
                                          (s =
                                              (r = (i = (o = (a = c)[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] || [])[0] === k &&
                                              r[1]) && r[2]),
                                          (a = s && c.childNodes[s]);
                                      while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                                          if (1 === a.nodeType && ++d && a === e) {
                                              i[h] = [k, s, d];
                                              break;
                                          }
                                  } else if (
                                      (p &&
                                          (d = s =
                                              (r = (i = (o = (a = e)[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] || [])[0] === k &&
                                              r[1]),
                                      !1 === d)
                                  )
                                      while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                                          if (
                                              (x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) &&
                                              ++d &&
                                              (p && ((i = (o = a[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] = [k, d]), a === e)
                                          )
                                              break;
                                  return (d -= v) === g || (d % g == 0 && 0 <= d / g);
                              }
                          };
                },
                PSEUDO: function (e, o) {
                    var t,
                        a = b.pseudos[e] || b.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
                    return a[S]
                        ? a(o)
                        : 1 < a.length
                        ? ((t = [e, e, "", o]),
                          b.setFilters.hasOwnProperty(e.toLowerCase())
                              ? le(function (e, t) {
                                    var n,
                                        r = a(e, o),
                                        i = r.length;
                                    while (i--) e[(n = P(e, r[i]))] = !(t[n] = r[i]);
                                })
                              : function (e) {
                                    return a(e, 0, t);
                                })
                        : a;
                },
            },
            pseudos: {
                not: le(function (e) {
                    var r = [],
                        i = [],
                        s = f(e.replace($, "$1"));
                    return s[S]
                        ? le(function (e, t, n, r) {
                              var i,
                                  o = s(e, null, r, []),
                                  a = e.length;
                              while (a--) (i = o[a]) && (e[a] = !(t[a] = i));
                          })
                        : function (e, t, n) {
                              return (r[0] = e), s(r, null, n, i), (r[0] = null), !i.pop();
                          };
                }),
                has: le(function (t) {
                    return function (e) {
                        return 0 < se(t, e).length;
                    };
                }),
                contains: le(function (t) {
                    return (
                        (t = t.replace(te, ne)),
                        function (e) {
                            return -1 < (e.textContent || o(e)).indexOf(t);
                        }
                    );
                }),
                lang: le(function (n) {
                    return (
                        V.test(n || "") || se.error("unsupported lang: " + n),
                        (n = n.replace(te, ne).toLowerCase()),
                        function (e) {
                            var t;
                            do {
                                if ((t = E ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")))
                                    return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-");
                            } while ((e = e.parentNode) && 1 === e.nodeType);
                            return !1;
                        }
                    );
                }),
                target: function (e) {
                    var t = n.location && n.location.hash;
                    return t && t.slice(1) === e.id;
                },
                root: function (e) {
                    return e === a;
                },
                focus: function (e) {
                    return e === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: ge(!1),
                disabled: ge(!0),
                checked: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                },
                selected: function (e) {
                    return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                    return !0;
                },
                parent: function (e) {
                    return !b.pseudos.empty(e);
                },
                header: function (e) {
                    return J.test(e.nodeName);
                },
                input: function (e) {
                    return Q.test(e.nodeName);
                },
                button: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && "button" === e.type) || "button" === t;
                },
                text: function (e) {
                    var t;
                    return (
                        "input" === e.nodeName.toLowerCase() &&
                        "text" === e.type &&
                        (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                    );
                },
                first: ve(function () {
                    return [0];
                }),
                last: ve(function (e, t) {
                    return [t - 1];
                }),
                eq: ve(function (e, t, n) {
                    return [n < 0 ? n + t : n];
                }),
                even: ve(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                }),
                odd: ve(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                }),
                lt: ve(function (e, t, n) {
                    for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r; ) e.push(r);
                    return e;
                }),
                gt: ve(function (e, t, n) {
                    for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
                    return e;
                }),
            },
        }).pseudos.nth = b.pseudos.eq),
        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            b.pseudos[e] = de(e);
        for (e in { submit: !0, reset: !0 }) b.pseudos[e] = he(e);
        function me() {}
        function xe(e) {
            for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
            return r;
        }
        function be(s, e, t) {
            var u = e.dir,
                l = e.next,
                c = l || u,
                f = t && "parentNode" === c,
                p = r++;
            return e.first
                ? function (e, t, n) {
                      while ((e = e[u])) if (1 === e.nodeType || f) return s(e, t, n);
                      return !1;
                  }
                : function (e, t, n) {
                      var r,
                          i,
                          o,
                          a = [k, p];
                      if (n) {
                          while ((e = e[u])) if ((1 === e.nodeType || f) && s(e, t, n)) return !0;
                      } else
                          while ((e = e[u]))
                              if (1 === e.nodeType || f)
                                  if (((i = (o = e[S] || (e[S] = {}))[e.uniqueID] || (o[e.uniqueID] = {})), l && l === e.nodeName.toLowerCase()))
                                      e = e[u] || e;
                                  else {
                                      if ((r = i[c]) && r[0] === k && r[1] === p) return (a[2] = r[2]);
                                      if (((i[c] = a)[2] = s(e, t, n))) return !0;
                                  }
                      return !1;
                  };
        }
        function we(i) {
            return 1 < i.length
                ? function (e, t, n) {
                      var r = i.length;
                      while (r--) if (!i[r](e, t, n)) return !1;
                      return !0;
                  }
                : i[0];
        }
        function Te(e, t, n, r, i) {
            for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++) (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
            return a;
        }
        function Ce(d, h, g, v, y, e) {
            return (
                v && !v[S] && (v = Ce(v)),
                y && !y[S] && (y = Ce(y, e)),
                le(function (e, t, n, r) {
                    var i,
                        o,
                        a,
                        s = [],
                        u = [],
                        l = t.length,
                        c =
                            e ||
                            (function (e, t, n) {
                                for (var r = 0, i = t.length; r < i; r++) se(e, t[r], n);
                                return n;
                            })(h || "*", n.nodeType ? [n] : n, []),
                        f = !d || (!e && h) ? c : Te(c, s, d, n, r),
                        p = g ? (y || (e ? d : l || v) ? [] : t) : f;
                    if ((g && g(f, p, n, r), v)) {
                        (i = Te(p, u)), v(i, [], n, r), (o = i.length);
                        while (o--) (a = i[o]) && (p[u[o]] = !(f[u[o]] = a));
                    }
                    if (e) {
                        if (y || d) {
                            if (y) {
                                (i = []), (o = p.length);
                                while (o--) (a = p[o]) && i.push((f[o] = a));
                                y(null, (p = []), i, r);
                            }
                            o = p.length;
                            while (o--) (a = p[o]) && -1 < (i = y ? P(e, a) : s[o]) && (e[i] = !(t[i] = a));
                        }
                    } else (p = Te(p === t ? p.splice(l, p.length) : p)), y ? y(null, t, p, r) : H.apply(t, p);
                })
            );
        }
        function Ee(e) {
            for (
                var i,
                    t,
                    n,
                    r = e.length,
                    o = b.relative[e[0].type],
                    a = o || b.relative[" "],
                    s = o ? 1 : 0,
                    u = be(
                        function (e) {
                            return e === i;
                        },
                        a,
                        !0
                    ),
                    l = be(
                        function (e) {
                            return -1 < P(i, e);
                        },
                        a,
                        !0
                    ),
                    c = [
                        function (e, t, n) {
                            var r = (!o && (n || t !== w)) || ((i = t).nodeType ? u(e, t, n) : l(e, t, n));
                            return (i = null), r;
                        },
                    ];
                s < r;
                s++
            )
                if ((t = b.relative[e[s].type])) c = [be(we(c), t)];
                else {
                    if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) {
                        for (n = ++s; n < r; n++) if (b.relative[e[n].type]) break;
                        return Ce(
                            1 < s && we(c),
                            1 < s && xe(e.slice(0, s - 1).concat({ value: " " === e[s - 2].type ? "*" : "" })).replace($, "$1"),
                            t,
                            s < n && Ee(e.slice(s, n)),
                            n < r && Ee((e = e.slice(n))),
                            n < r && xe(e)
                        );
                    }
                    c.push(t);
                }
            return we(c);
        }
        return (
            (me.prototype = b.filters = b.pseudos),
            (b.setFilters = new me()),
            (h = se.tokenize = function (e, t) {
                var n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l = x[e + " "];
                if (l) return t ? 0 : l.slice(0);
                (a = e), (s = []), (u = b.preFilter);
                while (a) {
                    for (o in ((n && !(r = _.exec(a))) || (r && (a = a.slice(r[0].length) || a), s.push((i = []))),
                    (n = !1),
                    (r = z.exec(a)) && ((n = r.shift()), i.push({ value: n, type: r[0].replace($, " ") }), (a = a.slice(n.length))),
                    b.filter))
                        !(r = G[o].exec(a)) ||
                            (u[o] && !(r = u[o](r))) ||
                            ((n = r.shift()), i.push({ value: n, type: o, matches: r }), (a = a.slice(n.length)));
                    if (!n) break;
                }
                return t ? a.length : a ? se.error(e) : x(e, s).slice(0);
            }),
            (f = se.compile = function (e, t) {
                var n,
                    v,
                    y,
                    m,
                    x,
                    r,
                    i = [],
                    o = [],
                    a = A[e + " "];
                if (!a) {
                    t || (t = h(e)), (n = t.length);
                    while (n--) (a = Ee(t[n]))[S] ? i.push(a) : o.push(a);
                    (a = A(
                        e,
                        ((v = o),
                        (m = 0 < (y = i).length),
                        (x = 0 < v.length),
                        (r = function (e, t, n, r, i) {
                            var o,
                                a,
                                s,
                                u = 0,
                                l = "0",
                                c = e && [],
                                f = [],
                                p = w,
                                d = e || (x && b.find.TAG("*", i)),
                                h = (k += null == p ? 1 : Math.random() || 0.1),
                                g = d.length;
                            for (i && (w = t == C || t || i); l !== g && null != (o = d[l]); l++) {
                                if (x && o) {
                                    (a = 0), t || o.ownerDocument == C || (T(o), (n = !E));
                                    while ((s = v[a++]))
                                        if (s(o, t || C, n)) {
                                            r.push(o);
                                            break;
                                        }
                                    i && (k = h);
                                }
                                m && ((o = !s && o) && u--, e && c.push(o));
                            }
                            if (((u += l), m && l !== u)) {
                                a = 0;
                                while ((s = y[a++])) s(c, f, t, n);
                                if (e) {
                                    if (0 < u) while (l--) c[l] || f[l] || (f[l] = q.call(r));
                                    f = Te(f);
                                }
                                H.apply(r, f), i && !e && 0 < f.length && 1 < u + y.length && se.uniqueSort(r);
                            }
                            return i && ((k = h), (w = p)), c;
                        }),
                        m ? le(r) : r)
                    )).selector = e;
                }
                return a;
            }),
            (g = se.select = function (e, t, n, r) {
                var i,
                    o,
                    a,
                    s,
                    u,
                    l = "function" == typeof e && e,
                    c = !r && h((e = l.selector || e));
                if (((n = n || []), 1 === c.length)) {
                    if (2 < (o = c[0] = c[0].slice(0)).length && "ID" === (a = o[0]).type && 9 === t.nodeType && E && b.relative[o[1].type]) {
                        if (!(t = (b.find.ID(a.matches[0].replace(te, ne), t) || [])[0])) return n;
                        l && (t = t.parentNode), (e = e.slice(o.shift().value.length));
                    }
                    i = G.needsContext.test(e) ? 0 : o.length;
                    while (i--) {
                        if (((a = o[i]), b.relative[(s = a.type)])) break;
                        if ((u = b.find[s]) && (r = u(a.matches[0].replace(te, ne), (ee.test(o[0].type) && ye(t.parentNode)) || t))) {
                            if ((o.splice(i, 1), !(e = r.length && xe(o)))) return H.apply(n, r), n;
                            break;
                        }
                    }
                }
                return (l || f(e, c))(r, t, !E, n, !t || (ee.test(e) && ye(t.parentNode)) || t), n;
            }),
            (d.sortStable = S.split("").sort(D).join("") === S),
            (d.detectDuplicates = !!l),
            T(),
            (d.sortDetached = ce(function (e) {
                return 1 & e.compareDocumentPosition(C.createElement("fieldset"));
            })),
            ce(function (e) {
                return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
            }) ||
                fe("type|href|height|width", function (e, t, n) {
                    if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                }),
            (d.attributes &&
                ce(function (e) {
                    return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                })) ||
                fe("value", function (e, t, n) {
                    if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                }),
            ce(function (e) {
                return null == e.getAttribute("disabled");
            }) ||
                fe(R, function (e, t, n) {
                    var r;
                    if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
                }),
            se
        );
    })(C);
    (S.find = d),
        (S.expr = d.selectors),
        (S.expr[":"] = S.expr.pseudos),
        (S.uniqueSort = S.unique = d.uniqueSort),
        (S.text = d.getText),
        (S.isXMLDoc = d.isXML),
        (S.contains = d.contains),
        (S.escapeSelector = d.escape);
    var h = function (e, t, n) {
            var r = [],
                i = void 0 !== n;
            while ((e = e[t]) && 9 !== e.nodeType)
                if (1 === e.nodeType) {
                    if (i && S(e).is(n)) break;
                    r.push(e);
                }
            return r;
        },
        T = function (e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n;
        },
        k = S.expr.match.needsContext;
    function A(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }
    var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function D(e, n, r) {
        return m(n)
            ? S.grep(e, function (e, t) {
                  return !!n.call(e, t, e) !== r;
              })
            : n.nodeType
            ? S.grep(e, function (e) {
                  return (e === n) !== r;
              })
            : "string" != typeof n
            ? S.grep(e, function (e) {
                  return -1 < i.call(n, e) !== r;
              })
            : S.filter(n, e, r);
    }
    (S.filter = function (e, t, n) {
        var r = t[0];
        return (
            n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === r.nodeType
                ? S.find.matchesSelector(r, e)
                    ? [r]
                    : []
                : S.find.matches(
                      e,
                      S.grep(t, function (e) {
                          return 1 === e.nodeType;
                      })
                  )
        );
    }),
        S.fn.extend({
            find: function (e) {
                var t,
                    n,
                    r = this.length,
                    i = this;
                if ("string" != typeof e)
                    return this.pushStack(
                        S(e).filter(function () {
                            for (t = 0; t < r; t++) if (S.contains(i[t], this)) return !0;
                        })
                    );
                for (n = this.pushStack([]), t = 0; t < r; t++) S.find(e, i[t], n);
                return 1 < r ? S.uniqueSort(n) : n;
            },
            filter: function (e) {
                return this.pushStack(D(this, e || [], !1));
            },
            not: function (e) {
                return this.pushStack(D(this, e || [], !0));
            },
            is: function (e) {
                return !!D(this, "string" == typeof e && k.test(e) ? S(e) : e || [], !1).length;
            },
        });
    var j,
        q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((S.fn.init = function (e, t, n) {
        var r, i;
        if (!e) return this;
        if (((n = n || j), "string" == typeof e)) {
            if (!(r = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : q.exec(e)) || (!r[1] && t))
                return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (r[1]) {
                if (
                    ((t = t instanceof S ? t[0] : t),
                    S.merge(this, S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : E, !0)),
                    N.test(r[1]) && S.isPlainObject(t))
                )
                    for (r in t) m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                return this;
            }
            return (i = E.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this;
        }
        return e.nodeType ? ((this[0] = e), (this.length = 1), this) : m(e) ? (void 0 !== n.ready ? n.ready(e) : e(S)) : S.makeArray(e, this);
    }).prototype = S.fn),
        (j = S(E));
    var L = /^(?:parents|prev(?:Until|All))/,
        H = { children: !0, contents: !0, next: !0, prev: !0 };
    function O(e, t) {
        while ((e = e[t]) && 1 !== e.nodeType);
        return e;
    }
    S.fn.extend({
        has: function (e) {
            var t = S(e, this),
                n = t.length;
            return this.filter(function () {
                for (var e = 0; e < n; e++) if (S.contains(this, t[e])) return !0;
            });
        },
        closest: function (e, t) {
            var n,
                r = 0,
                i = this.length,
                o = [],
                a = "string" != typeof e && S(e);
            if (!k.test(e))
                for (; r < i; r++)
                    for (n = this[r]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (a ? -1 < a.index(n) : 1 === n.nodeType && S.find.matchesSelector(n, e))) {
                            o.push(n);
                            break;
                        }
            return this.pushStack(1 < o.length ? S.uniqueSort(o) : o);
        },
        index: function (e) {
            return e
                ? "string" == typeof e
                    ? i.call(S(e), this[0])
                    : i.call(this, e.jquery ? e[0] : e)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
        },
        add: function (e, t) {
            return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
        },
        addBack: function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        },
    }),
        S.each(
            {
                parent: function (e) {
                    var t = e.parentNode;
                    return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                    return h(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                    return h(e, "parentNode", n);
                },
                next: function (e) {
                    return O(e, "nextSibling");
                },
                prev: function (e) {
                    return O(e, "previousSibling");
                },
                nextAll: function (e) {
                    return h(e, "nextSibling");
                },
                prevAll: function (e) {
                    return h(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                    return h(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                    return h(e, "previousSibling", n);
                },
                siblings: function (e) {
                    return T((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                    return T(e.firstChild);
                },
                contents: function (e) {
                    return null != e.contentDocument && r(e.contentDocument)
                        ? e.contentDocument
                        : (A(e, "template") && (e = e.content || e), S.merge([], e.childNodes));
                },
            },
            function (r, i) {
                S.fn[r] = function (e, t) {
                    var n = S.map(this, i, e);
                    return (
                        "Until" !== r.slice(-5) && (t = e),
                        t && "string" == typeof t && (n = S.filter(t, n)),
                        1 < this.length && (H[r] || S.uniqueSort(n), L.test(r) && n.reverse()),
                        this.pushStack(n)
                    );
                };
            }
        );
    var P = /[^\x20\t\r\n\f]+/g;
    function R(e) {
        return e;
    }
    function M(e) {
        throw e;
    }
    function I(e, t, n, r) {
        var i;
        try {
            e && m((i = e.promise)) ? i.call(e).done(t).fail(n) : e && m((i = e.then)) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
        } catch (e) {
            n.apply(void 0, [e]);
        }
    }
    (S.Callbacks = function (r) {
        var e, n;
        r =
            "string" == typeof r
                ? ((e = r),
                  (n = {}),
                  S.each(e.match(P) || [], function (e, t) {
                      n[t] = !0;
                  }),
                  n)
                : S.extend({}, r);
        var i,
            t,
            o,
            a,
            s = [],
            u = [],
            l = -1,
            c = function () {
                for (a = a || r.once, o = i = !0; u.length; l = -1) {
                    t = u.shift();
                    while (++l < s.length) !1 === s[l].apply(t[0], t[1]) && r.stopOnFalse && ((l = s.length), (t = !1));
                }
                r.memory || (t = !1), (i = !1), a && (s = t ? [] : "");
            },
            f = {
                add: function () {
                    return (
                        s &&
                            (t && !i && ((l = s.length - 1), u.push(t)),
                            (function n(e) {
                                S.each(e, function (e, t) {
                                    m(t) ? (r.unique && f.has(t)) || s.push(t) : t && t.length && "string" !== w(t) && n(t);
                                });
                            })(arguments),
                            t && !i && c()),
                        this
                    );
                },
                remove: function () {
                    return (
                        S.each(arguments, function (e, t) {
                            var n;
                            while (-1 < (n = S.inArray(t, s, n))) s.splice(n, 1), n <= l && l--;
                        }),
                        this
                    );
                },
                has: function (e) {
                    return e ? -1 < S.inArray(e, s) : 0 < s.length;
                },
                empty: function () {
                    return s && (s = []), this;
                },
                disable: function () {
                    return (a = u = []), (s = t = ""), this;
                },
                disabled: function () {
                    return !s;
                },
                lock: function () {
                    return (a = u = []), t || i || (s = t = ""), this;
                },
                locked: function () {
                    return !!a;
                },
                fireWith: function (e, t) {
                    return a || ((t = [e, (t = t || []).slice ? t.slice() : t]), u.push(t), i || c()), this;
                },
                fire: function () {
                    return f.fireWith(this, arguments), this;
                },
                fired: function () {
                    return !!o;
                },
            };
        return f;
    }),
        S.extend({
            Deferred: function (e) {
                var o = [
                        ["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2],
                        ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"],
                    ],
                    i = "pending",
                    a = {
                        state: function () {
                            return i;
                        },
                        always: function () {
                            return s.done(arguments).fail(arguments), this;
                        },
                        catch: function (e) {
                            return a.then(null, e);
                        },
                        pipe: function () {
                            var i = arguments;
                            return S.Deferred(function (r) {
                                S.each(o, function (e, t) {
                                    var n = m(i[t[4]]) && i[t[4]];
                                    s[t[1]](function () {
                                        var e = n && n.apply(this, arguments);
                                        e && m(e.promise)
                                            ? e.promise().progress(r.notify).done(r.resolve).fail(r.reject)
                                            : r[t[0] + "With"](this, n ? [e] : arguments);
                                    });
                                }),
                                    (i = null);
                            }).promise();
                        },
                        then: function (t, n, r) {
                            var u = 0;
                            function l(i, o, a, s) {
                                return function () {
                                    var n = this,
                                        r = arguments,
                                        e = function () {
                                            var e, t;
                                            if (!(i < u)) {
                                                if ((e = a.apply(n, r)) === o.promise()) throw new TypeError("Thenable self-resolution");
                                                (t = e && ("object" == typeof e || "function" == typeof e) && e.then),
                                                    m(t)
                                                        ? s
                                                            ? t.call(e, l(u, o, R, s), l(u, o, M, s))
                                                            : (u++, t.call(e, l(u, o, R, s), l(u, o, M, s), l(u, o, R, o.notifyWith)))
                                                        : (a !== R && ((n = void 0), (r = [e])), (s || o.resolveWith)(n, r));
                                            }
                                        },
                                        t = s
                                            ? e
                                            : function () {
                                                  try {
                                                      e();
                                                  } catch (e) {
                                                      S.Deferred.exceptionHook && S.Deferred.exceptionHook(e, t.stackTrace),
                                                          u <= i + 1 && (a !== M && ((n = void 0), (r = [e])), o.rejectWith(n, r));
                                                  }
                                              };
                                    i ? t() : (S.Deferred.getStackHook && (t.stackTrace = S.Deferred.getStackHook()), C.setTimeout(t));
                                };
                            }
                            return S.Deferred(function (e) {
                                o[0][3].add(l(0, e, m(r) ? r : R, e.notifyWith)),
                                    o[1][3].add(l(0, e, m(t) ? t : R)),
                                    o[2][3].add(l(0, e, m(n) ? n : M));
                            }).promise();
                        },
                        promise: function (e) {
                            return null != e ? S.extend(e, a) : a;
                        },
                    },
                    s = {};
                return (
                    S.each(o, function (e, t) {
                        var n = t[2],
                            r = t[5];
                        (a[t[1]] = n.add),
                            r &&
                                n.add(
                                    function () {
                                        i = r;
                                    },
                                    o[3 - e][2].disable,
                                    o[3 - e][3].disable,
                                    o[0][2].lock,
                                    o[0][3].lock
                                ),
                            n.add(t[3].fire),
                            (s[t[0]] = function () {
                                return s[t[0] + "With"](this === s ? void 0 : this, arguments), this;
                            }),
                            (s[t[0] + "With"] = n.fireWith);
                    }),
                    a.promise(s),
                    e && e.call(s, s),
                    s
                );
            },
            when: function (e) {
                var n = arguments.length,
                    t = n,
                    r = Array(t),
                    i = s.call(arguments),
                    o = S.Deferred(),
                    a = function (t) {
                        return function (e) {
                            (r[t] = this), (i[t] = 1 < arguments.length ? s.call(arguments) : e), --n || o.resolveWith(r, i);
                        };
                    };
                if (n <= 1 && (I(e, o.done(a(t)).resolve, o.reject, !n), "pending" === o.state() || m(i[t] && i[t].then))) return o.then();
                while (t--) I(i[t], a(t), o.reject);
                return o.promise();
            },
        });
    var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (S.Deferred.exceptionHook = function (e, t) {
        C.console && C.console.warn && e && W.test(e.name) && C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
    }),
        (S.readyException = function (e) {
            C.setTimeout(function () {
                throw e;
            });
        });
    var F = S.Deferred();
    function B() {
        E.removeEventListener("DOMContentLoaded", B), C.removeEventListener("load", B), S.ready();
    }
    (S.fn.ready = function (e) {
        return (
            F.then(e)["catch"](function (e) {
                S.readyException(e);
            }),
            this
        );
    }),
        S.extend({
            isReady: !1,
            readyWait: 1,
            ready: function (e) {
                (!0 === e ? --S.readyWait : S.isReady) || ((S.isReady = !0) !== e && 0 < --S.readyWait) || F.resolveWith(E, [S]);
            },
        }),
        (S.ready.then = F.then),
        "complete" === E.readyState || ("loading" !== E.readyState && !E.documentElement.doScroll)
            ? C.setTimeout(S.ready)
            : (E.addEventListener("DOMContentLoaded", B), C.addEventListener("load", B));
    var $ = function (e, t, n, r, i, o, a) {
            var s = 0,
                u = e.length,
                l = null == n;
            if ("object" === w(n)) for (s in ((i = !0), n)) $(e, t, s, n[s], !0, o, a);
            else if (
                void 0 !== r &&
                ((i = !0),
                m(r) || (a = !0),
                l &&
                    (a
                        ? (t.call(e, r), (t = null))
                        : ((l = t),
                          (t = function (e, t, n) {
                              return l.call(S(e), n);
                          }))),
                t)
            )
                for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
            return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
        },
        _ = /^-ms-/,
        z = /-([a-z])/g;
    function U(e, t) {
        return t.toUpperCase();
    }
    function X(e) {
        return e.replace(_, "ms-").replace(z, U);
    }
    var V = function (e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };
    function G() {
        this.expando = S.expando + G.uid++;
    }
    (G.uid = 1),
        (G.prototype = {
            cache: function (e) {
                var t = e[this.expando];
                return (
                    t ||
                        ((t = {}),
                        V(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))),
                    t
                );
            },
            set: function (e, t, n) {
                var r,
                    i = this.cache(e);
                if ("string" == typeof t) i[X(t)] = n;
                else for (r in t) i[X(r)] = t[r];
                return i;
            },
            get: function (e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)];
            },
            access: function (e, t, n) {
                return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function (e, t) {
                var n,
                    r = e[this.expando];
                if (void 0 !== r) {
                    if (void 0 !== t) {
                        n = (t = Array.isArray(t) ? t.map(X) : (t = X(t)) in r ? [t] : t.match(P) || []).length;
                        while (n--) delete r[t[n]];
                    }
                    (void 0 === t || S.isEmptyObject(r)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
            },
            hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !S.isEmptyObject(t);
            },
        });
    var Y = new G(),
        Q = new G(),
        J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        K = /[A-Z]/g;
    function Z(e, t, n) {
        var r, i;
        if (void 0 === n && 1 === e.nodeType)
            if (((r = "data-" + t.replace(K, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(r)))) {
                try {
                    n = "true" === (i = n) || ("false" !== i && ("null" === i ? null : i === +i + "" ? +i : J.test(i) ? JSON.parse(i) : i));
                } catch (e) {}
                Q.set(e, t, n);
            } else n = void 0;
        return n;
    }
    S.extend({
        hasData: function (e) {
            return Q.hasData(e) || Y.hasData(e);
        },
        data: function (e, t, n) {
            return Q.access(e, t, n);
        },
        removeData: function (e, t) {
            Q.remove(e, t);
        },
        _data: function (e, t, n) {
            return Y.access(e, t, n);
        },
        _removeData: function (e, t) {
            Y.remove(e, t);
        },
    }),
        S.fn.extend({
            data: function (n, e) {
                var t,
                    r,
                    i,
                    o = this[0],
                    a = o && o.attributes;
                if (void 0 === n) {
                    if (this.length && ((i = Q.get(o)), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))) {
                        t = a.length;
                        while (t--) a[t] && 0 === (r = a[t].name).indexOf("data-") && ((r = X(r.slice(5))), Z(o, r, i[r]));
                        Y.set(o, "hasDataAttrs", !0);
                    }
                    return i;
                }
                return "object" == typeof n
                    ? this.each(function () {
                          Q.set(this, n);
                      })
                    : $(
                          this,
                          function (e) {
                              var t;
                              if (o && void 0 === e) return void 0 !== (t = Q.get(o, n)) ? t : void 0 !== (t = Z(o, n)) ? t : void 0;
                              this.each(function () {
                                  Q.set(this, n, e);
                              });
                          },
                          null,
                          e,
                          1 < arguments.length,
                          null,
                          !0
                      );
            },
            removeData: function (e) {
                return this.each(function () {
                    Q.remove(this, e);
                });
            },
        }),
        S.extend({
            queue: function (e, t, n) {
                var r;
                if (e)
                    return (
                        (t = (t || "fx") + "queue"),
                        (r = Y.get(e, t)),
                        n && (!r || Array.isArray(n) ? (r = Y.access(e, t, S.makeArray(n))) : r.push(n)),
                        r || []
                    );
            },
            dequeue: function (e, t) {
                t = t || "fx";
                var n = S.queue(e, t),
                    r = n.length,
                    i = n.shift(),
                    o = S._queueHooks(e, t);
                "inprogress" === i && ((i = n.shift()), r--),
                    i &&
                        ("fx" === t && n.unshift("inprogress"),
                        delete o.stop,
                        i.call(
                            e,
                            function () {
                                S.dequeue(e, t);
                            },
                            o
                        )),
                    !r && o && o.empty.fire();
            },
            _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                    Y.get(e, n) ||
                    Y.access(e, n, {
                        empty: S.Callbacks("once memory").add(function () {
                            Y.remove(e, [t + "queue", n]);
                        }),
                    })
                );
            },
        }),
        S.fn.extend({
            queue: function (t, n) {
                var e = 2;
                return (
                    "string" != typeof t && ((n = t), (t = "fx"), e--),
                    arguments.length < e
                        ? S.queue(this[0], t)
                        : void 0 === n
                        ? this
                        : this.each(function () {
                              var e = S.queue(this, t, n);
                              S._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t);
                          })
                );
            },
            dequeue: function (e) {
                return this.each(function () {
                    S.dequeue(this, e);
                });
            },
            clearQueue: function (e) {
                return this.queue(e || "fx", []);
            },
            promise: function (e, t) {
                var n,
                    r = 1,
                    i = S.Deferred(),
                    o = this,
                    a = this.length,
                    s = function () {
                        --r || i.resolveWith(o, [o]);
                    };
                "string" != typeof e && ((t = e), (e = void 0)), (e = e || "fx");
                while (a--) (n = Y.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
                return s(), i.promise(t);
            },
        });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
        ne = ["Top", "Right", "Bottom", "Left"],
        re = E.documentElement,
        ie = function (e) {
            return S.contains(e.ownerDocument, e);
        },
        oe = { composed: !0 };
    re.getRootNode &&
        (ie = function (e) {
            return S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument;
        });
    var ae = function (e, t) {
        return "none" === (e = t || e).style.display || ("" === e.style.display && ie(e) && "none" === S.css(e, "display"));
    };
    function se(e, t, n, r) {
        var i,
            o,
            a = 20,
            s = r
                ? function () {
                      return r.cur();
                  }
                : function () {
                      return S.css(e, t, "");
                  },
            u = s(),
            l = (n && n[3]) || (S.cssNumber[t] ? "" : "px"),
            c = e.nodeType && (S.cssNumber[t] || ("px" !== l && +u)) && te.exec(S.css(e, t));
        if (c && c[3] !== l) {
            (u /= 2), (l = l || c[3]), (c = +u || 1);
            while (a--) S.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0), (c /= o);
            (c *= 2), S.style(e, t, c + l), (n = n || []);
        }
        return n && ((c = +c || +u || 0), (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]), r && ((r.unit = l), (r.start = c), (r.end = i))), i;
    }
    var ue = {};
    function le(e, t) {
        for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++)
            (r = e[c]).style &&
                ((n = r.style.display),
                t
                    ? ("none" === n && ((l[c] = Y.get(r, "display") || null), l[c] || (r.style.display = "")),
                      "" === r.style.display &&
                          ae(r) &&
                          (l[c] =
                              ((u = a = o = void 0),
                              (a = (i = r).ownerDocument),
                              (s = i.nodeName),
                              (u = ue[s]) ||
                                  ((o = a.body.appendChild(a.createElement(s))),
                                  (u = S.css(o, "display")),
                                  o.parentNode.removeChild(o),
                                  "none" === u && (u = "block"),
                                  (ue[s] = u)))))
                    : "none" !== n && ((l[c] = "none"), Y.set(r, "display", n)));
        for (c = 0; c < f; c++) null != l[c] && (e[c].style.display = l[c]);
        return e;
    }
    S.fn.extend({
        show: function () {
            return le(this, !0);
        },
        hide: function () {
            return le(this);
        },
        toggle: function (e) {
            return "boolean" == typeof e
                ? e
                    ? this.show()
                    : this.hide()
                : this.each(function () {
                      ae(this) ? S(this).show() : S(this).hide();
                  });
        },
    });
    var ce,
        fe,
        pe = /^(?:checkbox|radio)$/i,
        de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        he = /^$|^module$|\/(?:java|ecma)script/i;
    (ce = E.createDocumentFragment().appendChild(E.createElement("div"))),
        (fe = E.createElement("input")).setAttribute("type", "radio"),
        fe.setAttribute("checked", "checked"),
        fe.setAttribute("name", "t"),
        ce.appendChild(fe),
        (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (ce.innerHTML = "<textarea>x</textarea>"),
        (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
        (ce.innerHTML = "<option></option>"),
        (y.option = !!ce.lastChild);
    var ge = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
    };
    function ve(e, t) {
        var n;
        return (
            (n =
                "undefined" != typeof e.getElementsByTagName
                    ? e.getElementsByTagName(t || "*")
                    : "undefined" != typeof e.querySelectorAll
                    ? e.querySelectorAll(t || "*")
                    : []),
            void 0 === t || (t && A(e, t)) ? S.merge([e], n) : n
        );
    }
    function ye(e, t) {
        for (var n = 0, r = e.length; n < r; n++) Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
    }
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
        (ge.th = ge.td),
        y.option || (ge.optgroup = ge.option = [1, "<select multiple='multiple'>", "</select>"]);
    var me = /<|&#?\w+;/;
    function xe(e, t, n, r, i) {
        for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++)
            if ((o = e[d]) || 0 === o)
                if ("object" === w(o)) S.merge(p, o.nodeType ? [o] : o);
                else if (me.test(o)) {
                    (a = a || f.appendChild(t.createElement("div"))),
                        (s = (de.exec(o) || ["", ""])[1].toLowerCase()),
                        (u = ge[s] || ge._default),
                        (a.innerHTML = u[1] + S.htmlPrefilter(o) + u[2]),
                        (c = u[0]);
                    while (c--) a = a.lastChild;
                    S.merge(p, a.childNodes), ((a = f.firstChild).textContent = "");
                } else p.push(t.createTextNode(o));
        (f.textContent = ""), (d = 0);
        while ((o = p[d++]))
            if (r && -1 < S.inArray(o, r)) i && i.push(o);
            else if (((l = ie(o)), (a = ve(f.appendChild(o), "script")), l && ye(a), n)) {
                c = 0;
                while ((o = a[c++])) he.test(o.type || "") && n.push(o);
            }
        return f;
    }
    var be = /^key/,
        we = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Te = /^([^.]*)(?:\.(.+)|)/;
    function Ce() {
        return !0;
    }
    function Ee() {
        return !1;
    }
    function Se(e, t) {
        return (
            (e ===
                (function () {
                    try {
                        return E.activeElement;
                    } catch (e) {}
                })()) ==
            ("focus" === t)
        );
    }
    function ke(e, t, n, r, i, o) {
        var a, s;
        if ("object" == typeof t) {
            for (s in ("string" != typeof n && ((r = r || n), (n = void 0)), t)) ke(e, s, n, r, t[s], o);
            return e;
        }
        if (
            (null == r && null == i
                ? ((i = n), (r = n = void 0))
                : null == i && ("string" == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))),
            !1 === i)
        )
            i = Ee;
        else if (!i) return e;
        return (
            1 === o &&
                ((a = i),
                ((i = function (e) {
                    return S().off(e), a.apply(this, arguments);
                }).guid = a.guid || (a.guid = S.guid++))),
            e.each(function () {
                S.event.add(this, t, i, r, n);
            })
        );
    }
    function Ae(e, i, o) {
        o
            ? (Y.set(e, i, !1),
              S.event.add(e, i, {
                  namespace: !1,
                  handler: function (e) {
                      var t,
                          n,
                          r = Y.get(this, i);
                      if (1 & e.isTrigger && this[i]) {
                          if (r.length) (S.event.special[i] || {}).delegateType && e.stopPropagation();
                          else if (
                              ((r = s.call(arguments)),
                              Y.set(this, i, r),
                              (t = o(this, i)),
                              this[i](),
                              r !== (n = Y.get(this, i)) || t ? Y.set(this, i, !1) : (n = {}),
                              r !== n)
                          )
                              return e.stopImmediatePropagation(), e.preventDefault(), n.value;
                      } else
                          r.length &&
                              (Y.set(this, i, { value: S.event.trigger(S.extend(r[0], S.Event.prototype), r.slice(1), this) }),
                              e.stopImmediatePropagation());
                  },
              }))
            : void 0 === Y.get(e, i) && S.event.add(e, i, Ce);
    }
    (S.event = {
        global: {},
        add: function (t, e, n, r, i) {
            var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = Y.get(t);
            if (V(t)) {
                n.handler && ((n = (o = n).handler), (i = o.selector)),
                    i && S.find.matchesSelector(re, i),
                    n.guid || (n.guid = S.guid++),
                    (u = v.events) || (u = v.events = Object.create(null)),
                    (a = v.handle) ||
                        (a = v.handle = function (e) {
                            return "undefined" != typeof S && S.event.triggered !== e.type ? S.event.dispatch.apply(t, arguments) : void 0;
                        }),
                    (l = (e = (e || "").match(P) || [""]).length);
                while (l--)
                    (d = g = (s = Te.exec(e[l]) || [])[1]),
                        (h = (s[2] || "").split(".").sort()),
                        d &&
                            ((f = S.event.special[d] || {}),
                            (d = (i ? f.delegateType : f.bindType) || d),
                            (f = S.event.special[d] || {}),
                            (c = S.extend(
                                {
                                    type: d,
                                    origType: g,
                                    data: r,
                                    handler: n,
                                    guid: n.guid,
                                    selector: i,
                                    needsContext: i && S.expr.match.needsContext.test(i),
                                    namespace: h.join("."),
                                },
                                o
                            )),
                            (p = u[d]) ||
                                (((p = u[d] = []).delegateCount = 0),
                                (f.setup && !1 !== f.setup.call(t, r, h, a)) || (t.addEventListener && t.addEventListener(d, a))),
                            f.add && (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)),
                            i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                            (S.event.global[d] = !0));
            }
        },
        remove: function (e, t, n, r, i) {
            var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = Y.hasData(e) && Y.get(e);
            if (v && (u = v.events)) {
                l = (t = (t || "").match(P) || [""]).length;
                while (l--)
                    if (((d = g = (s = Te.exec(t[l]) || [])[1]), (h = (s[2] || "").split(".").sort()), d)) {
                        (f = S.event.special[d] || {}),
                            (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
                            (s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")),
                            (a = o = p.length);
                        while (o--)
                            (c = p[o]),
                                (!i && g !== c.origType) ||
                                    (n && n.guid !== c.guid) ||
                                    (s && !s.test(c.namespace)) ||
                                    (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                                    (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
                        a && !p.length && ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) || S.removeEvent(e, d, v.handle), delete u[d]);
                    } else for (d in u) S.event.remove(e, d + t[l], n, r, !0);
                S.isEmptyObject(u) && Y.remove(e, "handle events");
            }
        },
        dispatch: function (e) {
            var t,
                n,
                r,
                i,
                o,
                a,
                s = new Array(arguments.length),
                u = S.event.fix(e),
                l = (Y.get(this, "events") || Object.create(null))[u.type] || [],
                c = S.event.special[u.type] || {};
            for (s[0] = u, t = 1; t < arguments.length; t++) s[t] = arguments[t];
            if (((u.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, u))) {
                (a = S.event.handlers.call(this, u, l)), (t = 0);
                while ((i = a[t++]) && !u.isPropagationStopped()) {
                    (u.currentTarget = i.elem), (n = 0);
                    while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped())
                        (u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace)) ||
                            ((u.handleObj = o),
                            (u.data = o.data),
                            void 0 !== (r = ((S.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) &&
                                !1 === (u.result = r) &&
                                (u.preventDefault(), u.stopPropagation()));
                }
                return c.postDispatch && c.postDispatch.call(this, u), u.result;
            }
        },
        handlers: function (e, t) {
            var n,
                r,
                i,
                o,
                a,
                s = [],
                u = t.delegateCount,
                l = e.target;
            if (u && l.nodeType && !("click" === e.type && 1 <= e.button))
                for (; l !== this; l = l.parentNode || this)
                    if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                        for (o = [], a = {}, n = 0; n < u; n++)
                            void 0 === a[(i = (r = t[n]).selector + " ")] &&
                                (a[i] = r.needsContext ? -1 < S(i, this).index(l) : S.find(i, this, null, [l]).length),
                                a[i] && o.push(r);
                        o.length && s.push({ elem: l, handlers: o });
                    }
            return (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s;
        },
        addProp: function (t, e) {
            Object.defineProperty(S.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: m(e)
                    ? function () {
                          if (this.originalEvent) return e(this.originalEvent);
                      }
                    : function () {
                          if (this.originalEvent) return this.originalEvent[t];
                      },
                set: function (e) {
                    Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e });
                },
            });
        },
        fix: function (e) {
            return e[S.expando] ? e : new S.Event(e);
        },
        special: {
            load: { noBubble: !0 },
            click: {
                setup: function (e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && A(t, "input") && Ae(t, "click", Ce), !1;
                },
                trigger: function (e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && A(t, "input") && Ae(t, "click"), !0;
                },
                _default: function (e) {
                    var t = e.target;
                    return (pe.test(t.type) && t.click && A(t, "input") && Y.get(t, "click")) || A(t, "a");
                },
            },
            beforeunload: {
                postDispatch: function (e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
            },
        },
    }),
        (S.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
        }),
        (S.Event = function (e, t) {
            if (!(this instanceof S.Event)) return new S.Event(e, t);
            e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? Ce : Ee),
                  (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && S.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[S.expando] = !0);
        }),
        (S.Event.prototype = {
            constructor: S.Event,
            isDefaultPrevented: Ee,
            isPropagationStopped: Ee,
            isImmediatePropagationStopped: Ee,
            isSimulated: !1,
            preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = Ce), e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = Ce), e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = Ce), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
            },
        }),
        S.each(
            {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function (e) {
                    var t = e.button;
                    return null == e.which && be.test(e.type)
                        ? null != e.charCode
                            ? e.charCode
                            : e.keyCode
                        : !e.which && void 0 !== t && we.test(e.type)
                        ? 1 & t
                            ? 1
                            : 2 & t
                            ? 3
                            : 4 & t
                            ? 2
                            : 0
                        : e.which;
                },
            },
            S.event.addProp
        ),
        S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            S.event.special[e] = {
                setup: function () {
                    return Ae(this, e, Se), !1;
                },
                trigger: function () {
                    return Ae(this, e), !0;
                },
                delegateType: t,
            };
        }),
        S.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, i) {
            S.event.special[e] = {
                delegateType: i,
                bindType: i,
                handle: function (e) {
                    var t,
                        n = e.relatedTarget,
                        r = e.handleObj;
                    return (
                        (n && (n === this || S.contains(this, n))) || ((e.type = r.origType), (t = r.handler.apply(this, arguments)), (e.type = i)), t
                    );
                },
            };
        }),
        S.fn.extend({
            on: function (e, t, n, r) {
                return ke(this, e, t, n, r);
            },
            one: function (e, t, n, r) {
                return ke(this, e, t, n, r, 1);
            },
            off: function (e, t, n) {
                var r, i;
                if (e && e.preventDefault && e.handleObj)
                    return (
                        (r = e.handleObj),
                        S(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler),
                        this
                    );
                if ("object" == typeof e) {
                    for (i in e) this.off(i, t, e[i]);
                    return this;
                }
                return (
                    (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                    !1 === n && (n = Ee),
                    this.each(function () {
                        S.event.remove(this, e, n, t);
                    })
                );
            },
        });
    var Ne = /<script|<style|<link/i,
        De = /checked\s*(?:[^=]|=\s*.checked.)/i,
        je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function qe(e, t) {
        return (A(e, "table") && A(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0]) || e;
    }
    function Le(e) {
        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function He(e) {
        return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
    }
    function Oe(e, t) {
        var n, r, i, o, a, s;
        if (1 === t.nodeType) {
            if (Y.hasData(e) && (s = Y.get(e).events))
                for (i in (Y.remove(t, "handle events"), s)) for (n = 0, r = s[i].length; n < r; n++) S.event.add(t, i, s[i][n]);
            Q.hasData(e) && ((o = Q.access(e)), (a = S.extend({}, o)), Q.set(t, a));
        }
    }
    function Pe(n, r, i, o) {
        r = g(r);
        var e,
            t,
            a,
            s,
            u,
            l,
            c = 0,
            f = n.length,
            p = f - 1,
            d = r[0],
            h = m(d);
        if (h || (1 < f && "string" == typeof d && !y.checkClone && De.test(d)))
            return n.each(function (e) {
                var t = n.eq(e);
                h && (r[0] = d.call(this, e, t.html())), Pe(t, r, i, o);
            });
        if (f && ((t = (e = xe(r, n[0].ownerDocument, !1, n, o)).firstChild), 1 === e.childNodes.length && (e = t), t || o)) {
            for (s = (a = S.map(ve(e, "script"), Le)).length; c < f; c++)
                (u = e), c !== p && ((u = S.clone(u, !0, !0)), s && S.merge(a, ve(u, "script"))), i.call(n[c], u, c);
            if (s)
                for (l = a[a.length - 1].ownerDocument, S.map(a, He), c = 0; c < s; c++)
                    (u = a[c]),
                        he.test(u.type || "") &&
                            !Y.access(u, "globalEval") &&
                            S.contains(l, u) &&
                            (u.src && "module" !== (u.type || "").toLowerCase()
                                ? S._evalUrl && !u.noModule && S._evalUrl(u.src, { nonce: u.nonce || u.getAttribute("nonce") }, l)
                                : b(u.textContent.replace(je, ""), u, l));
        }
        return n;
    }
    function Re(e, t, n) {
        for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
            n || 1 !== r.nodeType || S.cleanData(ve(r)), r.parentNode && (n && ie(r) && ye(ve(r, "script")), r.parentNode.removeChild(r));
        return e;
    }
    S.extend({
        htmlPrefilter: function (e) {
            return e;
        },
        clone: function (e, t, n) {
            var r,
                i,
                o,
                a,
                s,
                u,
                l,
                c = e.cloneNode(!0),
                f = ie(e);
            if (!(y.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || S.isXMLDoc(e)))
                for (a = ve(c), r = 0, i = (o = ve(e)).length; r < i; r++)
                    (s = o[r]),
                        (u = a[r]),
                        void 0,
                        "input" === (l = u.nodeName.toLowerCase()) && pe.test(s.type)
                            ? (u.checked = s.checked)
                            : ("input" !== l && "textarea" !== l) || (u.defaultValue = s.defaultValue);
            if (t)
                if (n) for (o = o || ve(e), a = a || ve(c), r = 0, i = o.length; r < i; r++) Oe(o[r], a[r]);
                else Oe(e, c);
            return 0 < (a = ve(c, "script")).length && ye(a, !f && ve(e, "script")), c;
        },
        cleanData: function (e) {
            for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (V(n)) {
                    if ((t = n[Y.expando])) {
                        if (t.events) for (r in t.events) i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle);
                        n[Y.expando] = void 0;
                    }
                    n[Q.expando] && (n[Q.expando] = void 0);
                }
        },
    }),
        S.fn.extend({
            detach: function (e) {
                return Re(this, e, !0);
            },
            remove: function (e) {
                return Re(this, e);
            },
            text: function (e) {
                return $(
                    this,
                    function (e) {
                        return void 0 === e
                            ? S.text(this)
                            : this.empty().each(function () {
                                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                              });
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            append: function () {
                return Pe(this, arguments, function (e) {
                    (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || qe(this, e).appendChild(e);
                });
            },
            prepend: function () {
                return Pe(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = qe(this, e);
                        t.insertBefore(e, t.firstChild);
                    }
                });
            },
            before: function () {
                return Pe(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                });
            },
            after: function () {
                return Pe(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
            },
            empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (S.cleanData(ve(e, !1)), (e.textContent = ""));
                return this;
            },
            clone: function (e, t) {
                return (
                    (e = null != e && e),
                    (t = null == t ? e : t),
                    this.map(function () {
                        return S.clone(this, e, t);
                    })
                );
            },
            html: function (e) {
                return $(
                    this,
                    function (e) {
                        var t = this[0] || {},
                            n = 0,
                            r = this.length;
                        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                        if ("string" == typeof e && !Ne.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) {
                            e = S.htmlPrefilter(e);
                            try {
                                for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (S.cleanData(ve(t, !1)), (t.innerHTML = e));
                                t = 0;
                            } catch (e) {}
                        }
                        t && this.empty().append(e);
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            replaceWith: function () {
                var n = [];
                return Pe(
                    this,
                    arguments,
                    function (e) {
                        var t = this.parentNode;
                        S.inArray(this, n) < 0 && (S.cleanData(ve(this)), t && t.replaceChild(e, this));
                    },
                    n
                );
            },
        }),
        S.each(
            { appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" },
            function (e, a) {
                S.fn[e] = function (e) {
                    for (var t, n = [], r = S(e), i = r.length - 1, o = 0; o <= i; o++)
                        (t = o === i ? this : this.clone(!0)), S(r[o])[a](t), u.apply(n, t.get());
                    return this.pushStack(n);
                };
            }
        );
    var Me = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
        Ie = function (e) {
            var t = e.ownerDocument.defaultView;
            return (t && t.opener) || (t = C), t.getComputedStyle(e);
        },
        We = function (e, t, n) {
            var r,
                i,
                o = {};
            for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
            for (i in ((r = n.call(e)), t)) e.style[i] = o[i];
            return r;
        },
        Fe = new RegExp(ne.join("|"), "i");
    function Be(e, t, n) {
        var r,
            i,
            o,
            a,
            s = e.style;
        return (
            (n = n || Ie(e)) &&
                ("" !== (a = n.getPropertyValue(t) || n[t]) || ie(e) || (a = S.style(e, t)),
                !y.pixelBoxStyles() &&
                    Me.test(a) &&
                    Fe.test(t) &&
                    ((r = s.width),
                    (i = s.minWidth),
                    (o = s.maxWidth),
                    (s.minWidth = s.maxWidth = s.width = a),
                    (a = n.width),
                    (s.width = r),
                    (s.minWidth = i),
                    (s.maxWidth = o))),
            void 0 !== a ? a + "" : a
        );
    }
    function $e(e, t) {
        return {
            get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
            },
        };
    }
    !(function () {
        function e() {
            if (l) {
                (u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                    (l.style.cssText =
                        "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                    re.appendChild(u).appendChild(l);
                var e = C.getComputedStyle(l);
                (n = "1%" !== e.top),
                    (s = 12 === t(e.marginLeft)),
                    (l.style.right = "60%"),
                    (o = 36 === t(e.right)),
                    (r = 36 === t(e.width)),
                    (l.style.position = "absolute"),
                    (i = 12 === t(l.offsetWidth / 3)),
                    re.removeChild(u),
                    (l = null);
            }
        }
        function t(e) {
            return Math.round(parseFloat(e));
        }
        var n,
            r,
            i,
            o,
            a,
            s,
            u = E.createElement("div"),
            l = E.createElement("div");
        l.style &&
            ((l.style.backgroundClip = "content-box"),
            (l.cloneNode(!0).style.backgroundClip = ""),
            (y.clearCloneStyle = "content-box" === l.style.backgroundClip),
            S.extend(y, {
                boxSizingReliable: function () {
                    return e(), r;
                },
                pixelBoxStyles: function () {
                    return e(), o;
                },
                pixelPosition: function () {
                    return e(), n;
                },
                reliableMarginLeft: function () {
                    return e(), s;
                },
                scrollboxSize: function () {
                    return e(), i;
                },
                reliableTrDimensions: function () {
                    var e, t, n, r;
                    return (
                        null == a &&
                            ((e = E.createElement("table")),
                            (t = E.createElement("tr")),
                            (n = E.createElement("div")),
                            (e.style.cssText = "position:absolute;left:-11111px"),
                            (t.style.height = "1px"),
                            (n.style.height = "9px"),
                            re.appendChild(e).appendChild(t).appendChild(n),
                            (r = C.getComputedStyle(t)),
                            (a = 3 < parseInt(r.height)),
                            re.removeChild(e)),
                        a
                    );
                },
            }));
    })();
    var _e = ["Webkit", "Moz", "ms"],
        ze = E.createElement("div").style,
        Ue = {};
    function Xe(e) {
        var t = S.cssProps[e] || Ue[e];
        return (
            t ||
            (e in ze
                ? e
                : (Ue[e] =
                      (function (e) {
                          var t = e[0].toUpperCase() + e.slice(1),
                              n = _e.length;
                          while (n--) if ((e = _e[n] + t) in ze) return e;
                      })(e) || e))
        );
    }
    var Ve = /^(none|table(?!-c[ea]).+)/,
        Ge = /^--/,
        Ye = { position: "absolute", visibility: "hidden", display: "block" },
        Qe = { letterSpacing: "0", fontWeight: "400" };
    function Je(e, t, n) {
        var r = te.exec(t);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
    }
    function Ke(e, t, n, r, i, o) {
        var a = "width" === t ? 1 : 0,
            s = 0,
            u = 0;
        if (n === (r ? "border" : "content")) return 0;
        for (; a < 4; a += 2)
            "margin" === n && (u += S.css(e, n + ne[a], !0, i)),
                r
                    ? ("content" === n && (u -= S.css(e, "padding" + ne[a], !0, i)),
                      "margin" !== n && (u -= S.css(e, "border" + ne[a] + "Width", !0, i)))
                    : ((u += S.css(e, "padding" + ne[a], !0, i)),
                      "padding" !== n ? (u += S.css(e, "border" + ne[a] + "Width", !0, i)) : (s += S.css(e, "border" + ne[a] + "Width", !0, i)));
        return !r && 0 <= o && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5)) || 0), u;
    }
    function Ze(e, t, n) {
        var r = Ie(e),
            i = (!y.boxSizingReliable() || n) && "border-box" === S.css(e, "boxSizing", !1, r),
            o = i,
            a = Be(e, t, r),
            s = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Me.test(a)) {
            if (!n) return a;
            a = "auto";
        }
        return (
            ((!y.boxSizingReliable() && i) ||
                (!y.reliableTrDimensions() && A(e, "tr")) ||
                "auto" === a ||
                (!parseFloat(a) && "inline" === S.css(e, "display", !1, r))) &&
                e.getClientRects().length &&
                ((i = "border-box" === S.css(e, "boxSizing", !1, r)), (o = s in e) && (a = e[s])),
            (a = parseFloat(a) || 0) + Ke(e, t, n || (i ? "border" : "content"), o, r, a) + "px"
        );
    }
    function et(e, t, n, r, i) {
        return new et.prototype.init(e, t, n, r, i);
    }
    S.extend({
        cssHooks: {
            opacity: {
                get: function (e, t) {
                    if (t) {
                        var n = Be(e, "opacity");
                        return "" === n ? "1" : n;
                    }
                },
            },
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
        },
        cssProps: {},
        style: function (e, t, n, r) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i,
                    o,
                    a,
                    s = X(t),
                    u = Ge.test(t),
                    l = e.style;
                if ((u || (t = Xe(s)), (a = S.cssHooks[t] || S.cssHooks[s]), void 0 === n))
                    return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
                "string" === (o = typeof n) && (i = te.exec(n)) && i[1] && ((n = se(e, t, i)), (o = "number")),
                    null != n &&
                        n == n &&
                        ("number" !== o || u || (n += (i && i[3]) || (S.cssNumber[s] ? "" : "px")),
                        y.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                        (a && "set" in a && void 0 === (n = a.set(e, n, r))) || (u ? l.setProperty(t, n) : (l[t] = n)));
            }
        },
        css: function (e, t, n, r) {
            var i,
                o,
                a,
                s = X(t);
            return (
                Ge.test(t) || (t = Xe(s)),
                (a = S.cssHooks[t] || S.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)),
                void 0 === i && (i = Be(e, t, r)),
                "normal" === i && t in Qe && (i = Qe[t]),
                "" === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
            );
        },
    }),
        S.each(["height", "width"], function (e, u) {
            S.cssHooks[u] = {
                get: function (e, t, n) {
                    if (t)
                        return !Ve.test(S.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                            ? Ze(e, u, n)
                            : We(e, Ye, function () {
                                  return Ze(e, u, n);
                              });
                },
                set: function (e, t, n) {
                    var r,
                        i = Ie(e),
                        o = !y.scrollboxSize() && "absolute" === i.position,
                        a = (o || n) && "border-box" === S.css(e, "boxSizing", !1, i),
                        s = n ? Ke(e, u, n, a, i) : 0;
                    return (
                        a &&
                            o &&
                            (s -= Math.ceil(e["offset" + u[0].toUpperCase() + u.slice(1)] - parseFloat(i[u]) - Ke(e, u, "border", !1, i) - 0.5)),
                        s && (r = te.exec(t)) && "px" !== (r[3] || "px") && ((e.style[u] = t), (t = S.css(e, u))),
                        Je(0, t, s)
                    );
                },
            };
        }),
        (S.cssHooks.marginLeft = $e(y.reliableMarginLeft, function (e, t) {
            if (t)
                return (
                    (parseFloat(Be(e, "marginLeft")) ||
                        e.getBoundingClientRect().left -
                            We(e, { marginLeft: 0 }, function () {
                                return e.getBoundingClientRect().left;
                            })) + "px"
                );
        })),
        S.each({ margin: "", padding: "", border: "Width" }, function (i, o) {
            (S.cssHooks[i + o] = {
                expand: function (e) {
                    for (var t = 0, n = {}, r = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++) n[i + ne[t] + o] = r[t] || r[t - 2] || r[0];
                    return n;
                },
            }),
                "margin" !== i && (S.cssHooks[i + o].set = Je);
        }),
        S.fn.extend({
            css: function (e, t) {
                return $(
                    this,
                    function (e, t, n) {
                        var r,
                            i,
                            o = {},
                            a = 0;
                        if (Array.isArray(t)) {
                            for (r = Ie(e), i = t.length; a < i; a++) o[t[a]] = S.css(e, t[a], !1, r);
                            return o;
                        }
                        return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
                    },
                    e,
                    t,
                    1 < arguments.length
                );
            },
        }),
        (((S.Tween = et).prototype = {
            constructor: et,
            init: function (e, t, n, r, i, o) {
                (this.elem = e),
                    (this.prop = n),
                    (this.easing = i || S.easing._default),
                    (this.options = t),
                    (this.start = this.now = this.cur()),
                    (this.end = r),
                    (this.unit = o || (S.cssNumber[n] ? "" : "px"));
            },
            cur: function () {
                var e = et.propHooks[this.prop];
                return e && e.get ? e.get(this) : et.propHooks._default.get(this);
            },
            run: function (e) {
                var t,
                    n = et.propHooks[this.prop];
                return (
                    this.options.duration
                        ? (this.pos = t = S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
                        : (this.pos = t = e),
                    (this.now = (this.end - this.start) * t + this.start),
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    n && n.set ? n.set(this) : et.propHooks._default.set(this),
                    this
                );
            },
        }).init.prototype = et.prototype),
        ((et.propHooks = {
            _default: {
                get: function (e) {
                    var t;
                    return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                        ? e.elem[e.prop]
                        : (t = S.css(e.elem, e.prop, "")) && "auto" !== t
                        ? t
                        : 0;
                },
                set: function (e) {
                    S.fx.step[e.prop]
                        ? S.fx.step[e.prop](e)
                        : 1 !== e.elem.nodeType || (!S.cssHooks[e.prop] && null == e.elem.style[Xe(e.prop)])
                        ? (e.elem[e.prop] = e.now)
                        : S.style(e.elem, e.prop, e.now + e.unit);
                },
            },
        }).scrollTop = et.propHooks.scrollLeft = {
            set: function (e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            },
        }),
        (S.easing = {
            linear: function (e) {
                return e;
            },
            swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing",
        }),
        (S.fx = et.prototype.init),
        (S.fx.step = {});
    var tt,
        nt,
        rt,
        it,
        ot = /^(?:toggle|show|hide)$/,
        at = /queueHooks$/;
    function st() {
        nt && (!1 === E.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(st) : C.setTimeout(st, S.fx.interval), S.fx.tick());
    }
    function ut() {
        return (
            C.setTimeout(function () {
                tt = void 0;
            }),
            (tt = Date.now())
        );
    }
    function lt(e, t) {
        var n,
            r = 0,
            i = { height: e };
        for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = ne[r])] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e), i;
    }
    function ct(e, t, n) {
        for (var r, i = (ft.tweeners[t] || []).concat(ft.tweeners["*"]), o = 0, a = i.length; o < a; o++) if ((r = i[o].call(n, t, e))) return r;
    }
    function ft(o, e, t) {
        var n,
            a,
            r = 0,
            i = ft.prefilters.length,
            s = S.Deferred().always(function () {
                delete u.elem;
            }),
            u = function () {
                if (a) return !1;
                for (
                    var e = tt || ut(), t = Math.max(0, l.startTime + l.duration - e), n = 1 - (t / l.duration || 0), r = 0, i = l.tweens.length;
                    r < i;
                    r++
                )
                    l.tweens[r].run(n);
                return s.notifyWith(o, [l, n, t]), n < 1 && i ? t : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1);
            },
            l = s.promise({
                elem: o,
                props: S.extend({}, e),
                opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, t),
                originalProperties: e,
                originalOptions: t,
                startTime: tt || ut(),
                duration: t.duration,
                tweens: [],
                createTween: function (e, t) {
                    var n = S.Tween(o, l.opts, e, t, l.opts.specialEasing[e] || l.opts.easing);
                    return l.tweens.push(n), n;
                },
                stop: function (e) {
                    var t = 0,
                        n = e ? l.tweens.length : 0;
                    if (a) return this;
                    for (a = !0; t < n; t++) l.tweens[t].run(1);
                    return e ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e])) : s.rejectWith(o, [l, e]), this;
                },
            }),
            c = l.props;
        for (
            !(function (e, t) {
                var n, r, i, o, a;
                for (n in e)
                    if (
                        ((i = t[(r = X(n))]),
                        (o = e[n]),
                        Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
                        n !== r && ((e[r] = o), delete e[n]),
                        (a = S.cssHooks[r]) && ("expand" in a))
                    )
                        for (n in ((o = a.expand(o)), delete e[r], o)) (n in e) || ((e[n] = o[n]), (t[n] = i));
                    else t[r] = i;
            })(c, l.opts.specialEasing);
            r < i;
            r++
        )
            if ((n = ft.prefilters[r].call(l, o, c, l.opts))) return m(n.stop) && (S._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)), n;
        return (
            S.map(c, ct, l),
            m(l.opts.start) && l.opts.start.call(o, l),
            l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always),
            S.fx.timer(S.extend(u, { elem: o, anim: l, queue: l.opts.queue })),
            l
        );
    }
    (S.Animation = S.extend(ft, {
        tweeners: {
            "*": [
                function (e, t) {
                    var n = this.createTween(e, t);
                    return se(n.elem, e, te.exec(t), n), n;
                },
            ],
        },
        tweener: function (e, t) {
            m(e) ? ((t = e), (e = ["*"])) : (e = e.match(P));
            for (var n, r = 0, i = e.length; r < i; r++) (n = e[r]), (ft.tweeners[n] = ft.tweeners[n] || []), ft.tweeners[n].unshift(t);
        },
        prefilters: [
            function (e, t, n) {
                var r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l,
                    c,
                    f = "width" in t || "height" in t,
                    p = this,
                    d = {},
                    h = e.style,
                    g = e.nodeType && ae(e),
                    v = Y.get(e, "fxshow");
                for (r in (n.queue ||
                    (null == (a = S._queueHooks(e, "fx")).unqueued &&
                        ((a.unqueued = 0),
                        (s = a.empty.fire),
                        (a.empty.fire = function () {
                            a.unqueued || s();
                        })),
                    a.unqueued++,
                    p.always(function () {
                        p.always(function () {
                            a.unqueued--, S.queue(e, "fx").length || a.empty.fire();
                        });
                    })),
                t))
                    if (((i = t[r]), ot.test(i))) {
                        if ((delete t[r], (o = o || "toggle" === i), i === (g ? "hide" : "show"))) {
                            if ("show" !== i || !v || void 0 === v[r]) continue;
                            g = !0;
                        }
                        d[r] = (v && v[r]) || S.style(e, r);
                    }
                if ((u = !S.isEmptyObject(t)) || !S.isEmptyObject(d))
                    for (r in (f &&
                        1 === e.nodeType &&
                        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                        null == (l = v && v.display) && (l = Y.get(e, "display")),
                        "none" === (c = S.css(e, "display")) &&
                            (l ? (c = l) : (le([e], !0), (l = e.style.display || l), (c = S.css(e, "display")), le([e]))),
                        ("inline" === c || ("inline-block" === c && null != l)) &&
                            "none" === S.css(e, "float") &&
                            (u ||
                                (p.done(function () {
                                    h.display = l;
                                }),
                                null == l && ((c = h.display), (l = "none" === c ? "" : c))),
                            (h.display = "inline-block"))),
                    n.overflow &&
                        ((h.overflow = "hidden"),
                        p.always(function () {
                            (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                        })),
                    (u = !1),
                    d))
                        u ||
                            (v ? "hidden" in v && (g = v.hidden) : (v = Y.access(e, "fxshow", { display: l })),
                            o && (v.hidden = !g),
                            g && le([e], !0),
                            p.done(function () {
                                for (r in (g || le([e]), Y.remove(e, "fxshow"), d)) S.style(e, r, d[r]);
                            })),
                            (u = ct(g ? v[r] : 0, r, p)),
                            r in v || ((v[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
            },
        ],
        prefilter: function (e, t) {
            t ? ft.prefilters.unshift(e) : ft.prefilters.push(e);
        },
    })),
        (S.speed = function (e, t, n) {
            var r =
                e && "object" == typeof e
                    ? S.extend({}, e)
                    : { complete: n || (!n && t) || (m(e) && e), duration: e, easing: (n && t) || (t && !m(t) && t) };
            return (
                S.fx.off
                    ? (r.duration = 0)
                    : "number" != typeof r.duration &&
                      (r.duration in S.fx.speeds ? (r.duration = S.fx.speeds[r.duration]) : (r.duration = S.fx.speeds._default)),
                (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
                (r.old = r.complete),
                (r.complete = function () {
                    m(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue);
                }),
                r
            );
        }),
        S.fn.extend({
            fadeTo: function (e, t, n, r) {
                return this.filter(ae).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
            },
            animate: function (t, e, n, r) {
                var i = S.isEmptyObject(t),
                    o = S.speed(e, n, r),
                    a = function () {
                        var e = ft(this, S.extend({}, t), o);
                        (i || Y.get(this, "finish")) && e.stop(!0);
                    };
                return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
            },
            stop: function (i, e, o) {
                var a = function (e) {
                    var t = e.stop;
                    delete e.stop, t(o);
                };
                return (
                    "string" != typeof i && ((o = e), (e = i), (i = void 0)),
                    e && this.queue(i || "fx", []),
                    this.each(function () {
                        var e = !0,
                            t = null != i && i + "queueHooks",
                            n = S.timers,
                            r = Y.get(this);
                        if (t) r[t] && r[t].stop && a(r[t]);
                        else for (t in r) r[t] && r[t].stop && at.test(t) && a(r[t]);
                        for (t = n.length; t--; )
                            n[t].elem !== this || (null != i && n[t].queue !== i) || (n[t].anim.stop(o), (e = !1), n.splice(t, 1));
                        (!e && o) || S.dequeue(this, i);
                    })
                );
            },
            finish: function (a) {
                return (
                    !1 !== a && (a = a || "fx"),
                    this.each(function () {
                        var e,
                            t = Y.get(this),
                            n = t[a + "queue"],
                            r = t[a + "queueHooks"],
                            i = S.timers,
                            o = n ? n.length : 0;
                        for (t.finish = !0, S.queue(this, a, []), r && r.stop && r.stop.call(this, !0), e = i.length; e--; )
                            i[e].elem === this && i[e].queue === a && (i[e].anim.stop(!0), i.splice(e, 1));
                        for (e = 0; e < o; e++) n[e] && n[e].finish && n[e].finish.call(this);
                        delete t.finish;
                    })
                );
            },
        }),
        S.each(["toggle", "show", "hide"], function (e, r) {
            var i = S.fn[r];
            S.fn[r] = function (e, t, n) {
                return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(lt(r, !0), e, t, n);
            };
        }),
        S.each(
            {
                slideDown: lt("show"),
                slideUp: lt("hide"),
                slideToggle: lt("toggle"),
                fadeIn: { opacity: "show" },
                fadeOut: { opacity: "hide" },
                fadeToggle: { opacity: "toggle" },
            },
            function (e, r) {
                S.fn[e] = function (e, t, n) {
                    return this.animate(r, e, t, n);
                };
            }
        ),
        (S.timers = []),
        (S.fx.tick = function () {
            var e,
                t = 0,
                n = S.timers;
            for (tt = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || S.fx.stop(), (tt = void 0);
        }),
        (S.fx.timer = function (e) {
            S.timers.push(e), S.fx.start();
        }),
        (S.fx.interval = 13),
        (S.fx.start = function () {
            nt || ((nt = !0), st());
        }),
        (S.fx.stop = function () {
            nt = null;
        }),
        (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (S.fn.delay = function (r, e) {
            return (
                (r = (S.fx && S.fx.speeds[r]) || r),
                (e = e || "fx"),
                this.queue(e, function (e, t) {
                    var n = C.setTimeout(e, r);
                    t.stop = function () {
                        C.clearTimeout(n);
                    };
                })
            );
        }),
        (rt = E.createElement("input")),
        (it = E.createElement("select").appendChild(E.createElement("option"))),
        (rt.type = "checkbox"),
        (y.checkOn = "" !== rt.value),
        (y.optSelected = it.selected),
        ((rt = E.createElement("input")).value = "t"),
        (rt.type = "radio"),
        (y.radioValue = "t" === rt.value);
    var pt,
        dt = S.expr.attrHandle;
    S.fn.extend({
        attr: function (e, t) {
            return $(this, S.attr, e, t, 1 < arguments.length);
        },
        removeAttr: function (e) {
            return this.each(function () {
                S.removeAttr(this, e);
            });
        },
    }),
        S.extend({
            attr: function (e, t, n) {
                var r,
                    i,
                    o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return "undefined" == typeof e.getAttribute
                        ? S.prop(e, t, n)
                        : ((1 === o && S.isXMLDoc(e)) || (i = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? pt : void 0)),
                          void 0 !== n
                              ? null === n
                                  ? void S.removeAttr(e, t)
                                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                                  ? r
                                  : (e.setAttribute(t, n + ""), n)
                              : i && "get" in i && null !== (r = i.get(e, t))
                              ? r
                              : null == (r = S.find.attr(e, t))
                              ? void 0
                              : r);
            },
            attrHooks: {
                type: {
                    set: function (e, t) {
                        if (!y.radioValue && "radio" === t && A(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    },
                },
            },
            removeAttr: function (e, t) {
                var n,
                    r = 0,
                    i = t && t.match(P);
                if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
            },
        }),
        (pt = {
            set: function (e, t, n) {
                return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
            },
        }),
        S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var a = dt[t] || S.find.attr;
            dt[t] = function (e, t, n) {
                var r,
                    i,
                    o = t.toLowerCase();
                return n || ((i = dt[o]), (dt[o] = r), (r = null != a(e, t, n) ? o : null), (dt[o] = i)), r;
            };
        });
    var ht = /^(?:input|select|textarea|button)$/i,
        gt = /^(?:a|area)$/i;
    function vt(e) {
        return (e.match(P) || []).join(" ");
    }
    function yt(e) {
        return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function mt(e) {
        return Array.isArray(e) ? e : ("string" == typeof e && e.match(P)) || [];
    }
    S.fn.extend({
        prop: function (e, t) {
            return $(this, S.prop, e, t, 1 < arguments.length);
        },
        removeProp: function (e) {
            return this.each(function () {
                delete this[S.propFix[e] || e];
            });
        },
    }),
        S.extend({
            prop: function (e, t, n) {
                var r,
                    i,
                    o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return (
                        (1 === o && S.isXMLDoc(e)) || ((t = S.propFix[t] || t), (i = S.propHooks[t])),
                        void 0 !== n
                            ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                                ? r
                                : (e[t] = n)
                            : i && "get" in i && null !== (r = i.get(e, t))
                            ? r
                            : e[t]
                    );
            },
            propHooks: {
                tabIndex: {
                    get: function (e) {
                        var t = S.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : ht.test(e.nodeName) || (gt.test(e.nodeName) && e.href) ? 0 : -1;
                    },
                },
            },
            propFix: { for: "htmlFor", class: "className" },
        }),
        y.optSelected ||
            (S.propHooks.selected = {
                get: function (e) {
                    var t = e.parentNode;
                    return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                    var t = e.parentNode;
                    t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
            }),
        S.each(
            ["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"],
            function () {
                S.propFix[this.toLowerCase()] = this;
            }
        ),
        S.fn.extend({
            addClass: function (t) {
                var e,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u = 0;
                if (m(t))
                    return this.each(function (e) {
                        S(this).addClass(t.call(this, e, yt(this)));
                    });
                if ((e = mt(t)).length)
                    while ((n = this[u++]))
                        if (((i = yt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
                            a = 0;
                            while ((o = e[a++])) r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                            i !== (s = vt(r)) && n.setAttribute("class", s);
                        }
                return this;
            },
            removeClass: function (t) {
                var e,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u = 0;
                if (m(t))
                    return this.each(function (e) {
                        S(this).removeClass(t.call(this, e, yt(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ((e = mt(t)).length)
                    while ((n = this[u++]))
                        if (((i = yt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
                            a = 0;
                            while ((o = e[a++])) while (-1 < r.indexOf(" " + o + " ")) r = r.replace(" " + o + " ", " ");
                            i !== (s = vt(r)) && n.setAttribute("class", s);
                        }
                return this;
            },
            toggleClass: function (i, t) {
                var o = typeof i,
                    a = "string" === o || Array.isArray(i);
                return "boolean" == typeof t && a
                    ? t
                        ? this.addClass(i)
                        : this.removeClass(i)
                    : m(i)
                    ? this.each(function (e) {
                          S(this).toggleClass(i.call(this, e, yt(this), t), t);
                      })
                    : this.each(function () {
                          var e, t, n, r;
                          if (a) {
                              (t = 0), (n = S(this)), (r = mt(i));
                              while ((e = r[t++])) n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
                          } else (void 0 !== i && "boolean" !== o) || ((e = yt(this)) && Y.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === i ? "" : Y.get(this, "__className__") || ""));
                      });
            },
            hasClass: function (e) {
                var t,
                    n,
                    r = 0;
                t = " " + e + " ";
                while ((n = this[r++])) if (1 === n.nodeType && -1 < (" " + vt(yt(n)) + " ").indexOf(t)) return !0;
                return !1;
            },
        });
    var xt = /\r/g;
    S.fn.extend({
        val: function (n) {
            var r,
                e,
                i,
                t = this[0];
            return arguments.length
                ? ((i = m(n)),
                  this.each(function (e) {
                      var t;
                      1 === this.nodeType &&
                          (null == (t = i ? n.call(this, e, S(this).val()) : n)
                              ? (t = "")
                              : "number" == typeof t
                              ? (t += "")
                              : Array.isArray(t) &&
                                (t = S.map(t, function (e) {
                                    return null == e ? "" : e + "";
                                })),
                          ((r = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) &&
                              "set" in r &&
                              void 0 !== r.set(this, t, "value")) ||
                              (this.value = t));
                  }))
                : t
                ? (r = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) && "get" in r && void 0 !== (e = r.get(t, "value"))
                    ? e
                    : "string" == typeof (e = t.value)
                    ? e.replace(xt, "")
                    : null == e
                    ? ""
                    : e
                : void 0;
        },
    }),
        S.extend({
            valHooks: {
                option: {
                    get: function (e) {
                        var t = S.find.attr(e, "value");
                        return null != t ? t : vt(S.text(e));
                    },
                },
                select: {
                    get: function (e) {
                        var t,
                            n,
                            r,
                            i = e.options,
                            o = e.selectedIndex,
                            a = "select-one" === e.type,
                            s = a ? null : [],
                            u = a ? o + 1 : i.length;
                        for (r = o < 0 ? u : a ? o : 0; r < u; r++)
                            if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))) {
                                if (((t = S(n).val()), a)) return t;
                                s.push(t);
                            }
                        return s;
                    },
                    set: function (e, t) {
                        var n,
                            r,
                            i = e.options,
                            o = S.makeArray(t),
                            a = i.length;
                        while (a--) ((r = i[a]).selected = -1 < S.inArray(S.valHooks.option.get(r), o)) && (n = !0);
                        return n || (e.selectedIndex = -1), o;
                    },
                },
            },
        }),
        S.each(["radio", "checkbox"], function () {
            (S.valHooks[this] = {
                set: function (e, t) {
                    if (Array.isArray(t)) return (e.checked = -1 < S.inArray(S(e).val(), t));
                },
            }),
                y.checkOn ||
                    (S.valHooks[this].get = function (e) {
                        return null === e.getAttribute("value") ? "on" : e.value;
                    });
        }),
        (y.focusin = "onfocusin" in C);
    var bt = /^(?:focusinfocus|focusoutblur)$/,
        wt = function (e) {
            e.stopPropagation();
        };
    S.extend(S.event, {
        trigger: function (e, t, n, r) {
            var i,
                o,
                a,
                s,
                u,
                l,
                c,
                f,
                p = [n || E],
                d = v.call(e, "type") ? e.type : e,
                h = v.call(e, "namespace") ? e.namespace.split(".") : [];
            if (
                ((o = f = a = n = n || E),
                3 !== n.nodeType &&
                    8 !== n.nodeType &&
                    !bt.test(d + S.event.triggered) &&
                    (-1 < d.indexOf(".") && ((d = (h = d.split(".")).shift()), h.sort()),
                    (u = d.indexOf(":") < 0 && "on" + d),
                    ((e = e[S.expando] ? e : new S.Event(d, "object" == typeof e && e)).isTrigger = r ? 2 : 3),
                    (e.namespace = h.join(".")),
                    (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                    (e.result = void 0),
                    e.target || (e.target = n),
                    (t = null == t ? [e] : S.makeArray(t, [e])),
                    (c = S.event.special[d] || {}),
                    r || !c.trigger || !1 !== c.trigger.apply(n, t)))
            ) {
                if (!r && !c.noBubble && !x(n)) {
                    for (s = c.delegateType || d, bt.test(s + d) || (o = o.parentNode); o; o = o.parentNode) p.push(o), (a = o);
                    a === (n.ownerDocument || E) && p.push(a.defaultView || a.parentWindow || C);
                }
                i = 0;
                while ((o = p[i++]) && !e.isPropagationStopped())
                    (f = o),
                        (e.type = 1 < i ? s : c.bindType || d),
                        (l = (Y.get(o, "events") || Object.create(null))[e.type] && Y.get(o, "handle")) && l.apply(o, t),
                        (l = u && o[u]) && l.apply && V(o) && ((e.result = l.apply(o, t)), !1 === e.result && e.preventDefault());
                return (
                    (e.type = d),
                    r ||
                        e.isDefaultPrevented() ||
                        (c._default && !1 !== c._default.apply(p.pop(), t)) ||
                        !V(n) ||
                        (u &&
                            m(n[d]) &&
                            !x(n) &&
                            ((a = n[u]) && (n[u] = null),
                            (S.event.triggered = d),
                            e.isPropagationStopped() && f.addEventListener(d, wt),
                            n[d](),
                            e.isPropagationStopped() && f.removeEventListener(d, wt),
                            (S.event.triggered = void 0),
                            a && (n[u] = a))),
                    e.result
                );
            }
        },
        simulate: function (e, t, n) {
            var r = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
            S.event.trigger(r, null, t);
        },
    }),
        S.fn.extend({
            trigger: function (e, t) {
                return this.each(function () {
                    S.event.trigger(e, t, this);
                });
            },
            triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return S.event.trigger(e, t, n, !0);
            },
        }),
        y.focusin ||
            S.each({ focus: "focusin", blur: "focusout" }, function (n, r) {
                var i = function (e) {
                    S.event.simulate(r, e.target, S.event.fix(e));
                };
                S.event.special[r] = {
                    setup: function () {
                        var e = this.ownerDocument || this.document || this,
                            t = Y.access(e, r);
                        t || e.addEventListener(n, i, !0), Y.access(e, r, (t || 0) + 1);
                    },
                    teardown: function () {
                        var e = this.ownerDocument || this.document || this,
                            t = Y.access(e, r) - 1;
                        t ? Y.access(e, r, t) : (e.removeEventListener(n, i, !0), Y.remove(e, r));
                    },
                };
            });
    var Tt = C.location,
        Ct = { guid: Date.now() },
        Et = /\?/;
    S.parseXML = function (e) {
        var t;
        if (!e || "string" != typeof e) return null;
        try {
            t = new C.DOMParser().parseFromString(e, "text/xml");
        } catch (e) {
            t = void 0;
        }
        return (t && !t.getElementsByTagName("parsererror").length) || S.error("Invalid XML: " + e), t;
    };
    var St = /\[\]$/,
        kt = /\r?\n/g,
        At = /^(?:submit|button|image|reset|file)$/i,
        Nt = /^(?:input|select|textarea|keygen)/i;
    function Dt(n, e, r, i) {
        var t;
        if (Array.isArray(e))
            S.each(e, function (e, t) {
                r || St.test(n) ? i(n, t) : Dt(n + "[" + ("object" == typeof t && null != t ? e : "") + "]", t, r, i);
            });
        else if (r || "object" !== w(e)) i(n, e);
        else for (t in e) Dt(n + "[" + t + "]", e[t], r, i);
    }
    (S.param = function (e, t) {
        var n,
            r = [],
            i = function (e, t) {
                var n = m(t) ? t() : t;
                r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
            };
        if (null == e) return "";
        if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
            S.each(e, function () {
                i(this.name, this.value);
            });
        else for (n in e) Dt(n, e[n], t, i);
        return r.join("&");
    }),
        S.fn.extend({
            serialize: function () {
                return S.param(this.serializeArray());
            },
            serializeArray: function () {
                return this.map(function () {
                    var e = S.prop(this, "elements");
                    return e ? S.makeArray(e) : this;
                })
                    .filter(function () {
                        var e = this.type;
                        return this.name && !S(this).is(":disabled") && Nt.test(this.nodeName) && !At.test(e) && (this.checked || !pe.test(e));
                    })
                    .map(function (e, t) {
                        var n = S(this).val();
                        return null == n
                            ? null
                            : Array.isArray(n)
                            ? S.map(n, function (e) {
                                  return { name: t.name, value: e.replace(kt, "\r\n") };
                              })
                            : { name: t.name, value: n.replace(kt, "\r\n") };
                    })
                    .get();
            },
        });
    var jt = /%20/g,
        qt = /#.*$/,
        Lt = /([?&])_=[^&]*/,
        Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ot = /^(?:GET|HEAD)$/,
        Pt = /^\/\//,
        Rt = {},
        Mt = {},
        It = "*/".concat("*"),
        Wt = E.createElement("a");
    function Ft(o) {
        return function (e, t) {
            "string" != typeof e && ((t = e), (e = "*"));
            var n,
                r = 0,
                i = e.toLowerCase().match(P) || [];
            if (m(t)) while ((n = i[r++])) "+" === n[0] ? ((n = n.slice(1) || "*"), (o[n] = o[n] || []).unshift(t)) : (o[n] = o[n] || []).push(t);
        };
    }
    function Bt(t, i, o, a) {
        var s = {},
            u = t === Mt;
        function l(e) {
            var r;
            return (
                (s[e] = !0),
                S.each(t[e] || [], function (e, t) {
                    var n = t(i, o, a);
                    return "string" != typeof n || u || s[n] ? (u ? !(r = n) : void 0) : (i.dataTypes.unshift(n), l(n), !1);
                }),
                r
            );
        }
        return l(i.dataTypes[0]) || (!s["*"] && l("*"));
    }
    function $t(e, t) {
        var n,
            r,
            i = S.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
        return r && S.extend(!0, e, r), e;
    }
    (Wt.href = Tt.href),
        S.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: Tt.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                    "*": It,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript",
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": S.parseXML },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (e, t) {
                return t ? $t($t(e, S.ajaxSettings), t) : $t(S.ajaxSettings, e);
            },
            ajaxPrefilter: Ft(Rt),
            ajaxTransport: Ft(Mt),
            ajax: function (e, t) {
                "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                var c,
                    f,
                    p,
                    n,
                    d,
                    r,
                    h,
                    g,
                    i,
                    o,
                    v = S.ajaxSetup({}, t),
                    y = v.context || v,
                    m = v.context && (y.nodeType || y.jquery) ? S(y) : S.event,
                    x = S.Deferred(),
                    b = S.Callbacks("once memory"),
                    w = v.statusCode || {},
                    a = {},
                    s = {},
                    u = "canceled",
                    T = {
                        readyState: 0,
                        getResponseHeader: function (e) {
                            var t;
                            if (h) {
                                if (!n) {
                                    n = {};
                                    while ((t = Ht.exec(p))) n[t[1].toLowerCase() + " "] = (n[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                }
                                t = n[e.toLowerCase() + " "];
                            }
                            return null == t ? null : t.join(", ");
                        },
                        getAllResponseHeaders: function () {
                            return h ? p : null;
                        },
                        setRequestHeader: function (e, t) {
                            return null == h && ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e), (a[e] = t)), this;
                        },
                        overrideMimeType: function (e) {
                            return null == h && (v.mimeType = e), this;
                        },
                        statusCode: function (e) {
                            var t;
                            if (e)
                                if (h) T.always(e[T.status]);
                                else for (t in e) w[t] = [w[t], e[t]];
                            return this;
                        },
                        abort: function (e) {
                            var t = e || u;
                            return c && c.abort(t), l(0, t), this;
                        },
                    };
                if (
                    (x.promise(T),
                    (v.url = ((e || v.url || Tt.href) + "").replace(Pt, Tt.protocol + "//")),
                    (v.type = t.method || t.type || v.method || v.type),
                    (v.dataTypes = (v.dataType || "*").toLowerCase().match(P) || [""]),
                    null == v.crossDomain)
                ) {
                    r = E.createElement("a");
                    try {
                        (r.href = v.url), (r.href = r.href), (v.crossDomain = Wt.protocol + "//" + Wt.host != r.protocol + "//" + r.host);
                    } catch (e) {
                        v.crossDomain = !0;
                    }
                }
                if ((v.data && v.processData && "string" != typeof v.data && (v.data = S.param(v.data, v.traditional)), Bt(Rt, v, t, T), h)) return T;
                for (i in ((g = S.event && v.global) && 0 == S.active++ && S.event.trigger("ajaxStart"),
                (v.type = v.type.toUpperCase()),
                (v.hasContent = !Ot.test(v.type)),
                (f = v.url.replace(qt, "")),
                v.hasContent
                    ? v.data &&
                      v.processData &&
                      0 === (v.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                      (v.data = v.data.replace(jt, "+"))
                    : ((o = v.url.slice(f.length)),
                      v.data && (v.processData || "string" == typeof v.data) && ((f += (Et.test(f) ? "&" : "?") + v.data), delete v.data),
                      !1 === v.cache && ((f = f.replace(Lt, "$1")), (o = (Et.test(f) ? "&" : "?") + "_=" + Ct.guid++ + o)),
                      (v.url = f + o)),
                v.ifModified &&
                    (S.lastModified[f] && T.setRequestHeader("If-Modified-Since", S.lastModified[f]),
                    S.etag[f] && T.setRequestHeader("If-None-Match", S.etag[f])),
                ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) && T.setRequestHeader("Content-Type", v.contentType),
                T.setRequestHeader(
                    "Accept",
                    v.dataTypes[0] && v.accepts[v.dataTypes[0]]
                        ? v.accepts[v.dataTypes[0]] + ("*" !== v.dataTypes[0] ? ", " + It + "; q=0.01" : "")
                        : v.accepts["*"]
                ),
                v.headers))
                    T.setRequestHeader(i, v.headers[i]);
                if (v.beforeSend && (!1 === v.beforeSend.call(y, T, v) || h)) return T.abort();
                if (((u = "abort"), b.add(v.complete), T.done(v.success), T.fail(v.error), (c = Bt(Mt, v, t, T)))) {
                    if (((T.readyState = 1), g && m.trigger("ajaxSend", [T, v]), h)) return T;
                    v.async &&
                        0 < v.timeout &&
                        (d = C.setTimeout(function () {
                            T.abort("timeout");
                        }, v.timeout));
                    try {
                        (h = !1), c.send(a, l);
                    } catch (e) {
                        if (h) throw e;
                        l(-1, e);
                    }
                } else l(-1, "No Transport");
                function l(e, t, n, r) {
                    var i,
                        o,
                        a,
                        s,
                        u,
                        l = t;
                    h ||
                        ((h = !0),
                        d && C.clearTimeout(d),
                        (c = void 0),
                        (p = r || ""),
                        (T.readyState = 0 < e ? 4 : 0),
                        (i = (200 <= e && e < 300) || 304 === e),
                        n &&
                            (s = (function (e, t, n) {
                                var r,
                                    i,
                                    o,
                                    a,
                                    s = e.contents,
                                    u = e.dataTypes;
                                while ("*" === u[0]) u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                                if (r)
                                    for (i in s)
                                        if (s[i] && s[i].test(r)) {
                                            u.unshift(i);
                                            break;
                                        }
                                if (u[0] in n) o = u[0];
                                else {
                                    for (i in n) {
                                        if (!u[0] || e.converters[i + " " + u[0]]) {
                                            o = i;
                                            break;
                                        }
                                        a || (a = i);
                                    }
                                    o = o || a;
                                }
                                if (o) return o !== u[0] && u.unshift(o), n[o];
                            })(v, T, n)),
                        !i && -1 < S.inArray("script", v.dataTypes) && (v.converters["text script"] = function () {}),
                        (s = (function (e, t, n, r) {
                            var i,
                                o,
                                a,
                                s,
                                u,
                                l = {},
                                c = e.dataTypes.slice();
                            if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
                            o = c.shift();
                            while (o)
                                if (
                                    (e.responseFields[o] && (n[e.responseFields[o]] = t),
                                    !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                                    (u = o),
                                    (o = c.shift()))
                                )
                                    if ("*" === o) o = u;
                                    else if ("*" !== u && u !== o) {
                                        if (!(a = l[u + " " + o] || l["* " + o]))
                                            for (i in l)
                                                if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                                                    !0 === a ? (a = l[i]) : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                                                    break;
                                                }
                                        if (!0 !== a)
                                            if (a && e["throws"]) t = a(t);
                                            else
                                                try {
                                                    t = a(t);
                                                } catch (e) {
                                                    return { state: "parsererror", error: a ? e : "No conversion from " + u + " to " + o };
                                                }
                                    }
                            return { state: "success", data: t };
                        })(v, s, T, i)),
                        i
                            ? (v.ifModified &&
                                  ((u = T.getResponseHeader("Last-Modified")) && (S.lastModified[f] = u),
                                  (u = T.getResponseHeader("etag")) && (S.etag[f] = u)),
                              204 === e || "HEAD" === v.type
                                  ? (l = "nocontent")
                                  : 304 === e
                                  ? (l = "notmodified")
                                  : ((l = s.state), (o = s.data), (i = !(a = s.error))))
                            : ((a = l), (!e && l) || ((l = "error"), e < 0 && (e = 0))),
                        (T.status = e),
                        (T.statusText = (t || l) + ""),
                        i ? x.resolveWith(y, [o, l, T]) : x.rejectWith(y, [T, l, a]),
                        T.statusCode(w),
                        (w = void 0),
                        g && m.trigger(i ? "ajaxSuccess" : "ajaxError", [T, v, i ? o : a]),
                        b.fireWith(y, [T, l]),
                        g && (m.trigger("ajaxComplete", [T, v]), --S.active || S.event.trigger("ajaxStop")));
                }
                return T;
            },
            getJSON: function (e, t, n) {
                return S.get(e, t, n, "json");
            },
            getScript: function (e, t) {
                return S.get(e, void 0, t, "script");
            },
        }),
        S.each(["get", "post"], function (e, i) {
            S[i] = function (e, t, n, r) {
                return (
                    m(t) && ((r = r || n), (n = t), (t = void 0)),
                    S.ajax(S.extend({ url: e, type: i, dataType: r, data: t, success: n }, S.isPlainObject(e) && e))
                );
            };
        }),
        S.ajaxPrefilter(function (e) {
            var t;
            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
        }),
        (S._evalUrl = function (e, t, n) {
            return S.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (e) {
                    S.globalEval(e, t, n);
                },
            });
        }),
        S.fn.extend({
            wrapAll: function (e) {
                var t;
                return (
                    this[0] &&
                        (m(e) && (e = e.call(this[0])),
                        (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
                        this[0].parentNode && t.insertBefore(this[0]),
                        t
                            .map(function () {
                                var e = this;
                                while (e.firstElementChild) e = e.firstElementChild;
                                return e;
                            })
                            .append(this)),
                    this
                );
            },
            wrapInner: function (n) {
                return m(n)
                    ? this.each(function (e) {
                          S(this).wrapInner(n.call(this, e));
                      })
                    : this.each(function () {
                          var e = S(this),
                              t = e.contents();
                          t.length ? t.wrapAll(n) : e.append(n);
                      });
            },
            wrap: function (t) {
                var n = m(t);
                return this.each(function (e) {
                    S(this).wrapAll(n ? t.call(this, e) : t);
                });
            },
            unwrap: function (e) {
                return (
                    this.parent(e)
                        .not("body")
                        .each(function () {
                            S(this).replaceWith(this.childNodes);
                        }),
                    this
                );
            },
        }),
        (S.expr.pseudos.hidden = function (e) {
            return !S.expr.pseudos.visible(e);
        }),
        (S.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
        }),
        (S.ajaxSettings.xhr = function () {
            try {
                return new C.XMLHttpRequest();
            } catch (e) {}
        });
    var _t = { 0: 200, 1223: 204 },
        zt = S.ajaxSettings.xhr();
    (y.cors = !!zt && "withCredentials" in zt),
        (y.ajax = zt = !!zt),
        S.ajaxTransport(function (i) {
            var o, a;
            if (y.cors || (zt && !i.crossDomain))
                return {
                    send: function (e, t) {
                        var n,
                            r = i.xhr();
                        if ((r.open(i.type, i.url, i.async, i.username, i.password), i.xhrFields)) for (n in i.xhrFields) r[n] = i.xhrFields[n];
                        for (n in (i.mimeType && r.overrideMimeType && r.overrideMimeType(i.mimeType),
                        i.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"),
                        e))
                            r.setRequestHeader(n, e[n]);
                        (o = function (e) {
                            return function () {
                                o &&
                                    ((o = a = r.onload = r.onerror = r.onabort = r.ontimeout = r.onreadystatechange = null),
                                    "abort" === e
                                        ? r.abort()
                                        : "error" === e
                                        ? "number" != typeof r.status
                                            ? t(0, "error")
                                            : t(r.status, r.statusText)
                                        : t(
                                              _t[r.status] || r.status,
                                              r.statusText,
                                              "text" !== (r.responseType || "text") || "string" != typeof r.responseText
                                                  ? { binary: r.response }
                                                  : { text: r.responseText },
                                              r.getAllResponseHeaders()
                                          ));
                            };
                        }),
                            (r.onload = o()),
                            (a = r.onerror = r.ontimeout = o("error")),
                            void 0 !== r.onabort
                                ? (r.onabort = a)
                                : (r.onreadystatechange = function () {
                                      4 === r.readyState &&
                                          C.setTimeout(function () {
                                              o && a();
                                          });
                                  }),
                            (o = o("abort"));
                        try {
                            r.send((i.hasContent && i.data) || null);
                        } catch (e) {
                            if (o) throw e;
                        }
                    },
                    abort: function () {
                        o && o();
                    },
                };
        }),
        S.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
        }),
        S.ajaxSetup({
            accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                "text script": function (e) {
                    return S.globalEval(e), e;
                },
            },
        }),
        S.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
        }),
        S.ajaxTransport("script", function (n) {
            var r, i;
            if (n.crossDomain || n.scriptAttrs)
                return {
                    send: function (e, t) {
                        (r = S("<script>")
                            .attr(n.scriptAttrs || {})
                            .prop({ charset: n.scriptCharset, src: n.url })
                            .on(
                                "load error",
                                (i = function (e) {
                                    r.remove(), (i = null), e && t("error" === e.type ? 404 : 200, e.type);
                                })
                            )),
                            E.head.appendChild(r[0]);
                    },
                    abort: function () {
                        i && i();
                    },
                };
        });
    var Ut,
        Xt = [],
        Vt = /(=)\?(?=&|$)|\?\?/;
    S.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
            var e = Xt.pop() || S.expando + "_" + Ct.guid++;
            return (this[e] = !0), e;
        },
    }),
        S.ajaxPrefilter("json jsonp", function (e, t, n) {
            var r,
                i,
                o,
                a =
                    !1 !== e.jsonp &&
                    (Vt.test(e.url)
                        ? "url"
                        : "string" == typeof e.data &&
                          0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                          Vt.test(e.data) &&
                          "data");
            if (a || "jsonp" === e.dataTypes[0])
                return (
                    (r = e.jsonpCallback = m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                    a ? (e[a] = e[a].replace(Vt, "$1" + r)) : !1 !== e.jsonp && (e.url += (Et.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
                    (e.converters["script json"] = function () {
                        return o || S.error(r + " was not called"), o[0];
                    }),
                    (e.dataTypes[0] = "json"),
                    (i = C[r]),
                    (C[r] = function () {
                        o = arguments;
                    }),
                    n.always(function () {
                        void 0 === i ? S(C).removeProp(r) : (C[r] = i),
                            e[r] && ((e.jsonpCallback = t.jsonpCallback), Xt.push(r)),
                            o && m(i) && i(o[0]),
                            (o = i = void 0);
                    }),
                    "script"
                );
        }),
        (y.createHTMLDocument =
            (((Ut = E.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === Ut.childNodes.length)),
        (S.parseHTML = function (e, t, n) {
            return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                  t ||
                      (y.createHTMLDocument
                          ? (((r = (t = E.implementation.createHTMLDocument("")).createElement("base")).href = E.location.href),
                            t.head.appendChild(r))
                          : (t = E)),
                  (o = !n && []),
                  (i = N.exec(e)) ? [t.createElement(i[1])] : ((i = xe([e], t, o)), o && o.length && S(o).remove(), S.merge([], i.childNodes)));
            var r, i, o;
        }),
        (S.fn.load = function (e, t, n) {
            var r,
                i,
                o,
                a = this,
                s = e.indexOf(" ");
            return (
                -1 < s && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
                m(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (i = "POST"),
                0 < a.length &&
                    S.ajax({ url: e, type: i || "GET", dataType: "html", data: t })
                        .done(function (e) {
                            (o = arguments), a.html(r ? S("<div>").append(S.parseHTML(e)).find(r) : e);
                        })
                        .always(
                            n &&
                                function (e, t) {
                                    a.each(function () {
                                        n.apply(this, o || [e.responseText, t, e]);
                                    });
                                }
                        ),
                this
            );
        }),
        (S.expr.pseudos.animated = function (t) {
            return S.grep(S.timers, function (e) {
                return t === e.elem;
            }).length;
        }),
        (S.offset = {
            setOffset: function (e, t, n) {
                var r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l = S.css(e, "position"),
                    c = S(e),
                    f = {};
                "static" === l && (e.style.position = "relative"),
                    (s = c.offset()),
                    (o = S.css(e, "top")),
                    (u = S.css(e, "left")),
                    ("absolute" === l || "fixed" === l) && -1 < (o + u).indexOf("auto")
                        ? ((a = (r = c.position()).top), (i = r.left))
                        : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
                    m(t) && (t = t.call(e, n, S.extend({}, s))),
                    null != t.top && (f.top = t.top - s.top + a),
                    null != t.left && (f.left = t.left - s.left + i),
                    "using" in t
                        ? t.using.call(e, f)
                        : ("number" == typeof f.top && (f.top += "px"), "number" == typeof f.left && (f.left += "px"), c.css(f));
            },
        }),
        S.fn.extend({
            offset: function (t) {
                if (arguments.length)
                    return void 0 === t
                        ? this
                        : this.each(function (e) {
                              S.offset.setOffset(this, t, e);
                          });
                var e,
                    n,
                    r = this[0];
                return r
                    ? r.getClientRects().length
                        ? ((e = r.getBoundingClientRect()),
                          (n = r.ownerDocument.defaultView),
                          { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset })
                        : { top: 0, left: 0 }
                    : void 0;
            },
            position: function () {
                if (this[0]) {
                    var e,
                        t,
                        n,
                        r = this[0],
                        i = { top: 0, left: 0 };
                    if ("fixed" === S.css(r, "position")) t = r.getBoundingClientRect();
                    else {
                        (t = this.offset()), (n = r.ownerDocument), (e = r.offsetParent || n.documentElement);
                        while (e && (e === n.body || e === n.documentElement) && "static" === S.css(e, "position")) e = e.parentNode;
                        e &&
                            e !== r &&
                            1 === e.nodeType &&
                            (((i = S(e).offset()).top += S.css(e, "borderTopWidth", !0)), (i.left += S.css(e, "borderLeftWidth", !0)));
                    }
                    return { top: t.top - i.top - S.css(r, "marginTop", !0), left: t.left - i.left - S.css(r, "marginLeft", !0) };
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    var e = this.offsetParent;
                    while (e && "static" === S.css(e, "position")) e = e.offsetParent;
                    return e || re;
                });
            },
        }),
        S.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, i) {
            var o = "pageYOffset" === i;
            S.fn[t] = function (e) {
                return $(
                    this,
                    function (e, t, n) {
                        var r;
                        if ((x(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView), void 0 === n)) return r ? r[i] : e[t];
                        r ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset) : (e[t] = n);
                    },
                    t,
                    e,
                    arguments.length
                );
            };
        }),
        S.each(["top", "left"], function (e, n) {
            S.cssHooks[n] = $e(y.pixelPosition, function (e, t) {
                if (t) return (t = Be(e, n)), Me.test(t) ? S(e).position()[n] + "px" : t;
            });
        }),
        S.each({ Height: "height", Width: "width" }, function (a, s) {
            S.each({ padding: "inner" + a, content: s, "": "outer" + a }, function (r, o) {
                S.fn[o] = function (e, t) {
                    var n = arguments.length && (r || "boolean" != typeof e),
                        i = r || (!0 === e || !0 === t ? "margin" : "border");
                    return $(
                        this,
                        function (e, t, n) {
                            var r;
                            return x(e)
                                ? 0 === o.indexOf("outer")
                                    ? e["inner" + a]
                                    : e.document.documentElement["client" + a]
                                : 9 === e.nodeType
                                ? ((r = e.documentElement),
                                  Math.max(e.body["scroll" + a], r["scroll" + a], e.body["offset" + a], r["offset" + a], r["client" + a]))
                                : void 0 === n
                                ? S.css(e, t, i)
                                : S.style(e, t, n, i);
                        },
                        s,
                        n ? e : void 0,
                        n
                    );
                };
            });
        }),
        S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            S.fn[t] = function (e) {
                return this.on(t, e);
            };
        }),
        S.fn.extend({
            bind: function (e, t, n) {
                return this.on(e, null, t, n);
            },
            unbind: function (e, t) {
                return this.off(e, null, t);
            },
            delegate: function (e, t, n, r) {
                return this.on(t, e, n, r);
            },
            undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            },
        }),
        S.each(
            "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                " "
            ),
            function (e, n) {
                S.fn[n] = function (e, t) {
                    return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n);
                };
            }
        );
    var Gt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (S.proxy = function (e, t) {
        var n, r, i;
        if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), m(e)))
            return (
                (r = s.call(arguments, 2)),
                ((i = function () {
                    return e.apply(t || this, r.concat(s.call(arguments)));
                }).guid = e.guid = e.guid || S.guid++),
                i
            );
    }),
        (S.holdReady = function (e) {
            e ? S.readyWait++ : S.ready(!0);
        }),
        (S.isArray = Array.isArray),
        (S.parseJSON = JSON.parse),
        (S.nodeName = A),
        (S.isFunction = m),
        (S.isWindow = x),
        (S.camelCase = X),
        (S.type = w),
        (S.now = Date.now),
        (S.isNumeric = function (e) {
            var t = S.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
        }),
        (S.trim = function (e) {
            return null == e ? "" : (e + "").replace(Gt, "");
        }),
        "function" == typeof define &&
            define.amd &&
            define("jquery", [], function () {
                return S;
            });
    var Yt = C.jQuery,
        Qt = C.$;
    return (
        (S.noConflict = function (e) {
            return C.$ === S && (C.$ = Qt), e && C.jQuery === S && (C.jQuery = Yt), S;
        }),
        "undefined" == typeof e && (C.jQuery = C.$ = S),
        S
    );
});

// Slick Slider

(function (factory) {
    "use strict";
    if (typeof define === "function" && define.amd) {
        define(["jquery"], factory);
    } else if (typeof exports !== "undefined") {
        module.exports = factory(require("jquery"));
    } else {
        factory(jQuery);
    }
})(function ($) {
    "use strict";
    var Slick = window.Slick || {};
    Slick = (function () {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this,
                dataSettings;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3e3,
                centerMode: false,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: "slick-dots",
                draggable: true,
                easing: "linear",
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: false,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1e3,
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false,
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = "hidden";
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = "visibilitychange";
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data("slick") || {};
            _.options = $.extend({}, _.defaults, settings, dataSettings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            if (typeof document.mozHidden !== "undefined") {
                _.hidden = "mozHidden";
                _.visibilityChange = "mozvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                _.hidden = "webkitHidden";
                _.visibilityChange = "webkitvisibilitychange";
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.instanceUid = instanceUid++;
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.registerBreakpoints();
            _.init(true);
        }
        return Slick;
    })();
    Slick.prototype.activateADA = function () {
        var _ = this;
        _.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
        var _ = this;
        if (typeof index === "boolean") {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) {
            return false;
        }
        _.unload();
        if (typeof index === "number") {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function (index, element) {
            $(element).attr("data-slick-index", index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function () {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({ height: targetHeight }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function (targetLeft, callback) {
        var animProps = {},
            _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({ left: targetLeft }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({ top: targetLeft }, _.options.speed, _.options.easing, callback);
            }
        } else {
            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -_.currentLeft;
                }
                $({ animStart: _.currentLeft }).animate(
                    { animStart: targetLeft },
                    {
                        duration: _.options.speed,
                        easing: _.options.easing,
                        step: function (now) {
                            now = Math.ceil(now);
                            if (_.options.vertical === false) {
                                animProps[_.animType] = "translate(" + now + "px, 0px)";
                                _.$slideTrack.css(animProps);
                            } else {
                                animProps[_.animType] = "translate(0px," + now + "px)";
                                _.$slideTrack.css(animProps);
                            }
                        },
                        complete: function () {
                            if (callback) {
                                callback.call();
                            }
                        },
                    }
                );
            } else {
                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);
                if (_.options.vertical === false) {
                    animProps[_.animType] = "translate3d(" + targetLeft + "px, 0px, 0px)";
                } else {
                    animProps[_.animType] = "translate3d(0px," + targetLeft + "px, 0px)";
                }
                _.$slideTrack.css(animProps);
                if (callback) {
                    setTimeout(function () {
                        _.disableTransition();
                        callback.call();
                    }, _.options.speed);
                }
            }
        }
    };
    Slick.prototype.getNavTarget = function () {
        var _ = this,
            asNavFor = _.options.asNavFor;
        if (asNavFor && asNavFor !== null) {
            asNavFor = $(asNavFor).not(_.$slider);
        }
        return asNavFor;
    };
    Slick.prototype.asNavFor = function (index) {
        var _ = this,
            asNavFor = _.getNavTarget();
        if (asNavFor !== null && typeof asNavFor === "object") {
            asNavFor.each(function () {
                var target = $(this).slick("getSlick");
                if (!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }
    };
    Slick.prototype.applyTransition = function (slide) {
        var _ = this,
            transition = {};
        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + " " + _.options.speed + "ms " + _.options.cssEase;
        } else {
            transition[_.transitionType] = "opacity " + _.options.speed + "ms " + _.options.cssEase;
        }
        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };
    Slick.prototype.autoPlay = function () {
        var _ = this;
        _.autoPlayClear();
        if (_.slideCount > _.options.slidesToShow) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
        }
    };
    Slick.prototype.autoPlayClear = function () {
        var _ = this;
        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }
    };
    Slick.prototype.autoPlayIterator = function () {
        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;
        if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
                    _.direction = 0;
                } else if (_.direction === 0) {
                    slideTo = _.currentSlide - _.options.slidesToScroll;
                    if (_.currentSlide - 1 === 0) {
                        _.direction = 1;
                    }
                }
            }
            _.slideHandler(slideTo);
        }
    };
    Slick.prototype.buildArrows = function () {
        var _ = this;
        if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass("slick-arrow");
            _.$nextArrow = $(_.options.nextArrow).addClass("slick-arrow");
            if (_.slideCount > _.options.slidesToShow) {
                _.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex");
                _.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex");
                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }
                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }
                if (_.options.infinite !== true) {
                    _.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true");
                }
            } else {
                _.$prevArrow.add(_.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" });
            }
        }
    };
    Slick.prototype.buildDots = function () {
        var _ = this,
            i,
            dot;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass("slick-dotted");
            dot = $("<ul />").addClass(_.options.dotsClass);
            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($("<li />").append(_.options.customPaging.call(this, _, i)));
            }
            _.$dots = dot.appendTo(_.options.appendDots);
            _.$dots.find("li").first().addClass("slick-active");
        }
    };
    Slick.prototype.buildOut = function () {
        var _ = this;
        _.$slides = _.$slider.children(_.options.slide + ":not(.slick-cloned)").addClass("slick-slide");
        _.slideCount = _.$slides.length;
        _.$slides.each(function (index, element) {
            $(element)
                .attr("data-slick-index", index)
                .data("originalStyling", $(element).attr("style") || "");
        });
        _.$slider.addClass("slick-slider");
        _.$slideTrack =
            _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css("opacity", 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }
        $("img[data-lazy]", _.$slider).not("[src]").addClass("slick-loading");
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        _.setSlideClasses(typeof _.currentSlide === "number" ? _.currentSlide : 0);
        if (_.options.draggable === true) {
            _.$list.addClass("draggable");
        }
    };
    Slick.prototype.buildRows = function () {
        var _ = this,
            a,
            b,
            c,
            newSlides,
            numOfSlides,
            originalSlides,
            slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for (a = 0; a < numOfSlides; a++) {
                var slide = document.createElement("div");
                for (b = 0; b < _.options.rows; b++) {
                    var row = document.createElement("div");
                    for (c = 0; c < _.options.slidesPerRow; c++) {
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.empty().append(newSlides);
            _.$slider
                .children()
                .children()
                .children()
                .css({ width: 100 / _.options.slidesPerRow + "%", display: "inline-block" });
        }
    };
    Slick.prototype.checkResponsive = function (initial, forceUpdate) {
        var _ = this,
            breakpoint,
            targetBreakpoint,
            respondToWidth,
            triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === "window") {
            respondToWidth = windowWidth;
        } else if (_.respondTo === "slider") {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === "min") {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }
        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;
            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === "unslick") {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === "unslick") {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }
            if (!initial && triggerBreakpoint !== false) {
                _.$slider.trigger("breakpoint", [_, triggerBreakpoint]);
            }
        }
    };
    Slick.prototype.changeSlide = function (event, dontAnimate) {
        var _ = this,
            $target = $(event.currentTarget),
            indexOffset,
            slideOffset,
            unevenOffset;
        if ($target.is("a")) {
            event.preventDefault();
        }
        if (!$target.is("li")) {
            $target = $target.closest("li");
        }
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch (event.data.message) {
            case "previous":
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;
            case "next":
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;
            case "index":
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger("focus");
                break;
            default:
                return;
        }
    };
    Slick.prototype.checkNavigable = function (index) {
        var _ = this,
            navigables,
            prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function () {
        var _ = this;
        if (_.options.dots && _.$dots !== null) {
            $("li", _.$dots)
                .off("click.slick", _.changeSlide)
                .off("mouseenter.slick", $.proxy(_.interrupt, _, true))
                .off("mouseleave.slick", $.proxy(_.interrupt, _, false));
            if (_.options.accessibility === true) {
                _.$dots.off("keydown.slick", _.keyHandler);
            }
        }
        _.$slider.off("focus.slick blur.slick");
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off("click.slick", _.changeSlide);
            _.$nextArrow && _.$nextArrow.off("click.slick", _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off("keydown.slick", _.keyHandler);
                _.$nextArrow && _.$nextArrow.off("keydown.slick", _.keyHandler);
            }
        }
        _.$list.off("touchstart.slick mousedown.slick", _.swipeHandler);
        _.$list.off("touchmove.slick mousemove.slick", _.swipeHandler);
        _.$list.off("touchend.slick mouseup.slick", _.swipeHandler);
        _.$list.off("touchcancel.slick mouseleave.slick", _.swipeHandler);
        _.$list.off("click.slick", _.clickHandler);
        $(document).off(_.visibilityChange, _.visibility);
        _.cleanUpSlideEvents();
        if (_.options.accessibility === true) {
            _.$list.off("keydown.slick", _.keyHandler);
        }
        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off("click.slick", _.selectHandler);
        }
        $(window).off("orientationchange.slick.slick-" + _.instanceUid, _.orientationChange);
        $(window).off("resize.slick.slick-" + _.instanceUid, _.resize);
        $("[draggable!=true]", _.$slideTrack).off("dragstart", _.preventDefault);
        $(window).off("load.slick.slick-" + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function () {
        var _ = this;
        _.$list.off("mouseenter.slick", $.proxy(_.interrupt, _, true));
        _.$list.off("mouseleave.slick", $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function () {
        var _ = this,
            originalSlides;
        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr("style");
            _.$slider.empty().append(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function (event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function (refresh) {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $(".slick-cloned", _.$slider).detach();
        if (_.$dots) {
            _.$dots.remove();
        }
        if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", "");
            if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.remove();
            }
        }
        if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", "");
            if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.remove();
            }
        }
        if (_.$slides) {
            _.$slides
                .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                .removeAttr("aria-hidden")
                .removeAttr("data-slick-index")
                .each(function () {
                    $(this).attr("style", $(this).data("originalStyling"));
                });
            _.$slideTrack.children(this.options.slide).detach();
            _.$slideTrack.detach();
            _.$list.detach();
            _.$slider.append(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass("slick-slider");
        _.$slider.removeClass("slick-initialized");
        _.$slider.removeClass("slick-dotted");
        _.unslicked = true;
        if (!refresh) {
            _.$slider.trigger("destroy", [_]);
        }
    };
    Slick.prototype.disableTransition = function (slide) {
        var _ = this,
            transition = {};
        transition[_.transitionType] = "";
        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };
    Slick.prototype.fadeSlide = function (slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({ zIndex: _.options.zIndex });
            _.$slides.eq(slideIndex).animate({ opacity: 1 }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({ opacity: 1, zIndex: _.options.zIndex });
            if (callback) {
                setTimeout(function () {
                    _.disableTransition(slideIndex);
                    callback.call();
                }, _.options.speed);
            }
        }
    };
    Slick.prototype.fadeSlideOut = function (slideIndex) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).animate({ opacity: 0, zIndex: _.options.zIndex - 2 }, _.options.speed, _.options.easing);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({ opacity: 0, zIndex: _.options.zIndex - 2 });
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
        var _ = this;
        if (filter !== null) {
            _.$slidesCache = _.$slides;
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.focusHandler = function () {
        var _ = this;
        _.$slider
            .off("focus.slick blur.slick")
            .on("focus.slick", "*", function (event) {
                var $sf = $(this);
                setTimeout(function () {
                    if (_.options.pauseOnFocus) {
                        if ($sf.is(":focus")) {
                            _.focussed = true;
                            _.autoPlay();
                        }
                    }
                }, 0);
            })
            .on("blur.slick", "*", function (event) {
                var $sf = $(this);
                if (_.options.pauseOnFocus) {
                    _.focussed = false;
                    _.autoPlay();
                }
            });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function () {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if (!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        } else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function (slideIndex) {
        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;
                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2;
                    }
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = (_.slideCount % _.options.slidesToScroll) * _.slideWidth * -1;
                        verticalOffset = (_.slideCount % _.options.slidesToScroll) * verticalHeight * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
                verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
            }
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = (_.slideWidth * Math.floor(_.options.slidesToShow)) / 2 - (_.slideWidth * _.slideCount) / 2;
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) {
            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        } else {
            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        }
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex + _.options.slidesToShow);
            }
            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft = 0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }
            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex + _.options.slidesToShow + 1);
                }
                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft = 0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function () {
        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;
        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function () {
        return this;
    };
    Slick.prototype.getSlideCount = function () {
        var _ = this,
            slidesTraversed,
            swipedSlide,
            swipeTarget,
            centerOffset;
        centerOffset = _.options.centerMode === true ? Math.floor(_.$list.width() / 2) : 0;
        swipeTarget = _.swipeLeft * -1 + centerOffset;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find(".slick-slide").each(function (index, slide) {
                var slideOuterWidth, slideOffset, slideRightBoundary;
                slideOuterWidth = $(slide).outerWidth();
                slideOffset = slide.offsetLeft;
                if (_.options.centerMode !== true) {
                    slideOffset += slideOuterWidth / 2;
                }
                slideRightBoundary = slideOffset + slideOuterWidth;
                if (swipeTarget < slideRightBoundary) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr("data-slick-index") - _.currentSlide) || 1;
            return slidesTraversed;
        } else {
            return _.options.slidesToScroll;
        }
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
        var _ = this;
        _.changeSlide({ data: { message: "index", index: parseInt(slide) } }, dontAnimate);
    };
    Slick.prototype.init = function (creation) {
        var _ = this;
        if (!$(_.$slider).hasClass("slick-initialized")) {
            $(_.$slider).addClass("slick-initialized");
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }
        if (creation) {
            _.$slider.trigger("init", [_]);
        }
        if (_.options.accessibility === true) {
            _.initADA();
        }
        if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
        }
    };
    Slick.prototype.initADA = function () {
        var _ = this,
            numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
            tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
                return val >= 0 && val < _.slideCount;
            });
        _.$slides
            .add(_.$slideTrack.find(".slick-cloned"))
            .attr({ "aria-hidden": "true", tabindex: "-1" })
            .find("a, input, button, select")
            .attr({ tabindex: "-1" });
        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find(".slick-cloned")).each(function (i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);
                $(this).attr({ role: "tabpanel", id: "slick-slide" + _.instanceUid + i, tabindex: -1 });
                if (slideControlIndex !== -1) {
                    var ariaButtonControl = "slick-slide-control" + _.instanceUid + slideControlIndex;
                    if ($("#" + ariaButtonControl).length) {
                        $(this).attr({ "aria-describedby": ariaButtonControl });
                    }
                }
            });
            _.$dots
                .attr("role", "tablist")
                .find("li")
                .each(function (i) {
                    var mappedSlideIndex = tabControlIndexes[i];
                    $(this).attr({ role: "presentation" });
                    $(this)
                        .find("button")
                        .first()
                        .attr({
                            role: "tab",
                            id: "slick-slide-control" + _.instanceUid + i,
                            "aria-controls": "slick-slide" + _.instanceUid + mappedSlideIndex,
                            "aria-label": i + 1 + " of " + numDotGroups,
                            "aria-selected": null,
                            tabindex: "-1",
                        });
                })
                .eq(_.currentSlide)
                .find("button")
                .attr({ "aria-selected": "true", tabindex: "0" })
                .end();
        }
        for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
            if (_.options.focusOnChange) {
                _.$slides.eq(i).attr({ tabindex: "0" });
            } else {
                _.$slides.eq(i).removeAttr("tabindex");
            }
        }
        _.activateADA();
    };
    Slick.prototype.initArrowEvents = function () {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, _.changeSlide);
            _.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow.on("keydown.slick", _.keyHandler);
                _.$nextArrow.on("keydown.slick", _.keyHandler);
            }
        }
    };
    Slick.prototype.initDotEvents = function () {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $("li", _.$dots).on("click.slick", { message: "index" }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$dots.on("keydown.slick", _.keyHandler);
            }
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
            $("li", _.$dots).on("mouseenter.slick", $.proxy(_.interrupt, _, true)).on("mouseleave.slick", $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initSlideEvents = function () {
        var _ = this;
        if (_.options.pauseOnHover) {
            _.$list.on("mouseenter.slick", $.proxy(_.interrupt, _, true));
            _.$list.on("mouseleave.slick", $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initializeEvents = function () {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.initSlideEvents();
        _.$list.on("touchstart.slick mousedown.slick", { action: "start" }, _.swipeHandler);
        _.$list.on("touchmove.slick mousemove.slick", { action: "move" }, _.swipeHandler);
        _.$list.on("touchend.slick mouseup.slick", { action: "end" }, _.swipeHandler);
        _.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, _.swipeHandler);
        _.$list.on("click.slick", _.clickHandler);
        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
        if (_.options.accessibility === true) {
            _.$list.on("keydown.slick", _.keyHandler);
        }
        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on("click.slick", _.selectHandler);
        }
        $(window).on("orientationchange.slick.slick-" + _.instanceUid, $.proxy(_.orientationChange, _));
        $(window).on("resize.slick.slick-" + _.instanceUid, $.proxy(_.resize, _));
        $("[draggable!=true]", _.$slideTrack).on("dragstart", _.preventDefault);
        $(window).on("load.slick.slick-" + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };
    Slick.prototype.initUI = function () {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$dots.show();
        }
    };
    Slick.prototype.keyHandler = function (event) {
        var _ = this;
        if (!event.target.tagName.match("TEXTAREA|INPUT|SELECT")) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({ data: { message: _.options.rtl === true ? "next" : "previous" } });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({ data: { message: _.options.rtl === true ? "previous" : "next" } });
            }
        }
    };
    Slick.prototype.lazyLoad = function () {
        var _ = this,
            loadRange,
            cloneRange,
            rangeStart,
            rangeEnd;
        function loadImages(imagesScope) {
            $("img[data-lazy]", imagesScope).each(function () {
                var image = $(this),
                    imageSource = $(this).attr("data-lazy"),
                    imageSrcSet = $(this).attr("data-srcset"),
                    imageSizes = $(this).attr("data-sizes") || _.$slider.attr("data-sizes"),
                    imageToLoad = document.createElement("img");
                imageToLoad.onload = function () {
                    image.animate({ opacity: 0 }, 100, function () {
                        if (imageSrcSet) {
                            image.attr("srcset", imageSrcSet);
                            if (imageSizes) {
                                image.attr("sizes", imageSizes);
                            }
                        }
                        image.attr("src", imageSource).animate({ opacity: 1 }, 200, function () {
                            image.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                        });
                        _.$slider.trigger("lazyLoaded", [_, image, imageSource]);
                    });
                };
                imageToLoad.onerror = function () {
                    image.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error");
                    _.$slider.trigger("lazyLoadError", [_, image, imageSource]);
                };
                imageToLoad.src = imageSource;
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find(".slick-slide").slice(rangeStart, rangeEnd);
        if (_.options.lazyLoad === "anticipated") {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find(".slick-slide");
            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find(".slick-slide");
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find(".slick-cloned").slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find(".slick-cloned").slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function () {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({ opacity: 1 });
        _.$slider.removeClass("slick-loading");
        _.initUI();
        if (_.options.lazyLoad === "progressive") {
            _.progressiveLazyLoad();
        }
    };
    Slick.prototype.next = Slick.prototype.slickNext = function () {
        var _ = this;
        _.changeSlide({ data: { message: "next" } });
    };
    Slick.prototype.orientationChange = function () {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function () {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function () {
        var _ = this;
        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };
    Slick.prototype.postSlide = function (index) {
        var _ = this;
        if (!_.unslicked) {
            _.$slider.trigger("afterChange", [_, index]);
            _.animating = false;
            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }
            _.swipeLeft = null;
            if (_.options.autoplay) {
                _.autoPlay();
            }
            if (_.options.accessibility === true) {
                _.initADA();
                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr("tabindex", 0).focus();
                }
            }
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function () {
        var _ = this;
        _.changeSlide({ data: { message: "previous" } });
    };
    Slick.prototype.preventDefault = function (event) {
        event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function (tryCount) {
        tryCount = tryCount || 1;
        var _ = this,
            $imgsToLoad = $("img[data-lazy]", _.$slider),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;
        if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr("data-lazy");
            imageSrcSet = image.attr("data-srcset");
            imageSizes = image.attr("data-sizes") || _.$slider.attr("data-sizes");
            imageToLoad = document.createElement("img");
            imageToLoad.onload = function () {
                if (imageSrcSet) {
                    image.attr("srcset", imageSrcSet);
                    if (imageSizes) {
                        image.attr("sizes", imageSizes);
                    }
                }
                image.attr("src", imageSource).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                if (_.options.adaptiveHeight === true) {
                    _.setPosition();
                }
                _.$slider.trigger("lazyLoaded", [_, image, imageSource]);
                _.progressiveLazyLoad();
            };
            imageToLoad.onerror = function () {
                if (tryCount < 3) {
                    setTimeout(function () {
                        _.progressiveLazyLoad(tryCount + 1);
                    }, 500);
                } else {
                    image.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error");
                    _.$slider.trigger("lazyLoadError", [_, image, imageSource]);
                    _.progressiveLazyLoad();
                }
            };
            imageToLoad.src = imageSource;
        } else {
            _.$slider.trigger("allImagesLoaded", [_]);
        }
    };
    Slick.prototype.refresh = function (initializing) {
        var _ = this,
            currentSlide,
            lastVisibleIndex;
        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
            _.currentSlide = lastVisibleIndex;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }
        currentSlide = _.currentSlide;
        _.destroy(true);
        $.extend(_, _.initials, { currentSlide: currentSlide });
        _.init();
        if (!initializing) {
            _.changeSlide({ data: { message: "index", index: currentSlide } }, false);
        }
    };
    Slick.prototype.registerBreakpoints = function () {
        var _ = this,
            breakpoint,
            currentBreakpoint,
            l,
            responsiveSettings = _.options.responsive || null;
        if ($.type(responsiveSettings) === "array" && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || "window";
            for (breakpoint in responsiveSettings) {
                l = _.breakpoints.length - 1;
                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                    while (l >= 0) {
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                            _.breakpoints.splice(l, 1);
                        }
                        l--;
                    }
                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }
            _.breakpoints.sort(function (a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };
    Slick.prototype.reinit = function () {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass("slick-slide");
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }
        _.registerBreakpoints();
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();
        _.checkResponsive(false, true);
        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on("click.slick", _.selectHandler);
        }
        _.setSlideClasses(typeof _.currentSlide === "number" ? _.currentSlide : 0);
        _.setPosition();
        _.focusHandler();
        _.paused = !_.options.autoplay;
        _.autoPlay();
        _.$slider.trigger("reInit", [_]);
    };
    Slick.prototype.resize = function () {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function () {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) {
                    _.setPosition();
                }
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === "boolean") {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }
        _.unload();
        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function (position) {
        var _ = this,
            positionProps = {},
            x,
            y;
        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == "left" ? Math.ceil(position) + "px" : "0px";
        y = _.positionProp == "top" ? Math.ceil(position) + "px" : "0px";
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = "translate(" + x + ", " + y + ")";
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = "translate3d(" + x + ", " + y + ", 0px)";
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function () {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({ padding: "0px " + _.options.centerPadding });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({ padding: _.options.centerPadding + " 0px" });
            }
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children(".slick-slide").length));
        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5e3 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children(".slick-slide").length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children(".slick-slide").width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function () {
        var _ = this,
            targetLeft;
        _.$slides.each(function (index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) {
                $(element).css({ position: "relative", right: targetLeft, top: 0, zIndex: _.options.zIndex - 2, opacity: 0 });
            } else {
                $(element).css({ position: "relative", left: targetLeft, top: 0, zIndex: _.options.zIndex - 2, opacity: 0 });
            }
        });
        _.$slides.eq(_.currentSlide).css({ zIndex: _.options.zIndex - 1, opacity: 1 });
    };
    Slick.prototype.setHeight = function () {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css("height", targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
        var _ = this,
            l,
            item,
            option,
            value,
            refresh = false,
            type;
        if ($.type(arguments[0]) === "object") {
            option = arguments[0];
            refresh = arguments[1];
            type = "multiple";
        } else if ($.type(arguments[0]) === "string") {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];
            if (arguments[0] === "responsive" && $.type(arguments[1]) === "array") {
                type = "responsive";
            } else if (typeof arguments[1] !== "undefined") {
                type = "single";
            }
        }
        if (type === "single") {
            _.options[option] = value;
        } else if (type === "multiple") {
            $.each(option, function (opt, val) {
                _.options[opt] = val;
            });
        } else if (type === "responsive") {
            for (item in value) {
                if ($.type(_.options.responsive) !== "array") {
                    _.options.responsive = [value[item]];
                } else {
                    l = _.options.responsive.length - 1;
                    while (l >= 0) {
                        if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
                            _.options.responsive.splice(l, 1);
                        }
                        l--;
                    }
                    _.options.responsive.push(value[item]);
                }
            }
        }
        if (refresh) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function () {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }
        _.$slider.trigger("setPosition", [_]);
    };
    Slick.prototype.setProps = function () {
        var _ = this,
            bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? "top" : "left";
        if (_.positionProp === "top") {
            _.$slider.addClass("slick-vertical");
        } else {
            _.$slider.removeClass("slick-vertical");
        }
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }
        if (_.options.fade) {
            if (typeof _.options.zIndex === "number") {
                if (_.options.zIndex < 3) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = "OTransform";
            _.transformType = "-o-transform";
            _.transitionType = "OTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = "MozTransform";
            _.transformType = "-moz-transform";
            _.transitionType = "MozTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = "webkitTransform";
            _.transformType = "-webkit-transform";
            _.transitionType = "webkitTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = "msTransform";
            _.transformType = "-ms-transform";
            _.transitionType = "msTransition";
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = "transform";
            _.transformType = "transform";
            _.transitionType = "transition";
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function (index) {
        var _ = this,
            centerOffset,
            allSlides,
            indexOffset,
            remainder;
        allSlides = _.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
        _.$slides.eq(index).addClass("slick-current");
        if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false");
                } else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false");
                }
                if (index === 0) {
                    allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass("slick-center");
                } else if (index === _.slideCount - 1) {
                    allSlides.eq(_.options.slidesToShow).addClass("slick-center");
                }
            }
            _.$slides.eq(index).addClass("slick-center");
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false");
            } else if (allSlides.length <= _.options.slidesToShow) {
                allSlides.addClass("slick-active").attr("aria-hidden", "false");
            } else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false");
                } else {
                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false");
                }
            }
        }
        if (_.options.lazyLoad === "ondemand" || _.options.lazyLoad === "anticipated") {
            _.lazyLoad();
        }
    };
    Slick.prototype.setupInfinite = function () {
        var _ = this,
            i,
            slideIndex,
            infiniteCount;
        if (_.options.fade === true) {
            _.options.centerMode = false;
        }
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }
                for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex])
                        .clone(true)
                        .attr("id", "")
                        .attr("data-slick-index", slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack)
                        .addClass("slick-cloned");
                }
                for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex])
                        .clone(true)
                        .attr("id", "")
                        .attr("data-slick-index", slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack)
                        .addClass("slick-cloned");
                }
                _.$slideTrack
                    .find(".slick-cloned")
                    .find("[id]")
                    .each(function () {
                        $(this).attr("id", "");
                    });
            }
        }
    };
    Slick.prototype.interrupt = function (toggle) {
        var _ = this;
        if (!toggle) {
            _.autoPlay();
        }
        _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function (event) {
        var _ = this;
        var targetElement = $(event.target).is(".slick-slide") ? $(event.target) : $(event.target).parents(".slick-slide");
        var index = parseInt(targetElement.attr("data-slick-index"));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
        var targetSlide,
            animSlide,
            oldSlide,
            slideLeft,
            targetLeft = null,
            _ = this,
            navTarget;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }
        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }
        if (sync === false) {
            _.asNavFor(index);
        }
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }
        if (_.options.autoplay) {
            clearInterval(_.autoPlayTimer);
        }
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }
        _.animating = true;
        _.$slider.trigger("beforeChange", [_, _.currentSlide, animSlide]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick("getSlick");
            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                navTarget.setSlideClasses(_.currentSlide);
            }
        }
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlideOut(oldSlide);
                _.fadeSlide(animSlide, function () {
                    _.postSlide(animSlide);
                });
            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function () {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }
    };
    Slick.prototype.startLoad = function () {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$dots.hide();
        }
        _.$slider.addClass("slick-loading");
    };
    Slick.prototype.swipeDirection = function () {
        var xDist,
            yDist,
            r,
            swipeAngle,
            _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round((r * 180) / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }
        if (swipeAngle <= 45 && swipeAngle >= 0) {
            return _.options.rtl === false ? "left" : "right";
        }
        if (swipeAngle <= 360 && swipeAngle >= 315) {
            return _.options.rtl === false ? "left" : "right";
        }
        if (swipeAngle >= 135 && swipeAngle <= 225) {
            return _.options.rtl === false ? "right" : "left";
        }
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) {
                return "down";
            } else {
                return "up";
            }
        }
        return "vertical";
    };
    Slick.prototype.swipeEnd = function (event) {
        var _ = this,
            slideCount,
            direction;
        _.dragging = false;
        _.swiping = false;
        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) {
            return false;
        }
        if (_.touchObject.edgeHit === true) {
            _.$slider.trigger("edge", [_, _.swipeDirection()]);
        }
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();
            switch (direction) {
                case "left":
                case "down":
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.currentDirection = 1;
                    break;
                default:
            }
            if (direction != "vertical") {
                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger("swipe", [_, direction]);
            }
        } else {
            if (_.touchObject.startX !== _.touchObject.curX) {
                _.slideHandler(_.currentSlide);
                _.touchObject = {};
            }
        }
    };
    Slick.prototype.swipeHandler = function (event) {
        var _ = this;
        if (_.options.swipe === false || ("ontouchend" in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf("mouse") !== -1) {
            return;
        }
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        }
        switch (event.data.action) {
            case "start":
                _.swipeStart(event);
                break;
            case "move":
                _.swipeMove(event);
                break;
            case "end":
                _.swipeEnd(event);
                break;
        }
    };
    Slick.prototype.swipeMove = function (event) {
        var _ = this,
            edgeWasHit = false,
            curLeft,
            swipeDirection,
            swipeLength,
            positionOffset,
            touches,
            verticalSwipeLength;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || _.scrolling || (touches && touches.length !== 1)) {
            return false;
        }
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }
        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }
        swipeDirection = _.swipeDirection();
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === "right") || (_.currentSlide >= _.getDotCount() && swipeDirection === "left")) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }
        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function (event) {
        var _ = this,
            touches;
        _.interrupted = true;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function () {
        var _ = this;
        $(".slick-cloned", _.$slider).remove();
        if (_.$dots) {
            _.$dots.remove();
        }
        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }
        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }
        _.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
    };
    Slick.prototype.unslick = function (fromBreakpoint) {
        var _ = this;
        _.$slider.trigger("unslick", [_, fromBreakpoint]);
        _.destroy();
    };
    Slick.prototype.updateArrows = function () {
        var _ = this,
            centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            _.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true");
                _.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true");
                _.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true");
                _.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            }
        }
    };
    Slick.prototype.updateDots = function () {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find("li").removeClass("slick-active").end();
            _.$dots
                .find("li")
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass("slick-active");
        }
    };
    Slick.prototype.visibility = function () {
        var _ = this;
        if (_.options.autoplay) {
            if (document[_.hidden]) {
                _.interrupted = true;
            } else {
                _.interrupted = false;
            }
        }
    };
    $.fn.slick = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == "object" || typeof opt == "undefined") _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != "undefined") return ret;
        }
        return _;
    };
});

// Instafeed Js
// Generated by CoffeeScript 1.9.3
(function () {
    var e;
    (e = (function () {
        function e(e, t) {
            var n, r;
            this.options = { target: "instafeed", get: "popular", resolution: "thumbnail", sortBy: "none", links: !0, mock: !1, useHttp: !1 };
            if (typeof e == "object") for (n in e) (r = e[n]), (this.options[n] = r);
            (this.context = t != null ? t : this), (this.unique = this._genKey());
        }
        return (
            (e.prototype.hasNext = function () {
                return typeof this.context.nextUrl == "string" && this.context.nextUrl.length > 0;
            }),
            (e.prototype.next = function () {
                return this.hasNext() ? this.run(this.context.nextUrl) : !1;
            }),
            (e.prototype.run = function (t) {
                var n, r, i;
                if (typeof this.options.clientId != "string" && typeof this.options.accessToken != "string")
                    throw new Error("Missing clientId or accessToken.");
                if (typeof this.options.accessToken != "string" && typeof this.options.clientId != "string")
                    throw new Error("Missing clientId or accessToken.");
                return (
                    this.options.before != null && typeof this.options.before == "function" && this.options.before.call(this),
                    typeof document != "undefined" &&
                        document !== null &&
                        ((i = document.createElement("script")),
                        (i.id = "instafeed-fetcher"),
                        (i.src = t || this._buildUrl()),
                        (n = document.getElementsByTagName("head")),
                        n[0].appendChild(i),
                        (r = "instafeedCache" + this.unique),
                        (window[r] = new e(this.options, this)),
                        (window[r].unique = this.unique)),
                    !0
                );
            }),
            (e.prototype.parse = function (e) {
                var t, n, r, i, s, o, u, a, f, l, c, h, p, d, v, m, g, y, b, w, E, S, x, T, N, C, k, L, A, O, M, _, D;
                if (typeof e != "object") {
                    if (this.options.error != null && typeof this.options.error == "function")
                        return this.options.error.call(this, "Invalid JSON data"), !1;
                    throw new Error("Invalid JSON response");
                }
                if (e.meta.code !== 200) {
                    if (this.options.error != null && typeof this.options.error == "function")
                        return this.options.error.call(this, e.meta.error_message), !1;
                    throw new Error("Error from Instagram: " + e.meta.error_message);
                }
                if (e.data.length === 0) {
                    if (this.options.error != null && typeof this.options.error == "function")
                        return this.options.error.call(this, "No images were returned from Instagram"), !1;
                    throw new Error("No images were returned from Instagram");
                }
                this.options.success != null && typeof this.options.success == "function" && this.options.success.call(this, e),
                    (this.context.nextUrl = ""),
                    e.pagination != null && (this.context.nextUrl = e.pagination.next_url);
                if (this.options.sortBy !== "none") {
                    this.options.sortBy === "random" ? (M = ["", "random"]) : (M = this.options.sortBy.split("-")), (O = M[0] === "least" ? !0 : !1);
                    switch (M[1]) {
                        case "random":
                            e.data.sort(function () {
                                return 0.5 - Math.random();
                            });
                            break;
                        case "recent":
                            e.data = this._sortBy(e.data, "created_time", O);
                            break;
                        case "liked":
                            e.data = this._sortBy(e.data, "likes.count", O);
                            break;
                        case "commented":
                            e.data = this._sortBy(e.data, "comments.count", O);
                            break;
                        default:
                            throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");
                    }
                }
                if (typeof document != "undefined" && document !== null && this.options.mock === !1) {
                    (m = e.data),
                        (A = parseInt(this.options.limit, 10)),
                        this.options.limit != null && m.length > A && (m = m.slice(0, A)),
                        (u = document.createDocumentFragment()),
                        this.options.filter != null && typeof this.options.filter == "function" && (m = this._filter(m, this.options.filter));
                    if (this.options.template != null && typeof this.options.template == "string") {
                        (f = ""), (d = ""), (w = ""), (D = document.createElement("div"));
                        for (c = 0, N = m.length; c < N; c++) {
                            (h = m[c]), (p = h.images[this.options.resolution]);
                            if (typeof p != "object") throw ((o = "No image found for resolution: " + this.options.resolution + "."), new Error(o));
                            (E = p.width),
                                (y = p.height),
                                (b = "square"),
                                E > y && (b = "landscape"),
                                E < y && (b = "portrait"),
                                (v = p.url),
                                (l = window.location.protocol.indexOf("http") >= 0),
                                l && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")),
                                (d = this._makeTemplate(this.options.template, {
                                    model: h,
                                    id: h.id,
                                    link: h.link,
                                    type: h.type,
                                    image: v,
                                    width: E,
                                    height: y,
                                    orientation: b,
                                    caption: this._getObjectProperty(h, "caption.text"),
                                    likes: h.likes.count,
                                    comments: h.comments.count,
                                    location: this._getObjectProperty(h, "location.name"),
                                })),
                                (f += d);
                        }
                        (D.innerHTML = f), (i = []), (r = 0), (n = D.childNodes.length);
                        while (r < n) i.push(D.childNodes[r]), (r += 1);
                        for (x = 0, C = i.length; x < C; x++) (L = i[x]), u.appendChild(L);
                    } else
                        for (T = 0, k = m.length; T < k; T++) {
                            (h = m[T]), (g = document.createElement("img")), (p = h.images[this.options.resolution]);
                            if (typeof p != "object") throw ((o = "No image found for resolution: " + this.options.resolution + "."), new Error(o));
                            (v = p.url),
                                (l = window.location.protocol.indexOf("http") >= 0),
                                l && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")),
                                (g.src = v),
                                this.options.links === !0
                                    ? ((t = document.createElement("a")), (t.href = h.link), t.appendChild(g), u.appendChild(t))
                                    : u.appendChild(g);
                        }
                    (_ = this.options.target), typeof _ == "string" && (_ = document.getElementById(_));
                    if (_ == null) throw ((o = 'No element with id="' + this.options.target + '" on page.'), new Error(o));
                    _.appendChild(u),
                        (a = document.getElementsByTagName("head")[0]),
                        a.removeChild(document.getElementById("instafeed-fetcher")),
                        (S = "instafeedCache" + this.unique),
                        (window[S] = void 0);
                    try {
                        delete window[S];
                    } catch (P) {
                        s = P;
                    }
                }
                return this.options.after != null && typeof this.options.after == "function" && this.options.after.call(this), !0;
            }),
            (e.prototype._buildUrl = function () {
                var e, t, n;
                e = "https://api.instagram.com/v1";
                switch (this.options.get) {
                    case "popular":
                        t = "media/popular";
                        break;
                    case "tagged":
                        if (!this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
                        t = "tags/" + this.options.tagName + "/media/recent";
                        break;
                    case "location":
                        if (!this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");
                        t = "locations/" + this.options.locationId + "/media/recent";
                        break;
                    case "user":
                        if (!this.options.userId) throw new Error("No user specified. Use the 'userId' option.");
                        t = "users/" + this.options.userId + "/media/recent";
                        break;
                    default:
                        throw new Error("Invalid option for get: '" + this.options.get + "'.");
                }
                return (
                    (n = e + "/" + t),
                    this.options.accessToken != null
                        ? (n += "?access_token=" + this.options.accessToken)
                        : (n += "?client_id=" + this.options.clientId),
                    this.options.limit != null && (n += "&count=" + this.options.limit),
                    (n += "&callback=instafeedCache" + this.unique + ".parse"),
                    n
                );
            }),
            (e.prototype._genKey = function () {
                var e;
                return (
                    (e = function () {
                        return (((1 + Math.random()) * 65536) | 0).toString(16).substring(1);
                    }),
                    "" + e() + e() + e() + e()
                );
            }),
            (e.prototype._makeTemplate = function (e, t) {
                var n, r, i, s, o;
                (r = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/), (n = e);
                while (r.test(n))
                    (s = n.match(r)[1]),
                        (o = (i = this._getObjectProperty(t, s)) != null ? i : ""),
                        (n = n.replace(r, function () {
                            return "" + o;
                        }));
                return n;
            }),
            (e.prototype._getObjectProperty = function (e, t) {
                var n, r;
                (t = t.replace(/\[(\w+)\]/g, ".$1")), (r = t.split("."));
                while (r.length) {
                    n = r.shift();
                    if (!(e != null && n in e)) return null;
                    e = e[n];
                }
                return e;
            }),
            (e.prototype._sortBy = function (e, t, n) {
                var r;
                return (
                    (r = function (e, r) {
                        var i, s;
                        return (i = this._getObjectProperty(e, t)), (s = this._getObjectProperty(r, t)), n ? (i > s ? 1 : -1) : i < s ? 1 : -1;
                    }),
                    e.sort(r.bind(this)),
                    e
                );
            }),
            (e.prototype._filter = function (e, t) {
                var n, r, i, s, o;
                (n = []),
                    (r = function (e) {
                        if (t(e)) return n.push(e);
                    });
                for (i = 0, o = e.length; i < o; i++) (s = e[i]), r(s);
                return n;
            }),
            e
        );
    })()),
        (function (e, t) {
            return typeof define == "function" && define.amd
                ? define([], t)
                : typeof module == "object" && module.exports
                ? (module.exports = t())
                : (e.Instafeed = t());
        })(this, function () {
            return e;
        });
}.call(this));

/**!
handlebars v4.7.6
Copyright (C) 2011-2019 by Yehuda Katz
*/
!(function (a, b) {
    "object" == typeof exports && "object" == typeof module
        ? (module.exports = b())
        : "function" == typeof define && define.amd
        ? define([], b)
        : "object" == typeof exports
        ? (exports.Handlebars = b())
        : (a.Handlebars = b());
})(this, function () {
    return (function (a) {
        function b(d) {
            if (c[d]) return c[d].exports;
            var e = (c[d] = { exports: {}, id: d, loaded: !1 });
            return a[d].call(e.exports, e, e.exports, b), (e.loaded = !0), e.exports;
        }
        var c = {};
        return (b.m = a), (b.c = c), (b.p = ""), b(0);
    })([
        function (a, b, c) {
            "use strict";
            function d() {
                var a = r();
                return (
                    (a.compile = function (b, c) {
                        return k.compile(b, c, a);
                    }),
                    (a.precompile = function (b, c) {
                        return k.precompile(b, c, a);
                    }),
                    (a.AST = i["default"]),
                    (a.Compiler = k.Compiler),
                    (a.JavaScriptCompiler = m["default"]),
                    (a.Parser = j.parser),
                    (a.parse = j.parse),
                    (a.parseWithoutProcessing = j.parseWithoutProcessing),
                    a
                );
            }
            var e = c(1)["default"];
            b.__esModule = !0;
            var f = c(2),
                g = e(f),
                h = c(45),
                i = e(h),
                j = c(46),
                k = c(51),
                l = c(52),
                m = e(l),
                n = c(49),
                o = e(n),
                p = c(44),
                q = e(p),
                r = g["default"].create,
                s = d();
            (s.create = d), q["default"](s), (s.Visitor = o["default"]), (s["default"] = s), (b["default"] = s), (a.exports = b["default"]);
        },
        function (a, b) {
            "use strict";
            (b["default"] = function (a) {
                return a && a.__esModule ? a : { default: a };
            }),
                (b.__esModule = !0);
        },
        function (a, b, c) {
            "use strict";
            function d() {
                var a = new h.HandlebarsEnvironment();
                return (
                    n.extend(a, h),
                    (a.SafeString = j["default"]),
                    (a.Exception = l["default"]),
                    (a.Utils = n),
                    (a.escapeExpression = n.escapeExpression),
                    (a.VM = p),
                    (a.template = function (b) {
                        return p.template(b, a);
                    }),
                    a
                );
            }
            var e = c(3)["default"],
                f = c(1)["default"];
            b.__esModule = !0;
            var g = c(4),
                h = e(g),
                i = c(37),
                j = f(i),
                k = c(6),
                l = f(k),
                m = c(5),
                n = e(m),
                o = c(38),
                p = e(o),
                q = c(44),
                r = f(q),
                s = d();
            (s.create = d), r["default"](s), (s["default"] = s), (b["default"] = s), (a.exports = b["default"]);
        },
        function (a, b) {
            "use strict";
            (b["default"] = function (a) {
                if (a && a.__esModule) return a;
                var b = {};
                if (null != a) for (var c in a) Object.prototype.hasOwnProperty.call(a, c) && (b[c] = a[c]);
                return (b["default"] = a), b;
            }),
                (b.__esModule = !0);
        },
        function (a, b, c) {
            "use strict";
            function d(a, b, c) {
                (this.helpers = a || {}),
                    (this.partials = b || {}),
                    (this.decorators = c || {}),
                    i.registerDefaultHelpers(this),
                    j.registerDefaultDecorators(this);
            }
            var e = c(1)["default"];
            (b.__esModule = !0), (b.HandlebarsEnvironment = d);
            var f = c(5),
                g = c(6),
                h = e(g),
                i = c(10),
                j = c(30),
                k = c(32),
                l = e(k),
                m = c(33),
                n = "4.7.6";
            b.VERSION = n;
            var o = 8;
            b.COMPILER_REVISION = o;
            var p = 7;
            b.LAST_COMPATIBLE_COMPILER_REVISION = p;
            var q = {
                1: "<= 1.0.rc.2",
                2: "== 1.0.0-rc.3",
                3: "== 1.0.0-rc.4",
                4: "== 1.x.x",
                5: "== 2.0.0-alpha.x",
                6: ">= 2.0.0-beta.1",
                7: ">= 4.0.0 <4.3.0",
                8: ">= 4.3.0",
            };
            b.REVISION_CHANGES = q;
            var r = "[object Object]";
            d.prototype = {
                constructor: d,
                logger: l["default"],
                log: l["default"].log,
                registerHelper: function (a, b) {
                    if (f.toString.call(a) === r) {
                        if (b) throw new h["default"]("Arg not supported with multiple helpers");
                        f.extend(this.helpers, a);
                    } else this.helpers[a] = b;
                },
                unregisterHelper: function (a) {
                    delete this.helpers[a];
                },
                registerPartial: function (a, b) {
                    if (f.toString.call(a) === r) f.extend(this.partials, a);
                    else {
                        if ("undefined" == typeof b) throw new h["default"]('Attempting to register a partial called "' + a + '" as undefined');
                        this.partials[a] = b;
                    }
                },
                unregisterPartial: function (a) {
                    delete this.partials[a];
                },
                registerDecorator: function (a, b) {
                    if (f.toString.call(a) === r) {
                        if (b) throw new h["default"]("Arg not supported with multiple decorators");
                        f.extend(this.decorators, a);
                    } else this.decorators[a] = b;
                },
                unregisterDecorator: function (a) {
                    delete this.decorators[a];
                },
                resetLoggedPropertyAccesses: function () {
                    m.resetLoggedProperties();
                },
            };
            var s = l["default"].log;
            (b.log = s), (b.createFrame = f.createFrame), (b.logger = l["default"]);
        },
        function (a, b) {
            "use strict";
            function c(a) {
                return k[a];
            }
            function d(a) {
                for (var b = 1; b < arguments.length; b++)
                    for (var c in arguments[b]) Object.prototype.hasOwnProperty.call(arguments[b], c) && (a[c] = arguments[b][c]);
                return a;
            }
            function e(a, b) {
                for (var c = 0, d = a.length; c < d; c++) if (a[c] === b) return c;
                return -1;
            }
            function f(a) {
                if ("string" != typeof a) {
                    if (a && a.toHTML) return a.toHTML();
                    if (null == a) return "";
                    if (!a) return a + "";
                    a = "" + a;
                }
                return m.test(a) ? a.replace(l, c) : a;
            }
            function g(a) {
                return (!a && 0 !== a) || !(!p(a) || 0 !== a.length);
            }
            function h(a) {
                var b = d({}, a);
                return (b._parent = a), b;
            }
            function i(a, b) {
                return (a.path = b), a;
            }
            function j(a, b) {
                return (a ? a + "." : "") + b;
            }
            (b.__esModule = !0),
                (b.extend = d),
                (b.indexOf = e),
                (b.escapeExpression = f),
                (b.isEmpty = g),
                (b.createFrame = h),
                (b.blockParams = i),
                (b.appendContextPath = j);
            var k = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;", "=": "&#x3D;" },
                l = /[&<>"'`=]/g,
                m = /[&<>"'`=]/,
                n = Object.prototype.toString;
            b.toString = n;
            var o = function (a) {
                return "function" == typeof a;
            };
            o(/x/) &&
                (b.isFunction = o = function (a) {
                    return "function" == typeof a && "[object Function]" === n.call(a);
                }),
                (b.isFunction = o);
            var p =
                Array.isArray ||
                function (a) {
                    return !(!a || "object" != typeof a) && "[object Array]" === n.call(a);
                };
            b.isArray = p;
        },
        function (a, b, c) {
            "use strict";
            function d(a, b) {
                var c = b && b.loc,
                    g = void 0,
                    h = void 0,
                    i = void 0,
                    j = void 0;
                c && ((g = c.start.line), (h = c.end.line), (i = c.start.column), (j = c.end.column), (a += " - " + g + ":" + i));
                for (var k = Error.prototype.constructor.call(this, a), l = 0; l < f.length; l++) this[f[l]] = k[f[l]];
                Error.captureStackTrace && Error.captureStackTrace(this, d);
                try {
                    c &&
                        ((this.lineNumber = g),
                        (this.endLineNumber = h),
                        e
                            ? (Object.defineProperty(this, "column", { value: i, enumerable: !0 }),
                              Object.defineProperty(this, "endColumn", { value: j, enumerable: !0 }))
                            : ((this.column = i), (this.endColumn = j)));
                } catch (m) {}
            }
            var e = c(7)["default"];
            b.__esModule = !0;
            var f = ["description", "fileName", "lineNumber", "endLineNumber", "message", "name", "number", "stack"];
            (d.prototype = new Error()), (b["default"] = d), (a.exports = b["default"]);
        },
        function (a, b, c) {
            a.exports = { default: c(8), __esModule: !0 };
        },
        function (a, b, c) {
            var d = c(9);
            a.exports = function (a, b, c) {
                return d.setDesc(a, b, c);
            };
        },
        function (a, b) {
            var c = Object;
            a.exports = {
                create: c.create,
                getProto: c.getPrototypeOf,
                isEnum: {}.propertyIsEnumerable,
                getDesc: c.getOwnPropertyDescriptor,
                setDesc: c.defineProperty,
                setDescs: c.defineProperties,
                getKeys: c.keys,
                getNames: c.getOwnPropertyNames,
                getSymbols: c.getOwnPropertySymbols,
                each: [].forEach,
            };
        },
        function (a, b, c) {
            "use strict";
            function d(a) {
                h["default"](a), j["default"](a), l["default"](a), n["default"](a), p["default"](a), r["default"](a), t["default"](a);
            }
            function e(a, b, c) {
                a.helpers[b] && ((a.hooks[b] = a.helpers[b]), c || delete a.helpers[b]);
            }
            var f = c(1)["default"];
            (b.__esModule = !0), (b.registerDefaultHelpers = d), (b.moveHelperToHooks = e);
            var g = c(11),
                h = f(g),
                i = c(12),
                j = f(i),
                k = c(25),
                l = f(k),
                m = c(26),
                n = f(m),
                o = c(27),
                p = f(o),
                q = c(28),
                r = f(q),
                s = c(29),
                t = f(s);
        },
        function (a, b, c) {
            "use strict";
            b.__esModule = !0;
            var d = c(5);
            (b["default"] = function (a) {
                a.registerHelper("blockHelperMissing", function (b, c) {
                    var e = c.inverse,
                        f = c.fn;
                    if (b === !0) return f(this);
                    if (b === !1 || null == b) return e(this);
                    if (d.isArray(b)) return b.length > 0 ? (c.ids && (c.ids = [c.name]), a.helpers.each(b, c)) : e(this);
                    if (c.data && c.ids) {
                        var g = d.createFrame(c.data);
                        (g.contextPath = d.appendContextPath(c.data.contextPath, c.name)), (c = { data: g });
                    }
                    return f(b, c);
                });
            }),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            (function (d) {
                "use strict";
                var e = c(13)["default"],
                    f = c(1)["default"];
                b.__esModule = !0;
                var g = c(5),
                    h = c(6),
                    i = f(h);
                (b["default"] = function (a) {
                    a.registerHelper("each", function (a, b) {
                        function c(b, c, d) {
                            l && ((l.key = b), (l.index = c), (l.first = 0 === c), (l.last = !!d), m && (l.contextPath = m + b)),
                                (k += f(a[b], { data: l, blockParams: g.blockParams([a[b], b], [m + b, null]) }));
                        }
                        if (!b) throw new i["default"]("Must pass iterator to #each");
                        var f = b.fn,
                            h = b.inverse,
                            j = 0,
                            k = "",
                            l = void 0,
                            m = void 0;
                        if (
                            (b.data && b.ids && (m = g.appendContextPath(b.data.contextPath, b.ids[0]) + "."),
                            g.isFunction(a) && (a = a.call(this)),
                            b.data && (l = g.createFrame(b.data)),
                            a && "object" == typeof a)
                        )
                            if (g.isArray(a)) for (var n = a.length; j < n; j++) j in a && c(j, j, j === a.length - 1);
                            else if (d.Symbol && a[d.Symbol.iterator]) {
                                for (var o = [], p = a[d.Symbol.iterator](), q = p.next(); !q.done; q = p.next()) o.push(q.value);
                                a = o;
                                for (var n = a.length; j < n; j++) c(j, j, j === a.length - 1);
                            } else
                                !(function () {
                                    var b = void 0;
                                    e(a).forEach(function (a) {
                                        void 0 !== b && c(b, j - 1), (b = a), j++;
                                    }),
                                        void 0 !== b && c(b, j - 1, !0);
                                })();
                        return 0 === j && (k = h(this)), k;
                    });
                }),
                    (a.exports = b["default"]);
            }.call(
                b,
                (function () {
                    return this;
                })()
            ));
        },
        function (a, b, c) {
            a.exports = { default: c(14), __esModule: !0 };
        },
        function (a, b, c) {
            c(15), (a.exports = c(21).Object.keys);
        },
        function (a, b, c) {
            var d = c(16);
            c(18)("keys", function (a) {
                return function (b) {
                    return a(d(b));
                };
            });
        },
        function (a, b, c) {
            var d = c(17);
            a.exports = function (a) {
                return Object(d(a));
            };
        },
        function (a, b) {
            a.exports = function (a) {
                if (void 0 == a) throw TypeError("Can't call method on  " + a);
                return a;
            };
        },
        function (a, b, c) {
            var d = c(19),
                e = c(21),
                f = c(24);
            a.exports = function (a, b) {
                var c = (e.Object || {})[a] || Object[a],
                    g = {};
                (g[a] = b(c)),
                    d(
                        d.S +
                            d.F *
                                f(function () {
                                    c(1);
                                }),
                        "Object",
                        g
                    );
            };
        },
        function (a, b, c) {
            var d = c(20),
                e = c(21),
                f = c(22),
                g = "prototype",
                h = function (a, b, c) {
                    var i,
                        j,
                        k,
                        l = a & h.F,
                        m = a & h.G,
                        n = a & h.S,
                        o = a & h.P,
                        p = a & h.B,
                        q = a & h.W,
                        r = m ? e : e[b] || (e[b] = {}),
                        s = m ? d : n ? d[b] : (d[b] || {})[g];
                    m && (c = b);
                    for (i in c)
                        (j = !l && s && i in s),
                            (j && i in r) ||
                                ((k = j ? s[i] : c[i]),
                                (r[i] =
                                    m && "function" != typeof s[i]
                                        ? c[i]
                                        : p && j
                                        ? f(k, d)
                                        : q && s[i] == k
                                        ? (function (a) {
                                              var b = function (b) {
                                                  return this instanceof a ? new a(b) : a(b);
                                              };
                                              return (b[g] = a[g]), b;
                                          })(k)
                                        : o && "function" == typeof k
                                        ? f(Function.call, k)
                                        : k),
                                o && ((r[g] || (r[g] = {}))[i] = k));
                };
            (h.F = 1), (h.G = 2), (h.S = 4), (h.P = 8), (h.B = 16), (h.W = 32), (a.exports = h);
        },
        function (a, b) {
            var c = (a.exports =
                "undefined" != typeof window && window.Math == Math
                    ? window
                    : "undefined" != typeof self && self.Math == Math
                    ? self
                    : Function("return this")());
            "number" == typeof __g && (__g = c);
        },
        function (a, b) {
            var c = (a.exports = { version: "1.2.6" });
            "number" == typeof __e && (__e = c);
        },
        function (a, b, c) {
            var d = c(23);
            a.exports = function (a, b, c) {
                if ((d(a), void 0 === b)) return a;
                switch (c) {
                    case 1:
                        return function (c) {
                            return a.call(b, c);
                        };
                    case 2:
                        return function (c, d) {
                            return a.call(b, c, d);
                        };
                    case 3:
                        return function (c, d, e) {
                            return a.call(b, c, d, e);
                        };
                }
                return function () {
                    return a.apply(b, arguments);
                };
            };
        },
        function (a, b) {
            a.exports = function (a) {
                if ("function" != typeof a) throw TypeError(a + " is not a function!");
                return a;
            };
        },
        function (a, b) {
            a.exports = function (a) {
                try {
                    return !!a();
                } catch (b) {
                    return !0;
                }
            };
        },
        function (a, b, c) {
            "use strict";
            var d = c(1)["default"];
            b.__esModule = !0;
            var e = c(6),
                f = d(e);
            (b["default"] = function (a) {
                a.registerHelper("helperMissing", function () {
                    if (1 !== arguments.length) throw new f["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"');
                });
            }),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            var d = c(1)["default"];
            b.__esModule = !0;
            var e = c(5),
                f = c(6),
                g = d(f);
            (b["default"] = function (a) {
                a.registerHelper("if", function (a, b) {
                    if (2 != arguments.length) throw new g["default"]("#if requires exactly one argument");
                    return e.isFunction(a) && (a = a.call(this)), (!b.hash.includeZero && !a) || e.isEmpty(a) ? b.inverse(this) : b.fn(this);
                }),
                    a.registerHelper("unless", function (b, c) {
                        if (2 != arguments.length) throw new g["default"]("#unless requires exactly one argument");
                        return a.helpers["if"].call(this, b, { fn: c.inverse, inverse: c.fn, hash: c.hash });
                    });
            }),
                (a.exports = b["default"]);
        },
        function (a, b) {
            "use strict";
            (b.__esModule = !0),
                (b["default"] = function (a) {
                    a.registerHelper("log", function () {
                        for (var b = [void 0], c = arguments[arguments.length - 1], d = 0; d < arguments.length - 1; d++) b.push(arguments[d]);
                        var e = 1;
                        null != c.hash.level ? (e = c.hash.level) : c.data && null != c.data.level && (e = c.data.level),
                            (b[0] = e),
                            a.log.apply(a, b);
                    });
                }),
                (a.exports = b["default"]);
        },
        function (a, b) {
            "use strict";
            (b.__esModule = !0),
                (b["default"] = function (a) {
                    a.registerHelper("lookup", function (a, b, c) {
                        return a ? c.lookupProperty(a, b) : a;
                    });
                }),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            var d = c(1)["default"];
            b.__esModule = !0;
            var e = c(5),
                f = c(6),
                g = d(f);
            (b["default"] = function (a) {
                a.registerHelper("with", function (a, b) {
                    if (2 != arguments.length) throw new g["default"]("#with requires exactly one argument");
                    e.isFunction(a) && (a = a.call(this));
                    var c = b.fn;
                    if (e.isEmpty(a)) return b.inverse(this);
                    var d = b.data;
                    return (
                        b.data && b.ids && ((d = e.createFrame(b.data)), (d.contextPath = e.appendContextPath(b.data.contextPath, b.ids[0]))),
                        c(a, { data: d, blockParams: e.blockParams([a], [d && d.contextPath]) })
                    );
                });
            }),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            function d(a) {
                g["default"](a);
            }
            var e = c(1)["default"];
            (b.__esModule = !0), (b.registerDefaultDecorators = d);
            var f = c(31),
                g = e(f);
        },
        function (a, b, c) {
            "use strict";
            b.__esModule = !0;
            var d = c(5);
            (b["default"] = function (a) {
                a.registerDecorator("inline", function (a, b, c, e) {
                    var f = a;
                    return (
                        b.partials ||
                            ((b.partials = {}),
                            (f = function (e, f) {
                                var g = c.partials;
                                c.partials = d.extend({}, g, b.partials);
                                var h = a(e, f);
                                return (c.partials = g), h;
                            })),
                        (b.partials[e.args[0]] = e.fn),
                        f
                    );
                });
            }),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            b.__esModule = !0;
            var d = c(5),
                e = {
                    methodMap: ["debug", "info", "warn", "error"],
                    level: "info",
                    lookupLevel: function (a) {
                        if ("string" == typeof a) {
                            var b = d.indexOf(e.methodMap, a.toLowerCase());
                            a = b >= 0 ? b : parseInt(a, 10);
                        }
                        return a;
                    },
                    log: function (a) {
                        if (((a = e.lookupLevel(a)), "undefined" != typeof console && e.lookupLevel(e.level) <= a)) {
                            var b = e.methodMap[a];
                            console[b] || (b = "log");
                            for (var c = arguments.length, d = Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++) d[f - 1] = arguments[f];
                            console[b].apply(console, d);
                        }
                    },
                };
            (b["default"] = e), (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            function d(a) {
                var b = i(null);
                (b.constructor = !1), (b.__defineGetter__ = !1), (b.__defineSetter__ = !1), (b.__lookupGetter__ = !1);
                var c = i(null);
                return (
                    (c.__proto__ = !1),
                    {
                        properties: {
                            whitelist: l.createNewLookupObject(c, a.allowedProtoProperties),
                            defaultValue: a.allowProtoPropertiesByDefault,
                        },
                        methods: { whitelist: l.createNewLookupObject(b, a.allowedProtoMethods), defaultValue: a.allowProtoMethodsByDefault },
                    }
                );
            }
            function e(a, b, c) {
                return "function" == typeof a ? f(b.methods, c) : f(b.properties, c);
            }
            function f(a, b) {
                return void 0 !== a.whitelist[b] ? a.whitelist[b] === !0 : void 0 !== a.defaultValue ? a.defaultValue : (g(b), !1);
            }
            function g(a) {
                o[a] !== !0 &&
                    ((o[a] = !0),
                    n.log(
                        "error",
                        'Handlebars: Access has been denied to resolve the property "' +
                            a +
                            '" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'
                    ));
            }
            function h() {
                j(o).forEach(function (a) {
                    delete o[a];
                });
            }
            var i = c(34)["default"],
                j = c(13)["default"],
                k = c(3)["default"];
            (b.__esModule = !0), (b.createProtoAccessControl = d), (b.resultIsAllowed = e), (b.resetLoggedProperties = h);
            var l = c(36),
                m = c(32),
                n = k(m),
                o = i(null);
        },
        function (a, b, c) {
            a.exports = { default: c(35), __esModule: !0 };
        },
        function (a, b, c) {
            var d = c(9);
            a.exports = function (a, b) {
                return d.create(a, b);
            };
        },
        function (a, b, c) {
            "use strict";
            function d() {
                for (var a = arguments.length, b = Array(a), c = 0; c < a; c++) b[c] = arguments[c];
                return f.extend.apply(void 0, [e(null)].concat(b));
            }
            var e = c(34)["default"];
            (b.__esModule = !0), (b.createNewLookupObject = d);
            var f = c(5);
        },
        function (a, b) {
            "use strict";
            function c(a) {
                this.string = a;
            }
            (b.__esModule = !0),
                (c.prototype.toString = c.prototype.toHTML = function () {
                    return "" + this.string;
                }),
                (b["default"] = c),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            function d(a) {
                var b = (a && a[0]) || 1,
                    c = v.COMPILER_REVISION;
                if (!(b >= v.LAST_COMPATIBLE_COMPILER_REVISION && b <= v.COMPILER_REVISION)) {
                    if (b < v.LAST_COMPATIBLE_COMPILER_REVISION) {
                        var d = v.REVISION_CHANGES[c],
                            e = v.REVISION_CHANGES[b];
                        throw new u["default"](
                            "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
                                d +
                                ") or downgrade your runtime to an older version (" +
                                e +
                                ")."
                        );
                    }
                    throw new u["default"](
                        "Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" +
                            a[1] +
                            ")."
                    );
                }
            }
            function e(a, b) {
                function c(c, d, e) {
                    e.hash && ((d = s.extend({}, d, e.hash)), e.ids && (e.ids[0] = !0)), (c = b.VM.resolvePartial.call(this, c, d, e));
                    var f = s.extend({}, e, { hooks: this.hooks, protoAccessControl: this.protoAccessControl }),
                        g = b.VM.invokePartial.call(this, c, d, f);
                    if (
                        (null == g && b.compile && ((e.partials[e.name] = b.compile(c, a.compilerOptions, b)), (g = e.partials[e.name](d, f))),
                        null != g)
                    ) {
                        if (e.indent) {
                            for (var h = g.split("\n"), i = 0, j = h.length; i < j && (h[i] || i + 1 !== j); i++) h[i] = e.indent + h[i];
                            g = h.join("\n");
                        }
                        return g;
                    }
                    throw new u["default"]("The partial " + e.name + " could not be compiled when running in runtime-only mode");
                }
                function d(b) {
                    function c(b) {
                        return "" + a.main(g, b, g.helpers, g.partials, f, i, h);
                    }
                    var e = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                        f = e.data;
                    d._setup(e), !e.partial && a.useData && (f = j(b, f));
                    var h = void 0,
                        i = a.useBlockParams ? [] : void 0;
                    return (
                        a.useDepths && (h = e.depths ? (b != e.depths[0] ? [b].concat(e.depths) : e.depths) : [b]),
                        (c = k(a.main, c, g, e.depths || [], f, i))(b, e)
                    );
                }
                if (!b) throw new u["default"]("No environment passed to template");
                if (!a || !a.main) throw new u["default"]("Unknown template object: " + typeof a);
                (a.main.decorator = a.main_d), b.VM.checkRevision(a.compiler);
                var e = a.compiler && 7 === a.compiler[0],
                    g = {
                        strict: function (a, b, c) {
                            if (!(a && b in a)) throw new u["default"]('"' + b + '" not defined in ' + a, { loc: c });
                            return a[b];
                        },
                        lookupProperty: function (a, b) {
                            var c = a[b];
                            return null == c
                                ? c
                                : Object.prototype.hasOwnProperty.call(a, b)
                                ? c
                                : y.resultIsAllowed(c, g.protoAccessControl, b)
                                ? c
                                : void 0;
                        },
                        lookup: function (a, b) {
                            for (var c = a.length, d = 0; d < c; d++) {
                                var e = a[d] && g.lookupProperty(a[d], b);
                                if (null != e) return a[d][b];
                            }
                        },
                        lambda: function (a, b) {
                            return "function" == typeof a ? a.call(b) : a;
                        },
                        escapeExpression: s.escapeExpression,
                        invokePartial: c,
                        fn: function (b) {
                            var c = a[b];
                            return (c.decorator = a[b + "_d"]), c;
                        },
                        programs: [],
                        program: function (a, b, c, d, e) {
                            var g = this.programs[a],
                                h = this.fn(a);
                            return b || e || d || c ? (g = f(this, a, h, b, c, d, e)) : g || (g = this.programs[a] = f(this, a, h)), g;
                        },
                        data: function (a, b) {
                            for (; a && b--; ) a = a._parent;
                            return a;
                        },
                        mergeIfNeeded: function (a, b) {
                            var c = a || b;
                            return a && b && a !== b && (c = s.extend({}, b, a)), c;
                        },
                        nullContext: n({}),
                        noop: b.VM.noop,
                        compilerInfo: a.compiler,
                    };
                return (
                    (d.isTop = !0),
                    (d._setup = function (c) {
                        if (c.partial)
                            (g.protoAccessControl = c.protoAccessControl),
                                (g.helpers = c.helpers),
                                (g.partials = c.partials),
                                (g.decorators = c.decorators),
                                (g.hooks = c.hooks);
                        else {
                            var d = s.extend({}, b.helpers, c.helpers);
                            l(d, g),
                                (g.helpers = d),
                                a.usePartial && (g.partials = g.mergeIfNeeded(c.partials, b.partials)),
                                (a.usePartial || a.useDecorators) && (g.decorators = s.extend({}, b.decorators, c.decorators)),
                                (g.hooks = {}),
                                (g.protoAccessControl = y.createProtoAccessControl(c));
                            var f = c.allowCallsToHelperMissing || e;
                            w.moveHelperToHooks(g, "helperMissing", f), w.moveHelperToHooks(g, "blockHelperMissing", f);
                        }
                    }),
                    (d._child = function (b, c, d, e) {
                        if (a.useBlockParams && !d) throw new u["default"]("must pass block params");
                        if (a.useDepths && !e) throw new u["default"]("must pass parent depths");
                        return f(g, b, a[b], c, 0, d, e);
                    }),
                    d
                );
            }
            function f(a, b, c, d, e, f, g) {
                function h(b) {
                    var e = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                        h = g;
                    return (
                        !g || b == g[0] || (b === a.nullContext && null === g[0]) || (h = [b].concat(g)),
                        c(a, b, a.helpers, a.partials, e.data || d, f && [e.blockParams].concat(f), h)
                    );
                }
                return (h = k(c, h, a, g, d, f)), (h.program = b), (h.depth = g ? g.length : 0), (h.blockParams = e || 0), h;
            }
            function g(a, b, c) {
                return (
                    a
                        ? a.call || c.name || ((c.name = a), (a = c.partials[a]))
                        : (a = "@partial-block" === c.name ? c.data["partial-block"] : c.partials[c.name]),
                    a
                );
            }
            function h(a, b, c) {
                var d = c.data && c.data["partial-block"];
                (c.partial = !0), c.ids && (c.data.contextPath = c.ids[0] || c.data.contextPath);
                var e = void 0;
                if (
                    (c.fn &&
                        c.fn !== i &&
                        !(function () {
                            c.data = v.createFrame(c.data);
                            var a = c.fn;
                            (e = c.data["partial-block"] = function (b) {
                                var c = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
                                return (c.data = v.createFrame(c.data)), (c.data["partial-block"] = d), a(b, c);
                            }),
                                a.partials && (c.partials = s.extend({}, c.partials, a.partials));
                        })(),
                    void 0 === a && e && (a = e),
                    void 0 === a)
                )
                    throw new u["default"]("The partial " + c.name + " could not be found");
                if (a instanceof Function) return a(b, c);
            }
            function i() {
                return "";
            }
            function j(a, b) {
                return (b && "root" in b) || ((b = b ? v.createFrame(b) : {}), (b.root = a)), b;
            }
            function k(a, b, c, d, e, f) {
                if (a.decorator) {
                    var g = {};
                    (b = a.decorator(b, g, c, d && d[0], e, f, d)), s.extend(b, g);
                }
                return b;
            }
            function l(a, b) {
                o(a).forEach(function (c) {
                    var d = a[c];
                    a[c] = m(d, b);
                });
            }
            function m(a, b) {
                var c = b.lookupProperty;
                return x.wrapHelper(a, function (a) {
                    return s.extend({ lookupProperty: c }, a);
                });
            }
            var n = c(39)["default"],
                o = c(13)["default"],
                p = c(3)["default"],
                q = c(1)["default"];
            (b.__esModule = !0),
                (b.checkRevision = d),
                (b.template = e),
                (b.wrapProgram = f),
                (b.resolvePartial = g),
                (b.invokePartial = h),
                (b.noop = i);
            var r = c(5),
                s = p(r),
                t = c(6),
                u = q(t),
                v = c(4),
                w = c(10),
                x = c(43),
                y = c(33);
        },
        function (a, b, c) {
            a.exports = { default: c(40), __esModule: !0 };
        },
        function (a, b, c) {
            c(41), (a.exports = c(21).Object.seal);
        },
        function (a, b, c) {
            var d = c(42);
            c(18)("seal", function (a) {
                return function (b) {
                    return a && d(b) ? a(b) : b;
                };
            });
        },
        function (a, b) {
            a.exports = function (a) {
                return "object" == typeof a ? null !== a : "function" == typeof a;
            };
        },
        function (a, b) {
            "use strict";
            function c(a, b) {
                if ("function" != typeof a) return a;
                var c = function () {
                    var c = arguments[arguments.length - 1];
                    return (arguments[arguments.length - 1] = b(c)), a.apply(this, arguments);
                };
                return c;
            }
            (b.__esModule = !0), (b.wrapHelper = c);
        },
        function (a, b) {
            (function (c) {
                "use strict";
                (b.__esModule = !0),
                    (b["default"] = function (a) {
                        var b = "undefined" != typeof c ? c : window,
                            d = b.Handlebars;
                        a.noConflict = function () {
                            return b.Handlebars === a && (b.Handlebars = d), a;
                        };
                    }),
                    (a.exports = b["default"]);
            }.call(
                b,
                (function () {
                    return this;
                })()
            ));
        },
        function (a, b) {
            "use strict";
            b.__esModule = !0;
            var c = {
                helpers: {
                    helperExpression: function (a) {
                        return (
                            "SubExpression" === a.type ||
                            (("MustacheStatement" === a.type || "BlockStatement" === a.type) && !!((a.params && a.params.length) || a.hash))
                        );
                    },
                    scopedId: function (a) {
                        return /^\.|this\b/.test(a.original);
                    },
                    simpleId: function (a) {
                        return 1 === a.parts.length && !c.helpers.scopedId(a) && !a.depth;
                    },
                },
            };
            (b["default"] = c), (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            function d(a, b) {
                if ("Program" === a.type) return a;
                (i["default"].yy = o),
                    (o.locInfo = function (a) {
                        return new o.SourceLocation(b && b.srcName, a);
                    });
                var c = i["default"].parse(a);
                return c;
            }
            function e(a, b) {
                var c = d(a, b),
                    e = new k["default"](b);
                return e.accept(c);
            }
            var f = c(1)["default"],
                g = c(3)["default"];
            (b.__esModule = !0), (b.parseWithoutProcessing = d), (b.parse = e);
            var h = c(47),
                i = f(h),
                j = c(48),
                k = f(j),
                l = c(50),
                m = g(l),
                n = c(5);
            b.parser = i["default"];
            var o = {};
            n.extend(o, m);
        },
        function (a, b) {
            "use strict";
            b.__esModule = !0;
            var c = (function () {
                function a() {
                    this.yy = {};
                }
                var b = {
                        trace: function () {},
                        yy: {},
                        symbols_: {
                            error: 2,
                            root: 3,
                            program: 4,
                            EOF: 5,
                            program_repetition0: 6,
                            statement: 7,
                            mustache: 8,
                            block: 9,
                            rawBlock: 10,
                            partial: 11,
                            partialBlock: 12,
                            content: 13,
                            COMMENT: 14,
                            CONTENT: 15,
                            openRawBlock: 16,
                            rawBlock_repetition0: 17,
                            END_RAW_BLOCK: 18,
                            OPEN_RAW_BLOCK: 19,
                            helperName: 20,
                            openRawBlock_repetition0: 21,
                            openRawBlock_option0: 22,
                            CLOSE_RAW_BLOCK: 23,
                            openBlock: 24,
                            block_option0: 25,
                            closeBlock: 26,
                            openInverse: 27,
                            block_option1: 28,
                            OPEN_BLOCK: 29,
                            openBlock_repetition0: 30,
                            openBlock_option0: 31,
                            openBlock_option1: 32,
                            CLOSE: 33,
                            OPEN_INVERSE: 34,
                            openInverse_repetition0: 35,
                            openInverse_option0: 36,
                            openInverse_option1: 37,
                            openInverseChain: 38,
                            OPEN_INVERSE_CHAIN: 39,
                            openInverseChain_repetition0: 40,
                            openInverseChain_option0: 41,
                            openInverseChain_option1: 42,
                            inverseAndProgram: 43,
                            INVERSE: 44,
                            inverseChain: 45,
                            inverseChain_option0: 46,
                            OPEN_ENDBLOCK: 47,
                            OPEN: 48,
                            mustache_repetition0: 49,
                            mustache_option0: 50,
                            OPEN_UNESCAPED: 51,
                            mustache_repetition1: 52,
                            mustache_option1: 53,
                            CLOSE_UNESCAPED: 54,
                            OPEN_PARTIAL: 55,
                            partialName: 56,
                            partial_repetition0: 57,
                            partial_option0: 58,
                            openPartialBlock: 59,
                            OPEN_PARTIAL_BLOCK: 60,
                            openPartialBlock_repetition0: 61,
                            openPartialBlock_option0: 62,
                            param: 63,
                            sexpr: 64,
                            OPEN_SEXPR: 65,
                            sexpr_repetition0: 66,
                            sexpr_option0: 67,
                            CLOSE_SEXPR: 68,
                            hash: 69,
                            hash_repetition_plus0: 70,
                            hashSegment: 71,
                            ID: 72,
                            EQUALS: 73,
                            blockParams: 74,
                            OPEN_BLOCK_PARAMS: 75,
                            blockParams_repetition_plus0: 76,
                            CLOSE_BLOCK_PARAMS: 77,
                            path: 78,
                            dataName: 79,
                            STRING: 80,
                            NUMBER: 81,
                            BOOLEAN: 82,
                            UNDEFINED: 83,
                            NULL: 84,
                            DATA: 85,
                            pathSegments: 86,
                            SEP: 87,
                            $accept: 0,
                            $end: 1,
                        },
                        terminals_: {
                            2: "error",
                            5: "EOF",
                            14: "COMMENT",
                            15: "CONTENT",
                            18: "END_RAW_BLOCK",
                            19: "OPEN_RAW_BLOCK",
                            23: "CLOSE_RAW_BLOCK",
                            29: "OPEN_BLOCK",
                            33: "CLOSE",
                            34: "OPEN_INVERSE",
                            39: "OPEN_INVERSE_CHAIN",
                            44: "INVERSE",
                            47: "OPEN_ENDBLOCK",
                            48: "OPEN",
                            51: "OPEN_UNESCAPED",
                            54: "CLOSE_UNESCAPED",
                            55: "OPEN_PARTIAL",
                            60: "OPEN_PARTIAL_BLOCK",
                            65: "OPEN_SEXPR",
                            68: "CLOSE_SEXPR",
                            72: "ID",
                            73: "EQUALS",
                            75: "OPEN_BLOCK_PARAMS",
                            77: "CLOSE_BLOCK_PARAMS",
                            80: "STRING",
                            81: "NUMBER",
                            82: "BOOLEAN",
                            83: "UNDEFINED",
                            84: "NULL",
                            85: "DATA",
                            87: "SEP",
                        },
                        productions_: [
                            0,
                            [3, 2],
                            [4, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [13, 1],
                            [10, 3],
                            [16, 5],
                            [9, 4],
                            [9, 4],
                            [24, 6],
                            [27, 6],
                            [38, 6],
                            [43, 2],
                            [45, 3],
                            [45, 1],
                            [26, 3],
                            [8, 5],
                            [8, 5],
                            [11, 5],
                            [12, 3],
                            [59, 5],
                            [63, 1],
                            [63, 1],
                            [64, 5],
                            [69, 1],
                            [71, 3],
                            [74, 3],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [56, 1],
                            [56, 1],
                            [79, 2],
                            [78, 1],
                            [86, 3],
                            [86, 1],
                            [6, 0],
                            [6, 2],
                            [17, 0],
                            [17, 2],
                            [21, 0],
                            [21, 2],
                            [22, 0],
                            [22, 1],
                            [25, 0],
                            [25, 1],
                            [28, 0],
                            [28, 1],
                            [30, 0],
                            [30, 2],
                            [31, 0],
                            [31, 1],
                            [32, 0],
                            [32, 1],
                            [35, 0],
                            [35, 2],
                            [36, 0],
                            [36, 1],
                            [37, 0],
                            [37, 1],
                            [40, 0],
                            [40, 2],
                            [41, 0],
                            [41, 1],
                            [42, 0],
                            [42, 1],
                            [46, 0],
                            [46, 1],
                            [49, 0],
                            [49, 2],
                            [50, 0],
                            [50, 1],
                            [52, 0],
                            [52, 2],
                            [53, 0],
                            [53, 1],
                            [57, 0],
                            [57, 2],
                            [58, 0],
                            [58, 1],
                            [61, 0],
                            [61, 2],
                            [62, 0],
                            [62, 1],
                            [66, 0],
                            [66, 2],
                            [67, 0],
                            [67, 1],
                            [70, 1],
                            [70, 2],
                            [76, 1],
                            [76, 2],
                        ],
                        performAction: function (a, b, c, d, e, f, g) {
                            var h = f.length - 1;
                            switch (e) {
                                case 1:
                                    return f[h - 1];
                                case 2:
                                    this.$ = d.prepareProgram(f[h]);
                                    break;
                                case 3:
                                    this.$ = f[h];
                                    break;
                                case 4:
                                    this.$ = f[h];
                                    break;
                                case 5:
                                    this.$ = f[h];
                                    break;
                                case 6:
                                    this.$ = f[h];
                                    break;
                                case 7:
                                    this.$ = f[h];
                                    break;
                                case 8:
                                    this.$ = f[h];
                                    break;
                                case 9:
                                    this.$ = {
                                        type: "CommentStatement",
                                        value: d.stripComment(f[h]),
                                        strip: d.stripFlags(f[h], f[h]),
                                        loc: d.locInfo(this._$),
                                    };
                                    break;
                                case 10:
                                    this.$ = { type: "ContentStatement", original: f[h], value: f[h], loc: d.locInfo(this._$) };
                                    break;
                                case 11:
                                    this.$ = d.prepareRawBlock(f[h - 2], f[h - 1], f[h], this._$);
                                    break;
                                case 12:
                                    this.$ = { path: f[h - 3], params: f[h - 2], hash: f[h - 1] };
                                    break;
                                case 13:
                                    this.$ = d.prepareBlock(f[h - 3], f[h - 2], f[h - 1], f[h], !1, this._$);
                                    break;
                                case 14:
                                    this.$ = d.prepareBlock(f[h - 3], f[h - 2], f[h - 1], f[h], !0, this._$);
                                    break;
                                case 15:
                                    this.$ = {
                                        open: f[h - 5],
                                        path: f[h - 4],
                                        params: f[h - 3],
                                        hash: f[h - 2],
                                        blockParams: f[h - 1],
                                        strip: d.stripFlags(f[h - 5], f[h]),
                                    };
                                    break;
                                case 16:
                                    this.$ = {
                                        path: f[h - 4],
                                        params: f[h - 3],
                                        hash: f[h - 2],
                                        blockParams: f[h - 1],
                                        strip: d.stripFlags(f[h - 5], f[h]),
                                    };
                                    break;
                                case 17:
                                    this.$ = {
                                        path: f[h - 4],
                                        params: f[h - 3],
                                        hash: f[h - 2],
                                        blockParams: f[h - 1],
                                        strip: d.stripFlags(f[h - 5], f[h]),
                                    };
                                    break;
                                case 18:
                                    this.$ = { strip: d.stripFlags(f[h - 1], f[h - 1]), program: f[h] };
                                    break;
                                case 19:
                                    var i = d.prepareBlock(f[h - 2], f[h - 1], f[h], f[h], !1, this._$),
                                        j = d.prepareProgram([i], f[h - 1].loc);
                                    (j.chained = !0), (this.$ = { strip: f[h - 2].strip, program: j, chain: !0 });
                                    break;
                                case 20:
                                    this.$ = f[h];
                                    break;
                                case 21:
                                    this.$ = { path: f[h - 1], strip: d.stripFlags(f[h - 2], f[h]) };
                                    break;
                                case 22:
                                    this.$ = d.prepareMustache(f[h - 3], f[h - 2], f[h - 1], f[h - 4], d.stripFlags(f[h - 4], f[h]), this._$);
                                    break;
                                case 23:
                                    this.$ = d.prepareMustache(f[h - 3], f[h - 2], f[h - 1], f[h - 4], d.stripFlags(f[h - 4], f[h]), this._$);
                                    break;
                                case 24:
                                    this.$ = {
                                        type: "PartialStatement",
                                        name: f[h - 3],
                                        params: f[h - 2],
                                        hash: f[h - 1],
                                        indent: "",
                                        strip: d.stripFlags(f[h - 4], f[h]),
                                        loc: d.locInfo(this._$),
                                    };
                                    break;
                                case 25:
                                    this.$ = d.preparePartialBlock(f[h - 2], f[h - 1], f[h], this._$);
                                    break;
                                case 26:
                                    this.$ = { path: f[h - 3], params: f[h - 2], hash: f[h - 1], strip: d.stripFlags(f[h - 4], f[h]) };
                                    break;
                                case 27:
                                    this.$ = f[h];
                                    break;
                                case 28:
                                    this.$ = f[h];
                                    break;
                                case 29:
                                    this.$ = { type: "SubExpression", path: f[h - 3], params: f[h - 2], hash: f[h - 1], loc: d.locInfo(this._$) };
                                    break;
                                case 30:
                                    this.$ = { type: "Hash", pairs: f[h], loc: d.locInfo(this._$) };
                                    break;
                                case 31:
                                    this.$ = { type: "HashPair", key: d.id(f[h - 2]), value: f[h], loc: d.locInfo(this._$) };
                                    break;
                                case 32:
                                    this.$ = d.id(f[h - 1]);
                                    break;
                                case 33:
                                    this.$ = f[h];
                                    break;
                                case 34:
                                    this.$ = f[h];
                                    break;
                                case 35:
                                    this.$ = { type: "StringLiteral", value: f[h], original: f[h], loc: d.locInfo(this._$) };
                                    break;
                                case 36:
                                    this.$ = { type: "NumberLiteral", value: Number(f[h]), original: Number(f[h]), loc: d.locInfo(this._$) };
                                    break;
                                case 37:
                                    this.$ = { type: "BooleanLiteral", value: "true" === f[h], original: "true" === f[h], loc: d.locInfo(this._$) };
                                    break;
                                case 38:
                                    this.$ = { type: "UndefinedLiteral", original: void 0, value: void 0, loc: d.locInfo(this._$) };
                                    break;
                                case 39:
                                    this.$ = { type: "NullLiteral", original: null, value: null, loc: d.locInfo(this._$) };
                                    break;
                                case 40:
                                    this.$ = f[h];
                                    break;
                                case 41:
                                    this.$ = f[h];
                                    break;
                                case 42:
                                    this.$ = d.preparePath(!0, f[h], this._$);
                                    break;
                                case 43:
                                    this.$ = d.preparePath(!1, f[h], this._$);
                                    break;
                                case 44:
                                    f[h - 2].push({ part: d.id(f[h]), original: f[h], separator: f[h - 1] }), (this.$ = f[h - 2]);
                                    break;
                                case 45:
                                    this.$ = [{ part: d.id(f[h]), original: f[h] }];
                                    break;
                                case 46:
                                    this.$ = [];
                                    break;
                                case 47:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 48:
                                    this.$ = [];
                                    break;
                                case 49:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 50:
                                    this.$ = [];
                                    break;
                                case 51:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 58:
                                    this.$ = [];
                                    break;
                                case 59:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 64:
                                    this.$ = [];
                                    break;
                                case 65:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 70:
                                    this.$ = [];
                                    break;
                                case 71:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 78:
                                    this.$ = [];
                                    break;
                                case 79:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 82:
                                    this.$ = [];
                                    break;
                                case 83:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 86:
                                    this.$ = [];
                                    break;
                                case 87:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 90:
                                    this.$ = [];
                                    break;
                                case 91:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 94:
                                    this.$ = [];
                                    break;
                                case 95:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 98:
                                    this.$ = [f[h]];
                                    break;
                                case 99:
                                    f[h - 1].push(f[h]);
                                    break;
                                case 100:
                                    this.$ = [f[h]];
                                    break;
                                case 101:
                                    f[h - 1].push(f[h]);
                            }
                        },
                        table: [
                            {
                                3: 1,
                                4: 2,
                                5: [2, 46],
                                6: 3,
                                14: [2, 46],
                                15: [2, 46],
                                19: [2, 46],
                                29: [2, 46],
                                34: [2, 46],
                                48: [2, 46],
                                51: [2, 46],
                                55: [2, 46],
                                60: [2, 46],
                            },
                            { 1: [3] },
                            { 5: [1, 4] },
                            {
                                5: [2, 2],
                                7: 5,
                                8: 6,
                                9: 7,
                                10: 8,
                                11: 9,
                                12: 10,
                                13: 11,
                                14: [1, 12],
                                15: [1, 20],
                                16: 17,
                                19: [1, 23],
                                24: 15,
                                27: 16,
                                29: [1, 21],
                                34: [1, 22],
                                39: [2, 2],
                                44: [2, 2],
                                47: [2, 2],
                                48: [1, 13],
                                51: [1, 14],
                                55: [1, 18],
                                59: 19,
                                60: [1, 24],
                            },
                            { 1: [2, 1] },
                            {
                                5: [2, 47],
                                14: [2, 47],
                                15: [2, 47],
                                19: [2, 47],
                                29: [2, 47],
                                34: [2, 47],
                                39: [2, 47],
                                44: [2, 47],
                                47: [2, 47],
                                48: [2, 47],
                                51: [2, 47],
                                55: [2, 47],
                                60: [2, 47],
                            },
                            {
                                5: [2, 3],
                                14: [2, 3],
                                15: [2, 3],
                                19: [2, 3],
                                29: [2, 3],
                                34: [2, 3],
                                39: [2, 3],
                                44: [2, 3],
                                47: [2, 3],
                                48: [2, 3],
                                51: [2, 3],
                                55: [2, 3],
                                60: [2, 3],
                            },
                            {
                                5: [2, 4],
                                14: [2, 4],
                                15: [2, 4],
                                19: [2, 4],
                                29: [2, 4],
                                34: [2, 4],
                                39: [2, 4],
                                44: [2, 4],
                                47: [2, 4],
                                48: [2, 4],
                                51: [2, 4],
                                55: [2, 4],
                                60: [2, 4],
                            },
                            {
                                5: [2, 5],
                                14: [2, 5],
                                15: [2, 5],
                                19: [2, 5],
                                29: [2, 5],
                                34: [2, 5],
                                39: [2, 5],
                                44: [2, 5],
                                47: [2, 5],
                                48: [2, 5],
                                51: [2, 5],
                                55: [2, 5],
                                60: [2, 5],
                            },
                            {
                                5: [2, 6],
                                14: [2, 6],
                                15: [2, 6],
                                19: [2, 6],
                                29: [2, 6],
                                34: [2, 6],
                                39: [2, 6],
                                44: [2, 6],
                                47: [2, 6],
                                48: [2, 6],
                                51: [2, 6],
                                55: [2, 6],
                                60: [2, 6],
                            },
                            {
                                5: [2, 7],
                                14: [2, 7],
                                15: [2, 7],
                                19: [2, 7],
                                29: [2, 7],
                                34: [2, 7],
                                39: [2, 7],
                                44: [2, 7],
                                47: [2, 7],
                                48: [2, 7],
                                51: [2, 7],
                                55: [2, 7],
                                60: [2, 7],
                            },
                            {
                                5: [2, 8],
                                14: [2, 8],
                                15: [2, 8],
                                19: [2, 8],
                                29: [2, 8],
                                34: [2, 8],
                                39: [2, 8],
                                44: [2, 8],
                                47: [2, 8],
                                48: [2, 8],
                                51: [2, 8],
                                55: [2, 8],
                                60: [2, 8],
                            },
                            {
                                5: [2, 9],
                                14: [2, 9],
                                15: [2, 9],
                                19: [2, 9],
                                29: [2, 9],
                                34: [2, 9],
                                39: [2, 9],
                                44: [2, 9],
                                47: [2, 9],
                                48: [2, 9],
                                51: [2, 9],
                                55: [2, 9],
                                60: [2, 9],
                            },
                            {
                                20: 25,
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 36,
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                4: 37,
                                6: 3,
                                14: [2, 46],
                                15: [2, 46],
                                19: [2, 46],
                                29: [2, 46],
                                34: [2, 46],
                                39: [2, 46],
                                44: [2, 46],
                                47: [2, 46],
                                48: [2, 46],
                                51: [2, 46],
                                55: [2, 46],
                                60: [2, 46],
                            },
                            {
                                4: 38,
                                6: 3,
                                14: [2, 46],
                                15: [2, 46],
                                19: [2, 46],
                                29: [2, 46],
                                34: [2, 46],
                                44: [2, 46],
                                47: [2, 46],
                                48: [2, 46],
                                51: [2, 46],
                                55: [2, 46],
                                60: [2, 46],
                            },
                            { 15: [2, 48], 17: 39, 18: [2, 48] },
                            {
                                20: 41,
                                56: 40,
                                64: 42,
                                65: [1, 43],
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                4: 44,
                                6: 3,
                                14: [2, 46],
                                15: [2, 46],
                                19: [2, 46],
                                29: [2, 46],
                                34: [2, 46],
                                47: [2, 46],
                                48: [2, 46],
                                51: [2, 46],
                                55: [2, 46],
                                60: [2, 46],
                            },
                            {
                                5: [2, 10],
                                14: [2, 10],
                                15: [2, 10],
                                18: [2, 10],
                                19: [2, 10],
                                29: [2, 10],
                                34: [2, 10],
                                39: [2, 10],
                                44: [2, 10],
                                47: [2, 10],
                                48: [2, 10],
                                51: [2, 10],
                                55: [2, 10],
                                60: [2, 10],
                            },
                            {
                                20: 45,
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 46,
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 47,
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 41,
                                56: 48,
                                64: 42,
                                65: [1, 43],
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                33: [2, 78],
                                49: 49,
                                65: [2, 78],
                                72: [2, 78],
                                80: [2, 78],
                                81: [2, 78],
                                82: [2, 78],
                                83: [2, 78],
                                84: [2, 78],
                                85: [2, 78],
                            },
                            {
                                23: [2, 33],
                                33: [2, 33],
                                54: [2, 33],
                                65: [2, 33],
                                68: [2, 33],
                                72: [2, 33],
                                75: [2, 33],
                                80: [2, 33],
                                81: [2, 33],
                                82: [2, 33],
                                83: [2, 33],
                                84: [2, 33],
                                85: [2, 33],
                            },
                            {
                                23: [2, 34],
                                33: [2, 34],
                                54: [2, 34],
                                65: [2, 34],
                                68: [2, 34],
                                72: [2, 34],
                                75: [2, 34],
                                80: [2, 34],
                                81: [2, 34],
                                82: [2, 34],
                                83: [2, 34],
                                84: [2, 34],
                                85: [2, 34],
                            },
                            {
                                23: [2, 35],
                                33: [2, 35],
                                54: [2, 35],
                                65: [2, 35],
                                68: [2, 35],
                                72: [2, 35],
                                75: [2, 35],
                                80: [2, 35],
                                81: [2, 35],
                                82: [2, 35],
                                83: [2, 35],
                                84: [2, 35],
                                85: [2, 35],
                            },
                            {
                                23: [2, 36],
                                33: [2, 36],
                                54: [2, 36],
                                65: [2, 36],
                                68: [2, 36],
                                72: [2, 36],
                                75: [2, 36],
                                80: [2, 36],
                                81: [2, 36],
                                82: [2, 36],
                                83: [2, 36],
                                84: [2, 36],
                                85: [2, 36],
                            },
                            {
                                23: [2, 37],
                                33: [2, 37],
                                54: [2, 37],
                                65: [2, 37],
                                68: [2, 37],
                                72: [2, 37],
                                75: [2, 37],
                                80: [2, 37],
                                81: [2, 37],
                                82: [2, 37],
                                83: [2, 37],
                                84: [2, 37],
                                85: [2, 37],
                            },
                            {
                                23: [2, 38],
                                33: [2, 38],
                                54: [2, 38],
                                65: [2, 38],
                                68: [2, 38],
                                72: [2, 38],
                                75: [2, 38],
                                80: [2, 38],
                                81: [2, 38],
                                82: [2, 38],
                                83: [2, 38],
                                84: [2, 38],
                                85: [2, 38],
                            },
                            {
                                23: [2, 39],
                                33: [2, 39],
                                54: [2, 39],
                                65: [2, 39],
                                68: [2, 39],
                                72: [2, 39],
                                75: [2, 39],
                                80: [2, 39],
                                81: [2, 39],
                                82: [2, 39],
                                83: [2, 39],
                                84: [2, 39],
                                85: [2, 39],
                            },
                            {
                                23: [2, 43],
                                33: [2, 43],
                                54: [2, 43],
                                65: [2, 43],
                                68: [2, 43],
                                72: [2, 43],
                                75: [2, 43],
                                80: [2, 43],
                                81: [2, 43],
                                82: [2, 43],
                                83: [2, 43],
                                84: [2, 43],
                                85: [2, 43],
                                87: [1, 50],
                            },
                            { 72: [1, 35], 86: 51 },
                            {
                                23: [2, 45],
                                33: [2, 45],
                                54: [2, 45],
                                65: [2, 45],
                                68: [2, 45],
                                72: [2, 45],
                                75: [2, 45],
                                80: [2, 45],
                                81: [2, 45],
                                82: [2, 45],
                                83: [2, 45],
                                84: [2, 45],
                                85: [2, 45],
                                87: [2, 45],
                            },
                            {
                                52: 52,
                                54: [2, 82],
                                65: [2, 82],
                                72: [2, 82],
                                80: [2, 82],
                                81: [2, 82],
                                82: [2, 82],
                                83: [2, 82],
                                84: [2, 82],
                                85: [2, 82],
                            },
                            { 25: 53, 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 54, 47: [2, 54] },
                            { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] },
                            { 13: 62, 15: [1, 20], 18: [1, 61] },
                            {
                                33: [2, 86],
                                57: 63,
                                65: [2, 86],
                                72: [2, 86],
                                80: [2, 86],
                                81: [2, 86],
                                82: [2, 86],
                                83: [2, 86],
                                84: [2, 86],
                                85: [2, 86],
                            },
                            { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] },
                            { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] },
                            {
                                20: 64,
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            { 26: 65, 47: [1, 66] },
                            {
                                30: 67,
                                33: [2, 58],
                                65: [2, 58],
                                72: [2, 58],
                                75: [2, 58],
                                80: [2, 58],
                                81: [2, 58],
                                82: [2, 58],
                                83: [2, 58],
                                84: [2, 58],
                                85: [2, 58],
                            },
                            {
                                33: [2, 64],
                                35: 68,
                                65: [2, 64],
                                72: [2, 64],
                                75: [2, 64],
                                80: [2, 64],
                                81: [2, 64],
                                82: [2, 64],
                                83: [2, 64],
                                84: [2, 64],
                                85: [2, 64],
                            },
                            {
                                21: 69,
                                23: [2, 50],
                                65: [2, 50],
                                72: [2, 50],
                                80: [2, 50],
                                81: [2, 50],
                                82: [2, 50],
                                83: [2, 50],
                                84: [2, 50],
                                85: [2, 50],
                            },
                            {
                                33: [2, 90],
                                61: 70,
                                65: [2, 90],
                                72: [2, 90],
                                80: [2, 90],
                                81: [2, 90],
                                82: [2, 90],
                                83: [2, 90],
                                84: [2, 90],
                                85: [2, 90],
                            },
                            {
                                20: 74,
                                33: [2, 80],
                                50: 71,
                                63: 72,
                                64: 75,
                                65: [1, 43],
                                69: 73,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            { 72: [1, 79] },
                            {
                                23: [2, 42],
                                33: [2, 42],
                                54: [2, 42],
                                65: [2, 42],
                                68: [2, 42],
                                72: [2, 42],
                                75: [2, 42],
                                80: [2, 42],
                                81: [2, 42],
                                82: [2, 42],
                                83: [2, 42],
                                84: [2, 42],
                                85: [2, 42],
                                87: [1, 50],
                            },
                            {
                                20: 74,
                                53: 80,
                                54: [2, 84],
                                63: 81,
                                64: 75,
                                65: [1, 43],
                                69: 82,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            { 26: 83, 47: [1, 66] },
                            { 47: [2, 55] },
                            {
                                4: 84,
                                6: 3,
                                14: [2, 46],
                                15: [2, 46],
                                19: [2, 46],
                                29: [2, 46],
                                34: [2, 46],
                                39: [2, 46],
                                44: [2, 46],
                                47: [2, 46],
                                48: [2, 46],
                                51: [2, 46],
                                55: [2, 46],
                                60: [2, 46],
                            },
                            { 47: [2, 20] },
                            {
                                20: 85,
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                4: 86,
                                6: 3,
                                14: [2, 46],
                                15: [2, 46],
                                19: [2, 46],
                                29: [2, 46],
                                34: [2, 46],
                                47: [2, 46],
                                48: [2, 46],
                                51: [2, 46],
                                55: [2, 46],
                                60: [2, 46],
                            },
                            { 26: 87, 47: [1, 66] },
                            { 47: [2, 57] },
                            {
                                5: [2, 11],
                                14: [2, 11],
                                15: [2, 11],
                                19: [2, 11],
                                29: [2, 11],
                                34: [2, 11],
                                39: [2, 11],
                                44: [2, 11],
                                47: [2, 11],
                                48: [2, 11],
                                51: [2, 11],
                                55: [2, 11],
                                60: [2, 11],
                            },
                            { 15: [2, 49], 18: [2, 49] },
                            {
                                20: 74,
                                33: [2, 88],
                                58: 88,
                                63: 89,
                                64: 75,
                                65: [1, 43],
                                69: 90,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                65: [2, 94],
                                66: 91,
                                68: [2, 94],
                                72: [2, 94],
                                80: [2, 94],
                                81: [2, 94],
                                82: [2, 94],
                                83: [2, 94],
                                84: [2, 94],
                                85: [2, 94],
                            },
                            {
                                5: [2, 25],
                                14: [2, 25],
                                15: [2, 25],
                                19: [2, 25],
                                29: [2, 25],
                                34: [2, 25],
                                39: [2, 25],
                                44: [2, 25],
                                47: [2, 25],
                                48: [2, 25],
                                51: [2, 25],
                                55: [2, 25],
                                60: [2, 25],
                            },
                            {
                                20: 92,
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 74,
                                31: 93,
                                33: [2, 60],
                                63: 94,
                                64: 75,
                                65: [1, 43],
                                69: 95,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                75: [2, 60],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 74,
                                33: [2, 66],
                                36: 96,
                                63: 97,
                                64: 75,
                                65: [1, 43],
                                69: 98,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                75: [2, 66],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 74,
                                22: 99,
                                23: [2, 52],
                                63: 100,
                                64: 75,
                                65: [1, 43],
                                69: 101,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 74,
                                33: [2, 92],
                                62: 102,
                                63: 103,
                                64: 75,
                                65: [1, 43],
                                69: 104,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            { 33: [1, 105] },
                            { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] },
                            { 33: [2, 81] },
                            {
                                23: [2, 27],
                                33: [2, 27],
                                54: [2, 27],
                                65: [2, 27],
                                68: [2, 27],
                                72: [2, 27],
                                75: [2, 27],
                                80: [2, 27],
                                81: [2, 27],
                                82: [2, 27],
                                83: [2, 27],
                                84: [2, 27],
                                85: [2, 27],
                            },
                            {
                                23: [2, 28],
                                33: [2, 28],
                                54: [2, 28],
                                65: [2, 28],
                                68: [2, 28],
                                72: [2, 28],
                                75: [2, 28],
                                80: [2, 28],
                                81: [2, 28],
                                82: [2, 28],
                                83: [2, 28],
                                84: [2, 28],
                                85: [2, 28],
                            },
                            { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 106, 72: [1, 107], 75: [2, 30] },
                            { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] },
                            {
                                23: [2, 45],
                                33: [2, 45],
                                54: [2, 45],
                                65: [2, 45],
                                68: [2, 45],
                                72: [2, 45],
                                73: [1, 108],
                                75: [2, 45],
                                80: [2, 45],
                                81: [2, 45],
                                82: [2, 45],
                                83: [2, 45],
                                84: [2, 45],
                                85: [2, 45],
                                87: [2, 45],
                            },
                            {
                                23: [2, 44],
                                33: [2, 44],
                                54: [2, 44],
                                65: [2, 44],
                                68: [2, 44],
                                72: [2, 44],
                                75: [2, 44],
                                80: [2, 44],
                                81: [2, 44],
                                82: [2, 44],
                                83: [2, 44],
                                84: [2, 44],
                                85: [2, 44],
                                87: [2, 44],
                            },
                            { 54: [1, 109] },
                            { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] },
                            { 54: [2, 85] },
                            {
                                5: [2, 13],
                                14: [2, 13],
                                15: [2, 13],
                                19: [2, 13],
                                29: [2, 13],
                                34: [2, 13],
                                39: [2, 13],
                                44: [2, 13],
                                47: [2, 13],
                                48: [2, 13],
                                51: [2, 13],
                                55: [2, 13],
                                60: [2, 13],
                            },
                            { 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 111, 46: 110, 47: [2, 76] },
                            {
                                33: [2, 70],
                                40: 112,
                                65: [2, 70],
                                72: [2, 70],
                                75: [2, 70],
                                80: [2, 70],
                                81: [2, 70],
                                82: [2, 70],
                                83: [2, 70],
                                84: [2, 70],
                                85: [2, 70],
                            },
                            { 47: [2, 18] },
                            {
                                5: [2, 14],
                                14: [2, 14],
                                15: [2, 14],
                                19: [2, 14],
                                29: [2, 14],
                                34: [2, 14],
                                39: [2, 14],
                                44: [2, 14],
                                47: [2, 14],
                                48: [2, 14],
                                51: [2, 14],
                                55: [2, 14],
                                60: [2, 14],
                            },
                            { 33: [1, 113] },
                            { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] },
                            { 33: [2, 89] },
                            {
                                20: 74,
                                63: 115,
                                64: 75,
                                65: [1, 43],
                                67: 114,
                                68: [2, 96],
                                69: 116,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            { 33: [1, 117] },
                            { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] },
                            {
                                33: [2, 59],
                                65: [2, 59],
                                72: [2, 59],
                                75: [2, 59],
                                80: [2, 59],
                                81: [2, 59],
                                82: [2, 59],
                                83: [2, 59],
                                84: [2, 59],
                                85: [2, 59],
                            },
                            { 33: [2, 61], 75: [2, 61] },
                            { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] },
                            {
                                33: [2, 65],
                                65: [2, 65],
                                72: [2, 65],
                                75: [2, 65],
                                80: [2, 65],
                                81: [2, 65],
                                82: [2, 65],
                                83: [2, 65],
                                84: [2, 65],
                                85: [2, 65],
                            },
                            { 33: [2, 67], 75: [2, 67] },
                            { 23: [1, 123] },
                            { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] },
                            { 23: [2, 53] },
                            { 33: [1, 124] },
                            { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] },
                            { 33: [2, 93] },
                            {
                                5: [2, 22],
                                14: [2, 22],
                                15: [2, 22],
                                19: [2, 22],
                                29: [2, 22],
                                34: [2, 22],
                                39: [2, 22],
                                44: [2, 22],
                                47: [2, 22],
                                48: [2, 22],
                                51: [2, 22],
                                55: [2, 22],
                                60: [2, 22],
                            },
                            { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] },
                            { 73: [1, 108] },
                            {
                                20: 74,
                                63: 125,
                                64: 75,
                                65: [1, 43],
                                72: [1, 35],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                5: [2, 23],
                                14: [2, 23],
                                15: [2, 23],
                                19: [2, 23],
                                29: [2, 23],
                                34: [2, 23],
                                39: [2, 23],
                                44: [2, 23],
                                47: [2, 23],
                                48: [2, 23],
                                51: [2, 23],
                                55: [2, 23],
                                60: [2, 23],
                            },
                            { 47: [2, 19] },
                            { 47: [2, 77] },
                            {
                                20: 74,
                                33: [2, 72],
                                41: 126,
                                63: 127,
                                64: 75,
                                65: [1, 43],
                                69: 128,
                                70: 76,
                                71: 77,
                                72: [1, 78],
                                75: [2, 72],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                5: [2, 24],
                                14: [2, 24],
                                15: [2, 24],
                                19: [2, 24],
                                29: [2, 24],
                                34: [2, 24],
                                39: [2, 24],
                                44: [2, 24],
                                47: [2, 24],
                                48: [2, 24],
                                51: [2, 24],
                                55: [2, 24],
                                60: [2, 24],
                            },
                            { 68: [1, 129] },
                            { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] },
                            { 68: [2, 97] },
                            {
                                5: [2, 21],
                                14: [2, 21],
                                15: [2, 21],
                                19: [2, 21],
                                29: [2, 21],
                                34: [2, 21],
                                39: [2, 21],
                                44: [2, 21],
                                47: [2, 21],
                                48: [2, 21],
                                51: [2, 21],
                                55: [2, 21],
                                60: [2, 21],
                            },
                            { 33: [1, 130] },
                            { 33: [2, 63] },
                            { 72: [1, 132], 76: 131 },
                            { 33: [1, 133] },
                            { 33: [2, 69] },
                            { 15: [2, 12], 18: [2, 12] },
                            {
                                14: [2, 26],
                                15: [2, 26],
                                19: [2, 26],
                                29: [2, 26],
                                34: [2, 26],
                                47: [2, 26],
                                48: [2, 26],
                                51: [2, 26],
                                55: [2, 26],
                                60: [2, 26],
                            },
                            { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] },
                            { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] },
                            {
                                33: [2, 71],
                                65: [2, 71],
                                72: [2, 71],
                                75: [2, 71],
                                80: [2, 71],
                                81: [2, 71],
                                82: [2, 71],
                                83: [2, 71],
                                84: [2, 71],
                                85: [2, 71],
                            },
                            { 33: [2, 73], 75: [2, 73] },
                            {
                                23: [2, 29],
                                33: [2, 29],
                                54: [2, 29],
                                65: [2, 29],
                                68: [2, 29],
                                72: [2, 29],
                                75: [2, 29],
                                80: [2, 29],
                                81: [2, 29],
                                82: [2, 29],
                                83: [2, 29],
                                84: [2, 29],
                                85: [2, 29],
                            },
                            {
                                14: [2, 15],
                                15: [2, 15],
                                19: [2, 15],
                                29: [2, 15],
                                34: [2, 15],
                                39: [2, 15],
                                44: [2, 15],
                                47: [2, 15],
                                48: [2, 15],
                                51: [2, 15],
                                55: [2, 15],
                                60: [2, 15],
                            },
                            { 72: [1, 137], 77: [1, 136] },
                            { 72: [2, 100], 77: [2, 100] },
                            {
                                14: [2, 16],
                                15: [2, 16],
                                19: [2, 16],
                                29: [2, 16],
                                34: [2, 16],
                                44: [2, 16],
                                47: [2, 16],
                                48: [2, 16],
                                51: [2, 16],
                                55: [2, 16],
                                60: [2, 16],
                            },
                            { 33: [1, 138] },
                            { 33: [2, 75] },
                            { 33: [2, 32] },
                            { 72: [2, 101], 77: [2, 101] },
                            {
                                14: [2, 17],
                                15: [2, 17],
                                19: [2, 17],
                                29: [2, 17],
                                34: [2, 17],
                                39: [2, 17],
                                44: [2, 17],
                                47: [2, 17],
                                48: [2, 17],
                                51: [2, 17],
                                55: [2, 17],
                                60: [2, 17],
                            },
                        ],
                        defaultActions: {
                            4: [2, 1],
                            54: [2, 55],
                            56: [2, 20],
                            60: [2, 57],
                            73: [2, 81],
                            82: [2, 85],
                            86: [2, 18],
                            90: [2, 89],
                            101: [2, 53],
                            104: [2, 93],
                            110: [2, 19],
                            111: [2, 77],
                            116: [2, 97],
                            119: [2, 63],
                            122: [2, 69],
                            135: [2, 75],
                            136: [2, 32],
                        },
                        parseError: function (a, b) {
                            throw new Error(a);
                        },
                        parse: function (a) {
                            function b() {
                                var a;
                                return (a = c.lexer.lex() || 1), "number" != typeof a && (a = c.symbols_[a] || a), a;
                            }
                            var c = this,
                                d = [0],
                                e = [null],
                                f = [],
                                g = this.table,
                                h = "",
                                i = 0,
                                j = 0,
                                k = 0;
                            this.lexer.setInput(a),
                                (this.lexer.yy = this.yy),
                                (this.yy.lexer = this.lexer),
                                (this.yy.parser = this),
                                "undefined" == typeof this.lexer.yylloc && (this.lexer.yylloc = {});
                            var l = this.lexer.yylloc;
                            f.push(l);
                            var m = this.lexer.options && this.lexer.options.ranges;
                            "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
                            for (var n, o, p, q, r, s, t, u, v, w = {}; ; ) {
                                if (
                                    ((p = d[d.length - 1]),
                                    this.defaultActions[p]
                                        ? (q = this.defaultActions[p])
                                        : ((null !== n && "undefined" != typeof n) || (n = b()), (q = g[p] && g[p][n])),
                                    "undefined" == typeof q || !q.length || !q[0])
                                ) {
                                    var x = "";
                                    if (!k) {
                                        v = [];
                                        for (s in g[p]) this.terminals_[s] && s > 2 && v.push("'" + this.terminals_[s] + "'");
                                        (x = this.lexer.showPosition
                                            ? "Parse error on line " +
                                              (i + 1) +
                                              ":\n" +
                                              this.lexer.showPosition() +
                                              "\nExpecting " +
                                              v.join(", ") +
                                              ", got '" +
                                              (this.terminals_[n] || n) +
                                              "'"
                                            : "Parse error on line " +
                                              (i + 1) +
                                              ": Unexpected " +
                                              (1 == n ? "end of input" : "'" + (this.terminals_[n] || n) + "'")),
                                            this.parseError(x, {
                                                text: this.lexer.match,
                                                token: this.terminals_[n] || n,
                                                line: this.lexer.yylineno,
                                                loc: l,
                                                expected: v,
                                            });
                                    }
                                }
                                if (q[0] instanceof Array && q.length > 1)
                                    throw new Error("Parse Error: multiple actions possible at state: " + p + ", token: " + n);
                                switch (q[0]) {
                                    case 1:
                                        d.push(n),
                                            e.push(this.lexer.yytext),
                                            f.push(this.lexer.yylloc),
                                            d.push(q[1]),
                                            (n = null),
                                            o
                                                ? ((n = o), (o = null))
                                                : ((j = this.lexer.yyleng),
                                                  (h = this.lexer.yytext),
                                                  (i = this.lexer.yylineno),
                                                  (l = this.lexer.yylloc),
                                                  k > 0 && k--);
                                        break;
                                    case 2:
                                        if (
                                            ((t = this.productions_[q[1]][1]),
                                            (w.$ = e[e.length - t]),
                                            (w._$ = {
                                                first_line: f[f.length - (t || 1)].first_line,
                                                last_line: f[f.length - 1].last_line,
                                                first_column: f[f.length - (t || 1)].first_column,
                                                last_column: f[f.length - 1].last_column,
                                            }),
                                            m && (w._$.range = [f[f.length - (t || 1)].range[0], f[f.length - 1].range[1]]),
                                            (r = this.performAction.call(w, h, j, i, this.yy, q[1], e, f)),
                                            "undefined" != typeof r)
                                        )
                                            return r;
                                        t && ((d = d.slice(0, -1 * t * 2)), (e = e.slice(0, -1 * t)), (f = f.slice(0, -1 * t))),
                                            d.push(this.productions_[q[1]][0]),
                                            e.push(w.$),
                                            f.push(w._$),
                                            (u = g[d[d.length - 2]][d[d.length - 1]]),
                                            d.push(u);
                                        break;
                                    case 3:
                                        return !0;
                                }
                            }
                            return !0;
                        },
                    },
                    c = (function () {
                        var a = {
                            EOF: 1,
                            parseError: function (a, b) {
                                if (!this.yy.parser) throw new Error(a);
                                this.yy.parser.parseError(a, b);
                            },
                            setInput: function (a) {
                                return (
                                    (this._input = a),
                                    (this._more = this._less = this.done = !1),
                                    (this.yylineno = this.yyleng = 0),
                                    (this.yytext = this.matched = this.match = ""),
                                    (this.conditionStack = ["INITIAL"]),
                                    (this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }),
                                    this.options.ranges && (this.yylloc.range = [0, 0]),
                                    (this.offset = 0),
                                    this
                                );
                            },
                            input: function () {
                                var a = this._input[0];
                                (this.yytext += a), this.yyleng++, this.offset++, (this.match += a), (this.matched += a);
                                var b = a.match(/(?:\r\n?|\n).*/g);
                                return (
                                    b ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++,
                                    this.options.ranges && this.yylloc.range[1]++,
                                    (this._input = this._input.slice(1)),
                                    a
                                );
                            },
                            unput: function (a) {
                                var b = a.length,
                                    c = a.split(/(?:\r\n?|\n)/g);
                                (this._input = a + this._input),
                                    (this.yytext = this.yytext.substr(0, this.yytext.length - b - 1)),
                                    (this.offset -= b);
                                var d = this.match.split(/(?:\r\n?|\n)/g);
                                (this.match = this.match.substr(0, this.match.length - 1)),
                                    (this.matched = this.matched.substr(0, this.matched.length - 1)),
                                    c.length - 1 && (this.yylineno -= c.length - 1);
                                var e = this.yylloc.range;
                                return (
                                    (this.yylloc = {
                                        first_line: this.yylloc.first_line,
                                        last_line: this.yylineno + 1,
                                        first_column: this.yylloc.first_column,
                                        last_column: c
                                            ? (c.length === d.length ? this.yylloc.first_column : 0) + d[d.length - c.length].length - c[0].length
                                            : this.yylloc.first_column - b,
                                    }),
                                    this.options.ranges && (this.yylloc.range = [e[0], e[0] + this.yyleng - b]),
                                    this
                                );
                            },
                            more: function () {
                                return (this._more = !0), this;
                            },
                            less: function (a) {
                                this.unput(this.match.slice(a));
                            },
                            pastInput: function () {
                                var a = this.matched.substr(0, this.matched.length - this.match.length);
                                return (a.length > 20 ? "..." : "") + a.substr(-20).replace(/\n/g, "");
                            },
                            upcomingInput: function () {
                                var a = this.match;
                                return (
                                    a.length < 20 && (a += this._input.substr(0, 20 - a.length)),
                                    (a.substr(0, 20) + (a.length > 20 ? "..." : "")).replace(/\n/g, "")
                                );
                            },
                            showPosition: function () {
                                var a = this.pastInput(),
                                    b = new Array(a.length + 1).join("-");
                                return a + this.upcomingInput() + "\n" + b + "^";
                            },
                            next: function () {
                                if (this.done) return this.EOF;
                                this._input || (this.done = !0);
                                var a, b, c, d, e;
                                this._more || ((this.yytext = ""), (this.match = ""));
                                for (
                                    var f = this._currentRules(), g = 0;
                                    g < f.length &&
                                    ((c = this._input.match(this.rules[f[g]])),
                                    !c || (b && !(c[0].length > b[0].length)) || ((b = c), (d = g), this.options.flex));
                                    g++
                                );
                                return b
                                    ? ((e = b[0].match(/(?:\r\n?|\n).*/g)),
                                      e && (this.yylineno += e.length),
                                      (this.yylloc = {
                                          first_line: this.yylloc.last_line,
                                          last_line: this.yylineno + 1,
                                          first_column: this.yylloc.last_column,
                                          last_column: e
                                              ? e[e.length - 1].length - e[e.length - 1].match(/\r?\n?/)[0].length
                                              : this.yylloc.last_column + b[0].length,
                                      }),
                                      (this.yytext += b[0]),
                                      (this.match += b[0]),
                                      (this.matches = b),
                                      (this.yyleng = this.yytext.length),
                                      this.options.ranges && (this.yylloc.range = [this.offset, (this.offset += this.yyleng)]),
                                      (this._more = !1),
                                      (this._input = this._input.slice(b[0].length)),
                                      (this.matched += b[0]),
                                      (a = this.performAction.call(this, this.yy, this, f[d], this.conditionStack[this.conditionStack.length - 1])),
                                      this.done && this._input && (this.done = !1),
                                      a ? a : void 0)
                                    : "" === this._input
                                    ? this.EOF
                                    : this.parseError(
                                          "Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(),
                                          { text: "", token: null, line: this.yylineno }
                                      );
                            },
                            lex: function () {
                                var a = this.next();
                                return "undefined" != typeof a ? a : this.lex();
                            },
                            begin: function (a) {
                                this.conditionStack.push(a);
                            },
                            popState: function () {
                                return this.conditionStack.pop();
                            },
                            _currentRules: function () {
                                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                            },
                            topState: function () {
                                return this.conditionStack[this.conditionStack.length - 2];
                            },
                            pushState: function (a) {
                                this.begin(a);
                            },
                        };
                        return (
                            (a.options = {}),
                            (a.performAction = function (a, b, c, d) {
                                function e(a, c) {
                                    return (b.yytext = b.yytext.substring(a, b.yyleng - c + a));
                                }
                                switch (c) {
                                    case 0:
                                        if (
                                            ("\\\\" === b.yytext.slice(-2)
                                                ? (e(0, 1), this.begin("mu"))
                                                : "\\" === b.yytext.slice(-1)
                                                ? (e(0, 1), this.begin("emu"))
                                                : this.begin("mu"),
                                            b.yytext)
                                        )
                                            return 15;
                                        break;
                                    case 1:
                                        return 15;
                                    case 2:
                                        return this.popState(), 15;
                                    case 3:
                                        return this.begin("raw"), 15;
                                    case 4:
                                        return (
                                            this.popState(),
                                            "raw" === this.conditionStack[this.conditionStack.length - 1] ? 15 : (e(5, 9), "END_RAW_BLOCK")
                                        );
                                    case 5:
                                        return 15;
                                    case 6:
                                        return this.popState(), 14;
                                    case 7:
                                        return 65;
                                    case 8:
                                        return 68;
                                    case 9:
                                        return 19;
                                    case 10:
                                        return this.popState(), this.begin("raw"), 23;
                                    case 11:
                                        return 55;
                                    case 12:
                                        return 60;
                                    case 13:
                                        return 29;
                                    case 14:
                                        return 47;
                                    case 15:
                                        return this.popState(), 44;
                                    case 16:
                                        return this.popState(), 44;
                                    case 17:
                                        return 34;
                                    case 18:
                                        return 39;
                                    case 19:
                                        return 51;
                                    case 20:
                                        return 48;
                                    case 21:
                                        this.unput(b.yytext), this.popState(), this.begin("com");
                                        break;
                                    case 22:
                                        return this.popState(), 14;
                                    case 23:
                                        return 48;
                                    case 24:
                                        return 73;
                                    case 25:
                                        return 72;
                                    case 26:
                                        return 72;
                                    case 27:
                                        return 87;
                                    case 28:
                                        break;
                                    case 29:
                                        return this.popState(), 54;
                                    case 30:
                                        return this.popState(), 33;
                                    case 31:
                                        return (b.yytext = e(1, 2).replace(/\\"/g, '"')), 80;
                                    case 32:
                                        return (b.yytext = e(1, 2).replace(/\\'/g, "'")), 80;
                                    case 33:
                                        return 85;
                                    case 34:
                                        return 82;
                                    case 35:
                                        return 82;
                                    case 36:
                                        return 83;
                                    case 37:
                                        return 84;
                                    case 38:
                                        return 81;
                                    case 39:
                                        return 75;
                                    case 40:
                                        return 77;
                                    case 41:
                                        return 72;
                                    case 42:
                                        return (b.yytext = b.yytext.replace(/\\([\\\]])/g, "$1")), 72;
                                    case 43:
                                        return "INVALID";
                                    case 44:
                                        return 5;
                                }
                            }),
                            (a.rules = [
                                /^(?:[^\x00]*?(?=(\{\{)))/,
                                /^(?:[^\x00]+)/,
                                /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                                /^(?:\{\{\{\{(?=[^\/]))/,
                                /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
                                /^(?:[^\x00]+?(?=(\{\{\{\{)))/,
                                /^(?:[\s\S]*?--(~)?\}\})/,
                                /^(?:\()/,
                                /^(?:\))/,
                                /^(?:\{\{\{\{)/,
                                /^(?:\}\}\}\})/,
                                /^(?:\{\{(~)?>)/,
                                /^(?:\{\{(~)?#>)/,
                                /^(?:\{\{(~)?#\*?)/,
                                /^(?:\{\{(~)?\/)/,
                                /^(?:\{\{(~)?\^\s*(~)?\}\})/,
                                /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
                                /^(?:\{\{(~)?\^)/,
                                /^(?:\{\{(~)?\s*else\b)/,
                                /^(?:\{\{(~)?\{)/,
                                /^(?:\{\{(~)?&)/,
                                /^(?:\{\{(~)?!--)/,
                                /^(?:\{\{(~)?![\s\S]*?\}\})/,
                                /^(?:\{\{(~)?\*?)/,
                                /^(?:=)/,
                                /^(?:\.\.)/,
                                /^(?:\.(?=([=~}\s\/.)|])))/,
                                /^(?:[\/.])/,
                                /^(?:\s+)/,
                                /^(?:\}(~)?\}\})/,
                                /^(?:(~)?\}\})/,
                                /^(?:"(\\["]|[^"])*")/,
                                /^(?:'(\\[']|[^'])*')/,
                                /^(?:@)/,
                                /^(?:true(?=([~}\s)])))/,
                                /^(?:false(?=([~}\s)])))/,
                                /^(?:undefined(?=([~}\s)])))/,
                                /^(?:null(?=([~}\s)])))/,
                                /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
                                /^(?:as\s+\|)/,
                                /^(?:\|)/,
                                /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
                                /^(?:\[(\\\]|[^\]])*\])/,
                                /^(?:.)/,
                                /^(?:$)/,
                            ]),
                            (a.conditions = {
                                mu: {
                                    rules: [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17,
                                        18,
                                        19,
                                        20,
                                        21,
                                        22,
                                        23,
                                        24,
                                        25,
                                        26,
                                        27,
                                        28,
                                        29,
                                        30,
                                        31,
                                        32,
                                        33,
                                        34,
                                        35,
                                        36,
                                        37,
                                        38,
                                        39,
                                        40,
                                        41,
                                        42,
                                        43,
                                        44,
                                    ],
                                    inclusive: !1,
                                },
                                emu: { rules: [2], inclusive: !1 },
                                com: { rules: [6], inclusive: !1 },
                                raw: { rules: [3, 4, 5], inclusive: !1 },
                                INITIAL: { rules: [0, 1, 44], inclusive: !0 },
                            }),
                            a
                        );
                    })();
                return (b.lexer = c), (a.prototype = b), (b.Parser = a), new a();
            })();
            (b["default"] = c), (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            function d() {
                var a = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
                this.options = a;
            }
            function e(a, b, c) {
                void 0 === b && (b = a.length);
                var d = a[b - 1],
                    e = a[b - 2];
                return d ? ("ContentStatement" === d.type ? (e || !c ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(d.original) : void 0) : c;
            }
            function f(a, b, c) {
                void 0 === b && (b = -1);
                var d = a[b + 1],
                    e = a[b + 2];
                return d ? ("ContentStatement" === d.type ? (e || !c ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(d.original) : void 0) : c;
            }
            function g(a, b, c) {
                var d = a[null == b ? 0 : b + 1];
                if (d && "ContentStatement" === d.type && (c || !d.rightStripped)) {
                    var e = d.value;
                    (d.value = d.value.replace(c ? /^\s+/ : /^[ \t]*\r?\n?/, "")), (d.rightStripped = d.value !== e);
                }
            }
            function h(a, b, c) {
                var d = a[null == b ? a.length - 1 : b - 1];
                if (d && "ContentStatement" === d.type && (c || !d.leftStripped)) {
                    var e = d.value;
                    return (d.value = d.value.replace(c ? /\s+$/ : /[ \t]+$/, "")), (d.leftStripped = d.value !== e), d.leftStripped;
                }
            }
            var i = c(1)["default"];
            b.__esModule = !0;
            var j = c(49),
                k = i(j);
            (d.prototype = new k["default"]()),
                (d.prototype.Program = function (a) {
                    var b = !this.options.ignoreStandalone,
                        c = !this.isRootSeen;
                    this.isRootSeen = !0;
                    for (var d = a.body, i = 0, j = d.length; i < j; i++) {
                        var k = d[i],
                            l = this.accept(k);
                        if (l) {
                            var m = e(d, i, c),
                                n = f(d, i, c),
                                o = l.openStandalone && m,
                                p = l.closeStandalone && n,
                                q = l.inlineStandalone && m && n;
                            l.close && g(d, i, !0),
                                l.open && h(d, i, !0),
                                b && q && (g(d, i), h(d, i) && "PartialStatement" === k.type && (k.indent = /([ \t]+$)/.exec(d[i - 1].original)[1])),
                                b && o && (g((k.program || k.inverse).body), h(d, i)),
                                b && p && (g(d, i), h((k.inverse || k.program).body));
                        }
                    }
                    return a;
                }),
                (d.prototype.BlockStatement = d.prototype.DecoratorBlock = d.prototype.PartialBlockStatement = function (a) {
                    this.accept(a.program), this.accept(a.inverse);
                    var b = a.program || a.inverse,
                        c = a.program && a.inverse,
                        d = c,
                        i = c;
                    if (c && c.chained) for (d = c.body[0].program; i.chained; ) i = i.body[i.body.length - 1].program;
                    var j = { open: a.openStrip.open, close: a.closeStrip.close, openStandalone: f(b.body), closeStandalone: e((d || b).body) };
                    if ((a.openStrip.close && g(b.body, null, !0), c)) {
                        var k = a.inverseStrip;
                        k.open && h(b.body, null, !0),
                            k.close && g(d.body, null, !0),
                            a.closeStrip.open && h(i.body, null, !0),
                            !this.options.ignoreStandalone && e(b.body) && f(d.body) && (h(b.body), g(d.body));
                    } else a.closeStrip.open && h(b.body, null, !0);
                    return j;
                }),
                (d.prototype.Decorator = d.prototype.MustacheStatement = function (a) {
                    return a.strip;
                }),
                (d.prototype.PartialStatement = d.prototype.CommentStatement = function (a) {
                    var b = a.strip || {};
                    return { inlineStandalone: !0, open: b.open, close: b.close };
                }),
                (b["default"] = d),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            function d() {
                this.parents = [];
            }
            function e(a) {
                this.acceptRequired(a, "path"), this.acceptArray(a.params), this.acceptKey(a, "hash");
            }
            function f(a) {
                e.call(this, a), this.acceptKey(a, "program"), this.acceptKey(a, "inverse");
            }
            function g(a) {
                this.acceptRequired(a, "name"), this.acceptArray(a.params), this.acceptKey(a, "hash");
            }
            var h = c(1)["default"];
            b.__esModule = !0;
            var i = c(6),
                j = h(i);
            (d.prototype = {
                constructor: d,
                mutating: !1,
                acceptKey: function (a, b) {
                    var c = this.accept(a[b]);
                    if (this.mutating) {
                        if (c && !d.prototype[c.type])
                            throw new j["default"]('Unexpected node type "' + c.type + '" found when accepting ' + b + " on " + a.type);
                        a[b] = c;
                    }
                },
                acceptRequired: function (a, b) {
                    if ((this.acceptKey(a, b), !a[b])) throw new j["default"](a.type + " requires " + b);
                },
                acceptArray: function (a) {
                    for (var b = 0, c = a.length; b < c; b++) this.acceptKey(a, b), a[b] || (a.splice(b, 1), b--, c--);
                },
                accept: function (a) {
                    if (a) {
                        if (!this[a.type]) throw new j["default"]("Unknown type: " + a.type, a);
                        this.current && this.parents.unshift(this.current), (this.current = a);
                        var b = this[a.type](a);
                        return (this.current = this.parents.shift()), !this.mutating || b ? b : b !== !1 ? a : void 0;
                    }
                },
                Program: function (a) {
                    this.acceptArray(a.body);
                },
                MustacheStatement: e,
                Decorator: e,
                BlockStatement: f,
                DecoratorBlock: f,
                PartialStatement: g,
                PartialBlockStatement: function (a) {
                    g.call(this, a), this.acceptKey(a, "program");
                },
                ContentStatement: function () {},
                CommentStatement: function () {},
                SubExpression: e,
                PathExpression: function () {},
                StringLiteral: function () {},
                NumberLiteral: function () {},
                BooleanLiteral: function () {},
                UndefinedLiteral: function () {},
                NullLiteral: function () {},
                Hash: function (a) {
                    this.acceptArray(a.pairs);
                },
                HashPair: function (a) {
                    this.acceptRequired(a, "value");
                },
            }),
                (b["default"] = d),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            function d(a, b) {
                if (((b = b.path ? b.path.original : b), a.path.original !== b)) {
                    var c = { loc: a.path.loc };
                    throw new q["default"](a.path.original + " doesn't match " + b, c);
                }
            }
            function e(a, b) {
                (this.source = a),
                    (this.start = { line: b.first_line, column: b.first_column }),
                    (this.end = { line: b.last_line, column: b.last_column });
            }
            function f(a) {
                return /^\[.*\]$/.test(a) ? a.substring(1, a.length - 1) : a;
            }
            function g(a, b) {
                return { open: "~" === a.charAt(2), close: "~" === b.charAt(b.length - 3) };
            }
            function h(a) {
                return a.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
            }
            function i(a, b, c) {
                c = this.locInfo(c);
                for (var d = a ? "@" : "", e = [], f = 0, g = 0, h = b.length; g < h; g++) {
                    var i = b[g].part,
                        j = b[g].original !== i;
                    if (((d += (b[g].separator || "") + i), j || (".." !== i && "." !== i && "this" !== i))) e.push(i);
                    else {
                        if (e.length > 0) throw new q["default"]("Invalid path: " + d, { loc: c });
                        ".." === i && f++;
                    }
                }
                return { type: "PathExpression", data: a, depth: f, parts: e, original: d, loc: c };
            }
            function j(a, b, c, d, e, f) {
                var g = d.charAt(3) || d.charAt(2),
                    h = "{" !== g && "&" !== g,
                    i = /\*/.test(d);
                return { type: i ? "Decorator" : "MustacheStatement", path: a, params: b, hash: c, escaped: h, strip: e, loc: this.locInfo(f) };
            }
            function k(a, b, c, e) {
                d(a, c), (e = this.locInfo(e));
                var f = { type: "Program", body: b, strip: {}, loc: e };
                return {
                    type: "BlockStatement",
                    path: a.path,
                    params: a.params,
                    hash: a.hash,
                    program: f,
                    openStrip: {},
                    inverseStrip: {},
                    closeStrip: {},
                    loc: e,
                };
            }
            function l(a, b, c, e, f, g) {
                e && e.path && d(a, e);
                var h = /\*/.test(a.open);
                b.blockParams = a.blockParams;
                var i = void 0,
                    j = void 0;
                if (c) {
                    if (h) throw new q["default"]("Unexpected inverse block on decorator", c);
                    c.chain && (c.program.body[0].closeStrip = e.strip), (j = c.strip), (i = c.program);
                }
                return (
                    f && ((f = i), (i = b), (b = f)),
                    {
                        type: h ? "DecoratorBlock" : "BlockStatement",
                        path: a.path,
                        params: a.params,
                        hash: a.hash,
                        program: b,
                        inverse: i,
                        openStrip: a.strip,
                        inverseStrip: j,
                        closeStrip: e && e.strip,
                        loc: this.locInfo(g),
                    }
                );
            }
            function m(a, b) {
                if (!b && a.length) {
                    var c = a[0].loc,
                        d = a[a.length - 1].loc;
                    c &&
                        d &&
                        (b = {
                            source: c.source,
                            start: { line: c.start.line, column: c.start.column },
                            end: { line: d.end.line, column: d.end.column },
                        });
                }
                return { type: "Program", body: a, strip: {}, loc: b };
            }
            function n(a, b, c, e) {
                return (
                    d(a, c),
                    {
                        type: "PartialBlockStatement",
                        name: a.path,
                        params: a.params,
                        hash: a.hash,
                        program: b,
                        openStrip: a.strip,
                        closeStrip: c && c.strip,
                        loc: this.locInfo(e),
                    }
                );
            }
            var o = c(1)["default"];
            (b.__esModule = !0),
                (b.SourceLocation = e),
                (b.id = f),
                (b.stripFlags = g),
                (b.stripComment = h),
                (b.preparePath = i),
                (b.prepareMustache = j),
                (b.prepareRawBlock = k),
                (b.prepareBlock = l),
                (b.prepareProgram = m),
                (b.preparePartialBlock = n);
            var p = c(6),
                q = o(p);
        },
        function (a, b, c) {
            "use strict";
            function d() {}
            function e(a, b, c) {
                if (null == a || ("string" != typeof a && "Program" !== a.type))
                    throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + a);
                (b = b || {}), "data" in b || (b.data = !0), b.compat && (b.useDepths = !0);
                var d = c.parse(a, b),
                    e = new c.Compiler().compile(d, b);
                return new c.JavaScriptCompiler().compile(e, b);
            }
            function f(a, b, c) {
                function d() {
                    var d = c.parse(a, b),
                        e = new c.Compiler().compile(d, b),
                        f = new c.JavaScriptCompiler().compile(e, b, void 0, !0);
                    return c.template(f);
                }
                function e(a, b) {
                    return f || (f = d()), f.call(this, a, b);
                }
                if ((void 0 === b && (b = {}), null == a || ("string" != typeof a && "Program" !== a.type)))
                    throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + a);
                (b = m.extend({}, b)), "data" in b || (b.data = !0), b.compat && (b.useDepths = !0);
                var f = void 0;
                return (
                    (e._setup = function (a) {
                        return f || (f = d()), f._setup(a);
                    }),
                    (e._child = function (a, b, c, e) {
                        return f || (f = d()), f._child(a, b, c, e);
                    }),
                    e
                );
            }
            function g(a, b) {
                if (a === b) return !0;
                if (m.isArray(a) && m.isArray(b) && a.length === b.length) {
                    for (var c = 0; c < a.length; c++) if (!g(a[c], b[c])) return !1;
                    return !0;
                }
            }
            function h(a) {
                if (!a.path.parts) {
                    var b = a.path;
                    a.path = { type: "PathExpression", data: !1, depth: 0, parts: [b.original + ""], original: b.original + "", loc: b.loc };
                }
            }
            var i = c(34)["default"],
                j = c(1)["default"];
            (b.__esModule = !0), (b.Compiler = d), (b.precompile = e), (b.compile = f);
            var k = c(6),
                l = j(k),
                m = c(5),
                n = c(45),
                o = j(n),
                p = [].slice;
            d.prototype = {
                compiler: d,
                equals: function (a) {
                    var b = this.opcodes.length;
                    if (a.opcodes.length !== b) return !1;
                    for (var c = 0; c < b; c++) {
                        var d = this.opcodes[c],
                            e = a.opcodes[c];
                        if (d.opcode !== e.opcode || !g(d.args, e.args)) return !1;
                    }
                    b = this.children.length;
                    for (var c = 0; c < b; c++) if (!this.children[c].equals(a.children[c])) return !1;
                    return !0;
                },
                guid: 0,
                compile: function (a, b) {
                    return (
                        (this.sourceNode = []),
                        (this.opcodes = []),
                        (this.children = []),
                        (this.options = b),
                        (this.stringParams = b.stringParams),
                        (this.trackIds = b.trackIds),
                        (b.blockParams = b.blockParams || []),
                        (b.knownHelpers = m.extend(
                            i(null),
                            { helperMissing: !0, blockHelperMissing: !0, each: !0, if: !0, unless: !0, with: !0, log: !0, lookup: !0 },
                            b.knownHelpers
                        )),
                        this.accept(a)
                    );
                },
                compileProgram: function (a) {
                    var b = new this.compiler(),
                        c = b.compile(a, this.options),
                        d = this.guid++;
                    return (
                        (this.usePartial = this.usePartial || c.usePartial),
                        (this.children[d] = c),
                        (this.useDepths = this.useDepths || c.useDepths),
                        d
                    );
                },
                accept: function (a) {
                    if (!this[a.type]) throw new l["default"]("Unknown type: " + a.type, a);
                    this.sourceNode.unshift(a);
                    var b = this[a.type](a);
                    return this.sourceNode.shift(), b;
                },
                Program: function (a) {
                    this.options.blockParams.unshift(a.blockParams);
                    for (var b = a.body, c = b.length, d = 0; d < c; d++) this.accept(b[d]);
                    return (
                        this.options.blockParams.shift(),
                        (this.isSimple = 1 === c),
                        (this.blockParams = a.blockParams ? a.blockParams.length : 0),
                        this
                    );
                },
                BlockStatement: function (a) {
                    h(a);
                    var b = a.program,
                        c = a.inverse;
                    (b = b && this.compileProgram(b)), (c = c && this.compileProgram(c));
                    var d = this.classifySexpr(a);
                    "helper" === d
                        ? this.helperSexpr(a, b, c)
                        : "simple" === d
                        ? (this.simpleSexpr(a),
                          this.opcode("pushProgram", b),
                          this.opcode("pushProgram", c),
                          this.opcode("emptyHash"),
                          this.opcode("blockValue", a.path.original))
                        : (this.ambiguousSexpr(a, b, c),
                          this.opcode("pushProgram", b),
                          this.opcode("pushProgram", c),
                          this.opcode("emptyHash"),
                          this.opcode("ambiguousBlockValue")),
                        this.opcode("append");
                },
                DecoratorBlock: function (a) {
                    var b = a.program && this.compileProgram(a.program),
                        c = this.setupFullMustacheParams(a, b, void 0),
                        d = a.path;
                    (this.useDecorators = !0), this.opcode("registerDecorator", c.length, d.original);
                },
                PartialStatement: function (a) {
                    this.usePartial = !0;
                    var b = a.program;
                    b && (b = this.compileProgram(a.program));
                    var c = a.params;
                    if (c.length > 1) throw new l["default"]("Unsupported number of partial arguments: " + c.length, a);
                    c.length ||
                        (this.options.explicitPartialContext
                            ? this.opcode("pushLiteral", "undefined")
                            : c.push({ type: "PathExpression", parts: [], depth: 0 }));
                    var d = a.name.original,
                        e = "SubExpression" === a.name.type;
                    e && this.accept(a.name), this.setupFullMustacheParams(a, b, void 0, !0);
                    var f = a.indent || "";
                    this.options.preventIndent && f && (this.opcode("appendContent", f), (f = "")),
                        this.opcode("invokePartial", e, d, f),
                        this.opcode("append");
                },
                PartialBlockStatement: function (a) {
                    this.PartialStatement(a);
                },
                MustacheStatement: function (a) {
                    this.SubExpression(a), a.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
                },
                Decorator: function (a) {
                    this.DecoratorBlock(a);
                },
                ContentStatement: function (a) {
                    a.value && this.opcode("appendContent", a.value);
                },
                CommentStatement: function () {},
                SubExpression: function (a) {
                    h(a);
                    var b = this.classifySexpr(a);
                    "simple" === b ? this.simpleSexpr(a) : "helper" === b ? this.helperSexpr(a) : this.ambiguousSexpr(a);
                },
                ambiguousSexpr: function (a, b, c) {
                    var d = a.path,
                        e = d.parts[0],
                        f = null != b || null != c;
                    this.opcode("getContext", d.depth),
                        this.opcode("pushProgram", b),
                        this.opcode("pushProgram", c),
                        (d.strict = !0),
                        this.accept(d),
                        this.opcode("invokeAmbiguous", e, f);
                },
                simpleSexpr: function (a) {
                    var b = a.path;
                    (b.strict = !0), this.accept(b), this.opcode("resolvePossibleLambda");
                },
                helperSexpr: function (a, b, c) {
                    var d = this.setupFullMustacheParams(a, b, c),
                        e = a.path,
                        f = e.parts[0];
                    if (this.options.knownHelpers[f]) this.opcode("invokeKnownHelper", d.length, f);
                    else {
                        if (this.options.knownHelpersOnly)
                            throw new l["default"]("You specified knownHelpersOnly, but used the unknown helper " + f, a);
                        (e.strict = !0),
                            (e.falsy = !0),
                            this.accept(e),
                            this.opcode("invokeHelper", d.length, e.original, o["default"].helpers.simpleId(e));
                    }
                },
                PathExpression: function (a) {
                    this.addDepth(a.depth), this.opcode("getContext", a.depth);
                    var b = a.parts[0],
                        c = o["default"].helpers.scopedId(a),
                        d = !a.depth && !c && this.blockParamIndex(b);
                    d
                        ? this.opcode("lookupBlockParam", d, a.parts)
                        : b
                        ? a.data
                            ? ((this.options.data = !0), this.opcode("lookupData", a.depth, a.parts, a.strict))
                            : this.opcode("lookupOnContext", a.parts, a.falsy, a.strict, c)
                        : this.opcode("pushContext");
                },
                StringLiteral: function (a) {
                    this.opcode("pushString", a.value);
                },
                NumberLiteral: function (a) {
                    this.opcode("pushLiteral", a.value);
                },
                BooleanLiteral: function (a) {
                    this.opcode("pushLiteral", a.value);
                },
                UndefinedLiteral: function () {
                    this.opcode("pushLiteral", "undefined");
                },
                NullLiteral: function () {
                    this.opcode("pushLiteral", "null");
                },
                Hash: function (a) {
                    var b = a.pairs,
                        c = 0,
                        d = b.length;
                    for (this.opcode("pushHash"); c < d; c++) this.pushParam(b[c].value);
                    for (; c--; ) this.opcode("assignToHash", b[c].key);
                    this.opcode("popHash");
                },
                opcode: function (a) {
                    this.opcodes.push({ opcode: a, args: p.call(arguments, 1), loc: this.sourceNode[0].loc });
                },
                addDepth: function (a) {
                    a && (this.useDepths = !0);
                },
                classifySexpr: function (a) {
                    var b = o["default"].helpers.simpleId(a.path),
                        c = b && !!this.blockParamIndex(a.path.parts[0]),
                        d = !c && o["default"].helpers.helperExpression(a),
                        e = !c && (d || b);
                    if (e && !d) {
                        var f = a.path.parts[0],
                            g = this.options;
                        g.knownHelpers[f] ? (d = !0) : g.knownHelpersOnly && (e = !1);
                    }
                    return d ? "helper" : e ? "ambiguous" : "simple";
                },
                pushParams: function (a) {
                    for (var b = 0, c = a.length; b < c; b++) this.pushParam(a[b]);
                },
                pushParam: function (a) {
                    var b = null != a.value ? a.value : a.original || "";
                    if (this.stringParams)
                        b.replace && (b = b.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")),
                            a.depth && this.addDepth(a.depth),
                            this.opcode("getContext", a.depth || 0),
                            this.opcode("pushStringParam", b, a.type),
                            "SubExpression" === a.type && this.accept(a);
                    else {
                        if (this.trackIds) {
                            var c = void 0;
                            if ((!a.parts || o["default"].helpers.scopedId(a) || a.depth || (c = this.blockParamIndex(a.parts[0])), c)) {
                                var d = a.parts.slice(1).join(".");
                                this.opcode("pushId", "BlockParam", c, d);
                            } else
                                (b = a.original || b),
                                    b.replace &&
                                        (b = b
                                            .replace(/^this(?:\.|$)/, "")
                                            .replace(/^\.\//, "")
                                            .replace(/^\.$/, "")),
                                    this.opcode("pushId", a.type, b);
                        }
                        this.accept(a);
                    }
                },
                setupFullMustacheParams: function (a, b, c, d) {
                    var e = a.params;
                    return (
                        this.pushParams(e),
                        this.opcode("pushProgram", b),
                        this.opcode("pushProgram", c),
                        a.hash ? this.accept(a.hash) : this.opcode("emptyHash", d),
                        e
                    );
                },
                blockParamIndex: function (a) {
                    for (var b = 0, c = this.options.blockParams.length; b < c; b++) {
                        var d = this.options.blockParams[b],
                            e = d && m.indexOf(d, a);
                        if (d && e >= 0) return [b, e];
                    }
                },
            };
        },
        function (a, b, c) {
            "use strict";
            function d(a) {
                this.value = a;
            }
            function e() {}
            function f(a, b, c, d) {
                var e = b.popStack(),
                    f = 0,
                    g = c.length;
                for (a && g--; f < g; f++) e = b.nameLookup(e, c[f], d);
                return a
                    ? [b.aliasable("container.strict"), "(", e, ", ", b.quotedString(c[f]), ", ", JSON.stringify(b.source.currentLocation), " )"]
                    : e;
            }
            var g = c(13)["default"],
                h = c(1)["default"];
            b.__esModule = !0;
            var i = c(4),
                j = c(6),
                k = h(j),
                l = c(5),
                m = c(53),
                n = h(m);
            (e.prototype = {
                nameLookup: function (a, b) {
                    return this.internalNameLookup(a, b);
                },
                depthedLookup: function (a) {
                    return [this.aliasable("container.lookup"), '(depths, "', a, '")'];
                },
                compilerInfo: function () {
                    var a = i.COMPILER_REVISION,
                        b = i.REVISION_CHANGES[a];
                    return [a, b];
                },
                appendToBuffer: function (a, b, c) {
                    return (
                        l.isArray(a) || (a = [a]),
                        (a = this.source.wrap(a, b)),
                        this.environment.isSimple ? ["return ", a, ";"] : c ? ["buffer += ", a, ";"] : ((a.appendToBuffer = !0), a)
                    );
                },
                initializeBuffer: function () {
                    return this.quotedString("");
                },
                internalNameLookup: function (a, b) {
                    return (this.lookupPropertyFunctionIsUsed = !0), ["lookupProperty(", a, ",", JSON.stringify(b), ")"];
                },
                lookupPropertyFunctionIsUsed: !1,
                compile: function (a, b, c, d) {
                    (this.environment = a),
                        (this.options = b),
                        (this.stringParams = this.options.stringParams),
                        (this.trackIds = this.options.trackIds),
                        (this.precompile = !d),
                        (this.name = this.environment.name),
                        (this.isChild = !!c),
                        (this.context = c || { decorators: [], programs: [], environments: [] }),
                        this.preamble(),
                        (this.stackSlot = 0),
                        (this.stackVars = []),
                        (this.aliases = {}),
                        (this.registers = { list: [] }),
                        (this.hashes = []),
                        (this.compileStack = []),
                        (this.inlineStack = []),
                        (this.blockParams = []),
                        this.compileChildren(a, b),
                        (this.useDepths = this.useDepths || a.useDepths || a.useDecorators || this.options.compat),
                        (this.useBlockParams = this.useBlockParams || a.useBlockParams);
                    var e = a.opcodes,
                        f = void 0,
                        g = void 0,
                        h = void 0,
                        i = void 0;
                    for (h = 0, i = e.length; h < i; h++)
                        (f = e[h]), (this.source.currentLocation = f.loc), (g = g || f.loc), this[f.opcode].apply(this, f.args);
                    if (
                        ((this.source.currentLocation = g),
                        this.pushSource(""),
                        this.stackSlot || this.inlineStack.length || this.compileStack.length)
                    )
                        throw new k["default"]("Compile completed with content left on stack");
                    this.decorators.isEmpty()
                        ? (this.decorators = void 0)
                        : ((this.useDecorators = !0),
                          this.decorators.prepend(["var decorators = container.decorators, ", this.lookupPropertyFunctionVarDeclaration(), ";\n"]),
                          this.decorators.push("return fn;"),
                          d
                              ? (this.decorators = Function.apply(this, [
                                    "fn",
                                    "props",
                                    "container",
                                    "depth0",
                                    "data",
                                    "blockParams",
                                    "depths",
                                    this.decorators.merge(),
                                ]))
                              : (this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"),
                                this.decorators.push("}\n"),
                                (this.decorators = this.decorators.merge())));
                    var j = this.createFunctionContext(d);
                    if (this.isChild) return j;
                    var l = { compiler: this.compilerInfo(), main: j };
                    this.decorators && ((l.main_d = this.decorators), (l.useDecorators = !0));
                    var m = this.context,
                        n = m.programs,
                        o = m.decorators;
                    for (h = 0, i = n.length; h < i; h++) n[h] && ((l[h] = n[h]), o[h] && ((l[h + "_d"] = o[h]), (l.useDecorators = !0)));
                    return (
                        this.environment.usePartial && (l.usePartial = !0),
                        this.options.data && (l.useData = !0),
                        this.useDepths && (l.useDepths = !0),
                        this.useBlockParams && (l.useBlockParams = !0),
                        this.options.compat && (l.compat = !0),
                        d
                            ? (l.compilerOptions = this.options)
                            : ((l.compiler = JSON.stringify(l.compiler)),
                              (this.source.currentLocation = { start: { line: 1, column: 0 } }),
                              (l = this.objectLiteral(l)),
                              b.srcName
                                  ? ((l = l.toStringWithSourceMap({ file: b.destName })), (l.map = l.map && l.map.toString()))
                                  : (l = l.toString())),
                        l
                    );
                },
                preamble: function () {
                    (this.lastContext = 0),
                        (this.source = new n["default"](this.options.srcName)),
                        (this.decorators = new n["default"](this.options.srcName));
                },
                createFunctionContext: function (a) {
                    var b = this,
                        c = "",
                        d = this.stackVars.concat(this.registers.list);
                    d.length > 0 && (c += ", " + d.join(", "));
                    var e = 0;
                    g(this.aliases).forEach(function (a) {
                        var d = b.aliases[a];
                        d.children && d.referenceCount > 1 && ((c += ", alias" + ++e + "=" + a), (d.children[0] = "alias" + e));
                    }),
                        this.lookupPropertyFunctionIsUsed && (c += ", " + this.lookupPropertyFunctionVarDeclaration());
                    var f = ["container", "depth0", "helpers", "partials", "data"];
                    (this.useBlockParams || this.useDepths) && f.push("blockParams"), this.useDepths && f.push("depths");
                    var h = this.mergeSource(c);
                    return a ? (f.push(h), Function.apply(this, f)) : this.source.wrap(["function(", f.join(","), ") {\n  ", h, "}"]);
                },
                mergeSource: function (a) {
                    var b = this.environment.isSimple,
                        c = !this.forceBuffer,
                        d = void 0,
                        e = void 0,
                        f = void 0,
                        g = void 0;
                    return (
                        this.source.each(function (a) {
                            a.appendToBuffer
                                ? (f ? a.prepend("  + ") : (f = a), (g = a))
                                : (f && (e ? f.prepend("buffer += ") : (d = !0), g.add(";"), (f = g = void 0)), (e = !0), b || (c = !1));
                        }),
                        c
                            ? f
                                ? (f.prepend("return "), g.add(";"))
                                : e || this.source.push('return "";')
                            : ((a += ", buffer = " + (d ? "" : this.initializeBuffer())),
                              f ? (f.prepend("return buffer + "), g.add(";")) : this.source.push("return buffer;")),
                        a && this.source.prepend("var " + a.substring(2) + (d ? "" : ";\n")),
                        this.source.merge()
                    );
                },
                lookupPropertyFunctionVarDeclaration: function () {
                    return "\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim();
                },
                blockValue: function (a) {
                    var b = this.aliasable("container.hooks.blockHelperMissing"),
                        c = [this.contextName(0)];
                    this.setupHelperArgs(a, 0, c);
                    var d = this.popStack();
                    c.splice(1, 0, d), this.push(this.source.functionCall(b, "call", c));
                },
                ambiguousBlockValue: function () {
                    var a = this.aliasable("container.hooks.blockHelperMissing"),
                        b = [this.contextName(0)];
                    this.setupHelperArgs("", 0, b, !0), this.flushInline();
                    var c = this.topStack();
                    b.splice(1, 0, c), this.pushSource(["if (!", this.lastHelper, ") { ", c, " = ", this.source.functionCall(a, "call", b), "}"]);
                },
                appendContent: function (a) {
                    this.pendingContent ? (a = this.pendingContent + a) : (this.pendingLocation = this.source.currentLocation),
                        (this.pendingContent = a);
                },
                append: function () {
                    if (this.isInline())
                        this.replaceStack(function (a) {
                            return [" != null ? ", a, ' : ""'];
                        }),
                            this.pushSource(this.appendToBuffer(this.popStack()));
                    else {
                        var a = this.popStack();
                        this.pushSource(["if (", a, " != null) { ", this.appendToBuffer(a, void 0, !0), " }"]),
                            this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
                    }
                },
                appendEscaped: function () {
                    this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
                },
                getContext: function (a) {
                    this.lastContext = a;
                },
                pushContext: function () {
                    this.pushStackLiteral(this.contextName(this.lastContext));
                },
                lookupOnContext: function (a, b, c, d) {
                    var e = 0;
                    d || !this.options.compat || this.lastContext ? this.pushContext() : this.push(this.depthedLookup(a[e++])),
                        this.resolvePath("context", a, e, b, c);
                },
                lookupBlockParam: function (a, b) {
                    (this.useBlockParams = !0), this.push(["blockParams[", a[0], "][", a[1], "]"]), this.resolvePath("context", b, 1);
                },
                lookupData: function (a, b, c) {
                    a ? this.pushStackLiteral("container.data(data, " + a + ")") : this.pushStackLiteral("data"),
                        this.resolvePath("data", b, 0, !0, c);
                },
                resolvePath: function (a, b, c, d, e) {
                    var g = this;
                    if (this.options.strict || this.options.assumeObjects) return void this.push(f(this.options.strict && e, this, b, a));
                    for (var h = b.length; c < h; c++)
                        this.replaceStack(function (e) {
                            var f = g.nameLookup(e, b[c], a);
                            return d ? [" && ", f] : [" != null ? ", f, " : ", e];
                        });
                },
                resolvePossibleLambda: function () {
                    this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
                },
                pushStringParam: function (a, b) {
                    this.pushContext(),
                        this.pushString(b),
                        "SubExpression" !== b && ("string" == typeof a ? this.pushString(a) : this.pushStackLiteral(a));
                },
                emptyHash: function (a) {
                    this.trackIds && this.push("{}"),
                        this.stringParams && (this.push("{}"), this.push("{}")),
                        this.pushStackLiteral(a ? "undefined" : "{}");
                },
                pushHash: function () {
                    this.hash && this.hashes.push(this.hash), (this.hash = { values: {}, types: [], contexts: [], ids: [] });
                },
                popHash: function () {
                    var a = this.hash;
                    (this.hash = this.hashes.pop()),
                        this.trackIds && this.push(this.objectLiteral(a.ids)),
                        this.stringParams && (this.push(this.objectLiteral(a.contexts)), this.push(this.objectLiteral(a.types))),
                        this.push(this.objectLiteral(a.values));
                },
                pushString: function (a) {
                    this.pushStackLiteral(this.quotedString(a));
                },
                pushLiteral: function (a) {
                    this.pushStackLiteral(a);
                },
                pushProgram: function (a) {
                    null != a ? this.pushStackLiteral(this.programExpression(a)) : this.pushStackLiteral(null);
                },
                registerDecorator: function (a, b) {
                    var c = this.nameLookup("decorators", b, "decorator"),
                        d = this.setupHelperArgs(b, a);
                    this.decorators.push(["fn = ", this.decorators.functionCall(c, "", ["fn", "props", "container", d]), " || fn;"]);
                },
                invokeHelper: function (a, b, c) {
                    var d = this.popStack(),
                        e = this.setupHelper(a, b),
                        f = [];
                    c && f.push(e.name), f.push(d), this.options.strict || f.push(this.aliasable("container.hooks.helperMissing"));
                    var g = ["(", this.itemsSeparatedBy(f, "||"), ")"],
                        h = this.source.functionCall(g, "call", e.callParams);
                    this.push(h);
                },
                itemsSeparatedBy: function (a, b) {
                    var c = [];
                    c.push(a[0]);
                    for (var d = 1; d < a.length; d++) c.push(b, a[d]);
                    return c;
                },
                invokeKnownHelper: function (a, b) {
                    var c = this.setupHelper(a, b);
                    this.push(this.source.functionCall(c.name, "call", c.callParams));
                },
                invokeAmbiguous: function (a, b) {
                    this.useRegister("helper");
                    var c = this.popStack();
                    this.emptyHash();
                    var d = this.setupHelper(0, a, b),
                        e = (this.lastHelper = this.nameLookup("helpers", a, "helper")),
                        f = ["(", "(helper = ", e, " || ", c, ")"];
                    this.options.strict || ((f[0] = "(helper = "), f.push(" != null ? helper : ", this.aliasable("container.hooks.helperMissing"))),
                        this.push([
                            "(",
                            f,
                            d.paramsInit ? ["),(", d.paramsInit] : [],
                            "),",
                            "(typeof helper === ",
                            this.aliasable('"function"'),
                            " ? ",
                            this.source.functionCall("helper", "call", d.callParams),
                            " : helper))",
                        ]);
                },
                invokePartial: function (a, b, c) {
                    var d = [],
                        e = this.setupParams(b, 1, d);
                    a && ((b = this.popStack()), delete e.name),
                        c && (e.indent = JSON.stringify(c)),
                        (e.helpers = "helpers"),
                        (e.partials = "partials"),
                        (e.decorators = "container.decorators"),
                        a ? d.unshift(b) : d.unshift(this.nameLookup("partials", b, "partial")),
                        this.options.compat && (e.depths = "depths"),
                        (e = this.objectLiteral(e)),
                        d.push(e),
                        this.push(this.source.functionCall("container.invokePartial", "", d));
                },
                assignToHash: function (a) {
                    var b = this.popStack(),
                        c = void 0,
                        d = void 0,
                        e = void 0;
                    this.trackIds && (e = this.popStack()), this.stringParams && ((d = this.popStack()), (c = this.popStack()));
                    var f = this.hash;
                    c && (f.contexts[a] = c), d && (f.types[a] = d), e && (f.ids[a] = e), (f.values[a] = b);
                },
                pushId: function (a, b, c) {
                    "BlockParam" === a
                        ? this.pushStackLiteral("blockParams[" + b[0] + "].path[" + b[1] + "]" + (c ? " + " + JSON.stringify("." + c) : ""))
                        : "PathExpression" === a
                        ? this.pushString(b)
                        : "SubExpression" === a
                        ? this.pushStackLiteral("true")
                        : this.pushStackLiteral("null");
                },
                compiler: e,
                compileChildren: function (a, b) {
                    for (var c = a.children, d = void 0, e = void 0, f = 0, g = c.length; f < g; f++) {
                        (d = c[f]), (e = new this.compiler());
                        var h = this.matchExistingProgram(d);
                        if (null == h) {
                            this.context.programs.push("");
                            var i = this.context.programs.length;
                            (d.index = i),
                                (d.name = "program" + i),
                                (this.context.programs[i] = e.compile(d, b, this.context, !this.precompile)),
                                (this.context.decorators[i] = e.decorators),
                                (this.context.environments[i] = d),
                                (this.useDepths = this.useDepths || e.useDepths),
                                (this.useBlockParams = this.useBlockParams || e.useBlockParams),
                                (d.useDepths = this.useDepths),
                                (d.useBlockParams = this.useBlockParams);
                        } else
                            (d.index = h.index),
                                (d.name = "program" + h.index),
                                (this.useDepths = this.useDepths || h.useDepths),
                                (this.useBlockParams = this.useBlockParams || h.useBlockParams);
                    }
                },
                matchExistingProgram: function (a) {
                    for (var b = 0, c = this.context.environments.length; b < c; b++) {
                        var d = this.context.environments[b];
                        if (d && d.equals(a)) return d;
                    }
                },
                programExpression: function (a) {
                    var b = this.environment.children[a],
                        c = [b.index, "data", b.blockParams];
                    return (
                        (this.useBlockParams || this.useDepths) && c.push("blockParams"),
                        this.useDepths && c.push("depths"),
                        "container.program(" + c.join(", ") + ")"
                    );
                },
                useRegister: function (a) {
                    this.registers[a] || ((this.registers[a] = !0), this.registers.list.push(a));
                },
                push: function (a) {
                    return a instanceof d || (a = this.source.wrap(a)), this.inlineStack.push(a), a;
                },
                pushStackLiteral: function (a) {
                    this.push(new d(a));
                },
                pushSource: function (a) {
                    this.pendingContent &&
                        (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)),
                        (this.pendingContent = void 0)),
                        a && this.source.push(a);
                },
                replaceStack: function (a) {
                    var b = ["("],
                        c = void 0,
                        e = void 0,
                        f = void 0;
                    if (!this.isInline()) throw new k["default"]("replaceStack on non-inline");
                    var g = this.popStack(!0);
                    if (g instanceof d) (c = [g.value]), (b = ["(", c]), (f = !0);
                    else {
                        e = !0;
                        var h = this.incrStack();
                        (b = ["((", this.push(h), " = ", g, ")"]), (c = this.topStack());
                    }
                    var i = a.call(this, c);
                    f || this.popStack(), e && this.stackSlot--, this.push(b.concat(i, ")"));
                },
                incrStack: function () {
                    return (
                        this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName()
                    );
                },
                topStackName: function () {
                    return "stack" + this.stackSlot;
                },
                flushInline: function () {
                    var a = this.inlineStack;
                    this.inlineStack = [];
                    for (var b = 0, c = a.length; b < c; b++) {
                        var e = a[b];
                        if (e instanceof d) this.compileStack.push(e);
                        else {
                            var f = this.incrStack();
                            this.pushSource([f, " = ", e, ";"]), this.compileStack.push(f);
                        }
                    }
                },
                isInline: function () {
                    return this.inlineStack.length;
                },
                popStack: function (a) {
                    var b = this.isInline(),
                        c = (b ? this.inlineStack : this.compileStack).pop();
                    if (!a && c instanceof d) return c.value;
                    if (!b) {
                        if (!this.stackSlot) throw new k["default"]("Invalid stack pop");
                        this.stackSlot--;
                    }
                    return c;
                },
                topStack: function () {
                    var a = this.isInline() ? this.inlineStack : this.compileStack,
                        b = a[a.length - 1];
                    return b instanceof d ? b.value : b;
                },
                contextName: function (a) {
                    return this.useDepths && a ? "depths[" + a + "]" : "depth" + a;
                },
                quotedString: function (a) {
                    return this.source.quotedString(a);
                },
                objectLiteral: function (a) {
                    return this.source.objectLiteral(a);
                },
                aliasable: function (a) {
                    var b = this.aliases[a];
                    return b ? (b.referenceCount++, b) : ((b = this.aliases[a] = this.source.wrap(a)), (b.aliasable = !0), (b.referenceCount = 1), b);
                },
                setupHelper: function (a, b, c) {
                    var d = [],
                        e = this.setupHelperArgs(b, a, d, c),
                        f = this.nameLookup("helpers", b, "helper"),
                        g = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})");
                    return { params: d, paramsInit: e, name: f, callParams: [g].concat(d) };
                },
                setupParams: function (a, b, c) {
                    var d = {},
                        e = [],
                        f = [],
                        g = [],
                        h = !c,
                        i = void 0;
                    h && (c = []),
                        (d.name = this.quotedString(a)),
                        (d.hash = this.popStack()),
                        this.trackIds && (d.hashIds = this.popStack()),
                        this.stringParams && ((d.hashTypes = this.popStack()), (d.hashContexts = this.popStack()));
                    var j = this.popStack(),
                        k = this.popStack();
                    (k || j) && ((d.fn = k || "container.noop"), (d.inverse = j || "container.noop"));
                    for (var l = b; l--; )
                        (i = this.popStack()),
                            (c[l] = i),
                            this.trackIds && (g[l] = this.popStack()),
                            this.stringParams && ((f[l] = this.popStack()), (e[l] = this.popStack()));
                    return (
                        h && (d.args = this.source.generateArray(c)),
                        this.trackIds && (d.ids = this.source.generateArray(g)),
                        this.stringParams && ((d.types = this.source.generateArray(f)), (d.contexts = this.source.generateArray(e))),
                        this.options.data && (d.data = "data"),
                        this.useBlockParams && (d.blockParams = "blockParams"),
                        d
                    );
                },
                setupHelperArgs: function (a, b, c, d) {
                    var e = this.setupParams(a, b, c);
                    return (
                        (e.loc = JSON.stringify(this.source.currentLocation)),
                        (e = this.objectLiteral(e)),
                        d ? (this.useRegister("options"), c.push("options"), ["options=", e]) : c ? (c.push(e), "") : e
                    );
                },
            }),
                (function () {
                    for (
                        var a = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                                " "
                            ),
                            b = (e.RESERVED_WORDS = {}),
                            c = 0,
                            d = a.length;
                        c < d;
                        c++
                    )
                        b[a[c]] = !0;
                })(),
                (e.isValidJavaScriptVariableName = function (a) {
                    return !e.RESERVED_WORDS[a] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a);
                }),
                (b["default"] = e),
                (a.exports = b["default"]);
        },
        function (a, b, c) {
            "use strict";
            function d(a, b, c) {
                if (g.isArray(a)) {
                    for (var d = [], e = 0, f = a.length; e < f; e++) d.push(b.wrap(a[e], c));
                    return d;
                }
                return "boolean" == typeof a || "number" == typeof a ? a + "" : a;
            }
            function e(a) {
                (this.srcFile = a), (this.source = []);
            }
            var f = c(13)["default"];
            b.__esModule = !0;
            var g = c(5),
                h = void 0;
            try {
            } catch (i) {}
            h ||
                ((h = function (a, b, c, d) {
                    (this.src = ""), d && this.add(d);
                }),
                (h.prototype = {
                    add: function (a) {
                        g.isArray(a) && (a = a.join("")), (this.src += a);
                    },
                    prepend: function (a) {
                        g.isArray(a) && (a = a.join("")), (this.src = a + this.src);
                    },
                    toStringWithSourceMap: function () {
                        return { code: this.toString() };
                    },
                    toString: function () {
                        return this.src;
                    },
                })),
                (e.prototype = {
                    isEmpty: function () {
                        return !this.source.length;
                    },
                    prepend: function (a, b) {
                        this.source.unshift(this.wrap(a, b));
                    },
                    push: function (a, b) {
                        this.source.push(this.wrap(a, b));
                    },
                    merge: function () {
                        var a = this.empty();
                        return (
                            this.each(function (b) {
                                a.add(["  ", b, "\n"]);
                            }),
                            a
                        );
                    },
                    each: function (a) {
                        for (var b = 0, c = this.source.length; b < c; b++) a(this.source[b]);
                    },
                    empty: function () {
                        var a = this.currentLocation || { start: {} };
                        return new h(a.start.line, a.start.column, this.srcFile);
                    },
                    wrap: function (a) {
                        var b = arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || { start: {} } : arguments[1];
                        return a instanceof h ? a : ((a = d(a, this, b)), new h(b.start.line, b.start.column, this.srcFile, a));
                    },
                    functionCall: function (a, b, c) {
                        return (c = this.generateList(c)), this.wrap([a, b ? "." + b + "(" : "(", c, ")"]);
                    },
                    quotedString: function (a) {
                        return (
                            '"' +
                            (a + "")
                                .replace(/\\/g, "\\\\")
                                .replace(/"/g, '\\"')
                                .replace(/\n/g, "\\n")
                                .replace(/\r/g, "\\r")
                                .replace(/\u2028/g, "\\u2028")
                                .replace(/\u2029/g, "\\u2029") +
                            '"'
                        );
                    },
                    objectLiteral: function (a) {
                        var b = this,
                            c = [];
                        f(a).forEach(function (e) {
                            var f = d(a[e], b);
                            "undefined" !== f && c.push([b.quotedString(e), ":", f]);
                        });
                        var e = this.generateList(c);
                        return e.prepend("{"), e.add("}"), e;
                    },
                    generateList: function (a) {
                        for (var b = this.empty(), c = 0, e = a.length; c < e; c++) c && b.add(","), b.add(d(a[c], this));
                        return b;
                    },
                    generateArray: function (a) {
                        var b = this.generateList(a);
                        return b.prepend("["), b.add("]"), b;
                    },
                }),
                (b["default"] = e),
                (a.exports = b["default"]);
        },
    ]);
});

/*!
 * prepare-transition.min.js
 */
/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
!(function (e) {
    e.fn.prepareTransition = function () {
        return this.each(function () {
            var t = e(this);
            t.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
                t.removeClass("is-transitioning");
            });
            var n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                i = 0;
            e.each(n, function (e, n) {
                i || (i = parseFloat(t.css(n)));
            }),
                0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
        });
    };
})(jQuery);

/*! Magnific Popup - v1.1.0 - 2016-02-20
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2016 Dmitry Semenov; */
(function (factory) {
    if (typeof define === "function" && define.amd) {
        // AMD. Register as an anonymous module.
        define(["jquery"], factory);
    } else if (typeof exports === "object") {
        // Node/CommonJS
        factory(require("jquery"));
    } else {
        // Browser globals
        factory(window.jQuery || window.Zepto);
    }
})(function ($) {
    /*>>core*/
    /**
     *
     * Magnific Popup Core JS file
     *
     */

    /**
     * Private static constants
     */
    var CLOSE_EVENT = "Close",
        BEFORE_CLOSE_EVENT = "BeforeClose",
        AFTER_CLOSE_EVENT = "AfterClose",
        BEFORE_APPEND_EVENT = "BeforeAppend",
        MARKUP_PARSE_EVENT = "MarkupParse",
        OPEN_EVENT = "Open",
        CHANGE_EVENT = "Change",
        NS = "mfp",
        EVENT_NS = "." + NS,
        READY_CLASS = "mfp-ready",
        REMOVING_CLASS = "mfp-removing",
        PREVENT_CLOSE_CLASS = "mfp-prevent-close";

    /**
     * Private vars
     */
    /*jshint -W079 */
    var mfp, // As we have only one instance of MagnificPopup object, we define it locally to not to use 'this'
        MagnificPopup = function () {},
        _isJQ = !!window.jQuery,
        _prevStatus,
        _window = $(window),
        _document,
        _prevContentType,
        _wrapClasses,
        _currPopupType;

    /**
     * Private functions
     */
    var _mfpOn = function (name, f) {
            mfp.ev.on(NS + name + EVENT_NS, f);
        },
        _getEl = function (className, appendTo, html, raw) {
            var el = document.createElement("div");
            el.className = "mfp-" + className;
            if (html) {
                el.innerHTML = html;
            }
            if (!raw) {
                el = $(el);
                if (appendTo) {
                    el.appendTo(appendTo);
                }
            } else if (appendTo) {
                appendTo.appendChild(el);
            }
            return el;
        },
        _mfpTrigger = function (e, data) {
            mfp.ev.triggerHandler(NS + e, data);

            if (mfp.st.callbacks) {
                // converts "mfpEventName" to "eventName" callback and triggers it if it's present
                e = e.charAt(0).toLowerCase() + e.slice(1);
                if (mfp.st.callbacks[e]) {
                    mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [data]);
                }
            }
        },
        _getCloseBtn = function (type) {
            if (type !== _currPopupType || !mfp.currTemplate.closeBtn) {
                mfp.currTemplate.closeBtn = $(mfp.st.closeMarkup.replace("%title%", mfp.st.tClose));
                _currPopupType = type;
            }
            return mfp.currTemplate.closeBtn;
        },
        // Initialize Magnific Popup only when called at least once
        _checkInstance = function () {
            if (!$.magnificPopup.instance) {
                /*jshint -W020 */
                mfp = new MagnificPopup();
                mfp.init();
                $.magnificPopup.instance = mfp;
            }
        },
        // CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
        supportsTransitions = function () {
            var s = document.createElement("p").style, // 's' for style. better to create an element if body yet to exist
                v = ["ms", "O", "Moz", "Webkit"]; // 'v' for vendor

            if (s["transition"] !== undefined) {
                return true;
            }

            while (v.length) {
                if (v.pop() + "Transition" in s) {
                    return true;
                }
            }

            return false;
        };

    /**
     * Public functions
     */
    MagnificPopup.prototype = {
        constructor: MagnificPopup,

        /**
         * Initializes Magnific Popup plugin.
         * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
         */
        init: function () {
            var appVersion = navigator.appVersion;
            mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener;
            mfp.isAndroid = /android/gi.test(appVersion);
            mfp.isIOS = /iphone|ipad|ipod/gi.test(appVersion);
            mfp.supportsTransition = supportsTransitions();

            // We disable fixed positioned lightbox on devices that don't handle it nicely.
            // If you know a better way of detecting this - let me know.
            mfp.probablyMobile =
                mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent);
            _document = $(document);

            mfp.popupsCache = {};
        },

        /**
         * Opens popup
         * @param  data [description]
         */
        open: function (data) {
            var i;

            if (data.isObj === false) {
                // convert jQuery collection to array to avoid conflicts later
                mfp.items = data.items.toArray();

                mfp.index = 0;
                var items = data.items,
                    item;
                for (i = 0; i < items.length; i++) {
                    item = items[i];
                    if (item.parsed) {
                        item = item.el[0];
                    }
                    if (item === data.el[0]) {
                        mfp.index = i;
                        break;
                    }
                }
            } else {
                mfp.items = $.isArray(data.items) ? data.items : [data.items];
                mfp.index = data.index || 0;
            }

            // if popup is already opened - we just update the content
            if (mfp.isOpen) {
                mfp.updateItemHTML();
                return;
            }

            mfp.types = [];
            _wrapClasses = "";
            if (data.mainEl && data.mainEl.length) {
                mfp.ev = data.mainEl.eq(0);
            } else {
                mfp.ev = _document;
            }

            if (data.key) {
                if (!mfp.popupsCache[data.key]) {
                    mfp.popupsCache[data.key] = {};
                }
                mfp.currTemplate = mfp.popupsCache[data.key];
            } else {
                mfp.currTemplate = {};
            }

            mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data);
            mfp.fixedContentPos = mfp.st.fixedContentPos === "auto" ? !mfp.probablyMobile : mfp.st.fixedContentPos;

            if (mfp.st.modal) {
                mfp.st.closeOnContentClick = false;
                mfp.st.closeOnBgClick = false;
                mfp.st.showCloseBtn = false;
                mfp.st.enableEscapeKey = false;
            }

            // Building markup
            // main containers are created only once
            if (!mfp.bgOverlay) {
                // Dark overlay
                mfp.bgOverlay = _getEl("bg").on("click" + EVENT_NS, function () {
                    mfp.close();
                });

                mfp.wrap = _getEl("wrap")
                    .attr("tabindex", -1)
                    .on("click" + EVENT_NS, function (e) {
                        if (mfp._checkIfClose(e.target)) {
                            mfp.close();
                        }
                    });

                mfp.container = _getEl("container", mfp.wrap);
            }

            mfp.contentContainer = _getEl("content");
            if (mfp.st.preloader) {
                mfp.preloader = _getEl("preloader", mfp.container, mfp.st.tLoading);
            }

            // Initializing modules
            var modules = $.magnificPopup.modules;
            for (i = 0; i < modules.length; i++) {
                var n = modules[i];
                n = n.charAt(0).toUpperCase() + n.slice(1);
                mfp["init" + n].call(mfp);
            }
            _mfpTrigger("BeforeOpen");

            if (mfp.st.showCloseBtn) {
                // Close button
                if (!mfp.st.closeBtnInside) {
                    mfp.wrap.append(_getCloseBtn());
                } else {
                    _mfpOn(MARKUP_PARSE_EVENT, function (e, template, values, item) {
                        values.close_replaceWith = _getCloseBtn(item.type);
                    });
                    _wrapClasses += " mfp-close-btn-in";
                }
            }

            if (mfp.st.alignTop) {
                _wrapClasses += " mfp-align-top";
            }

            if (mfp.fixedContentPos) {
                mfp.wrap.css({
                    overflow: mfp.st.overflowY,
                    overflowX: "hidden",
                    overflowY: mfp.st.overflowY,
                });
            } else {
                mfp.wrap.css({
                    top: _window.scrollTop(),
                    position: "absolute",
                });
            }
            if (mfp.st.fixedBgPos === false || (mfp.st.fixedBgPos === "auto" && !mfp.fixedContentPos)) {
                mfp.bgOverlay.css({
                    height: _document.height(),
                    position: "absolute",
                });
            }

            if (mfp.st.enableEscapeKey) {
                // Close on ESC key
                _document.on("keyup" + EVENT_NS, function (e) {
                    if (e.keyCode === 27) {
                        mfp.close();
                    }
                });
            }

            _window.on("resize" + EVENT_NS, function () {
                mfp.updateSize();
            });

            if (!mfp.st.closeOnContentClick) {
                _wrapClasses += " mfp-auto-cursor";
            }

            if (_wrapClasses) mfp.wrap.addClass(_wrapClasses);

            // this triggers recalculation of layout, so we get it once to not to trigger twice
            var windowHeight = (mfp.wH = _window.height());

            var windowStyles = {};

            if (mfp.fixedContentPos) {
                if (mfp._hasScrollBar(windowHeight)) {
                    var s = mfp._getScrollbarSize();
                    if (s) {
                        windowStyles.marginRight = s;
                    }
                }
            }

            if (mfp.fixedContentPos) {
                if (!mfp.isIE7) {
                    windowStyles.overflow = "hidden";
                } else {
                    // ie7 double-scroll bug
                    $("body, html").css("overflow", "hidden");
                }
            }

            var classesToadd = mfp.st.mainClass;
            if (mfp.isIE7) {
                classesToadd += " mfp-ie7";
            }
            if (classesToadd) {
                mfp._addClassToMFP(classesToadd);
            }

            // add content
            mfp.updateItemHTML();

            _mfpTrigger("BuildControls");

            // remove scrollbar, add margin e.t.c
            $("html").css(windowStyles);

            // add everything to DOM
            mfp.bgOverlay.add(mfp.wrap).prependTo(mfp.st.prependTo || $(document.body));

            // Save last focused element
            mfp._lastFocusedEl = document.activeElement;

            // Wait for next cycle to allow CSS transition
            setTimeout(function () {
                if (mfp.content) {
                    mfp._addClassToMFP(READY_CLASS);
                    mfp._setFocus();
                } else {
                    // if content is not defined (not loaded e.t.c) we add class only for BG
                    mfp.bgOverlay.addClass(READY_CLASS);
                }

                // Trap the focus in popup
                _document.on("focusin" + EVENT_NS, mfp._onFocusIn);
            }, 16);

            mfp.isOpen = true;
            mfp.updateSize(windowHeight);
            _mfpTrigger(OPEN_EVENT);

            return data;
        },

        /**
         * Closes the popup
         */
        close: function () {
            if (!mfp.isOpen) return;
            _mfpTrigger(BEFORE_CLOSE_EVENT);

            mfp.isOpen = false;
            // for CSS3 animation
            if (mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition) {
                mfp._addClassToMFP(REMOVING_CLASS);
                setTimeout(function () {
                    mfp._close();
                }, mfp.st.removalDelay);
            } else {
                mfp._close();
            }
        },

        /**
         * Helper for close() function
         */
        _close: function () {
            _mfpTrigger(CLOSE_EVENT);

            var classesToRemove = REMOVING_CLASS + " " + READY_CLASS + " ";

            mfp.bgOverlay.detach();
            mfp.wrap.detach();
            mfp.container.empty();

            if (mfp.st.mainClass) {
                classesToRemove += mfp.st.mainClass + " ";
            }

            mfp._removeClassFromMFP(classesToRemove);

            if (mfp.fixedContentPos) {
                var windowStyles = { marginRight: "" };
                if (mfp.isIE7) {
                    $("body, html").css("overflow", "");
                } else {
                    windowStyles.overflow = "";
                }
                $("html").css(windowStyles);
            }

            _document.off("keyup" + EVENT_NS + " focusin" + EVENT_NS);
            mfp.ev.off(EVENT_NS);

            // clean up DOM elements that aren't removed
            mfp.wrap.attr("class", "mfp-wrap").removeAttr("style");
            mfp.bgOverlay.attr("class", "mfp-bg");
            mfp.container.attr("class", "mfp-container");

            // remove close button from target element
            if (mfp.st.showCloseBtn && (!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
                if (mfp.currTemplate.closeBtn) mfp.currTemplate.closeBtn.detach();
            }

            if (mfp.st.autoFocusLast && mfp._lastFocusedEl) {
                $(mfp._lastFocusedEl).focus(); // put tab focus back
            }
            mfp.currItem = null;
            mfp.content = null;
            mfp.currTemplate = null;
            mfp.prevHeight = 0;

            _mfpTrigger(AFTER_CLOSE_EVENT);
        },

        updateSize: function (winHeight) {
            if (mfp.isIOS) {
                // fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
                var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
                var height = window.innerHeight * zoomLevel;
                mfp.wrap.css("height", height);
                mfp.wH = height;
            } else {
                mfp.wH = winHeight || _window.height();
            }
            // Fixes #84: popup incorrectly positioned with position:relative on body
            if (!mfp.fixedContentPos) {
                mfp.wrap.css("height", mfp.wH);
            }

            _mfpTrigger("Resize");
        },

        /**
         * Set content of popup based on current index
         */
        updateItemHTML: function () {
            var item = mfp.items[mfp.index];

            // Detach and perform modifications
            mfp.contentContainer.detach();

            if (mfp.content) mfp.content.detach();

            if (!item.parsed) {
                item = mfp.parseEl(mfp.index);
            }

            var type = item.type;

            _mfpTrigger("BeforeChange", [mfp.currItem ? mfp.currItem.type : "", type]);
            // BeforeChange event works like so:
            // _mfpOn('BeforeChange', function(e, prevType, newType) { });

            mfp.currItem = item;

            if (!mfp.currTemplate[type]) {
                var markup = mfp.st[type] ? mfp.st[type].markup : false;

                // allows to modify markup
                _mfpTrigger("FirstMarkupParse", markup);

                if (markup) {
                    mfp.currTemplate[type] = $(markup);
                } else {
                    // if there is no markup found we just define that template is parsed
                    mfp.currTemplate[type] = true;
                }
            }

            if (_prevContentType && _prevContentType !== item.type) {
                mfp.container.removeClass("mfp-" + _prevContentType + "-holder");
            }

            var newContent = mfp["get" + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
            mfp.appendContent(newContent, type);

            item.preloaded = true;

            _mfpTrigger(CHANGE_EVENT, item);
            _prevContentType = item.type;

            // Append container back after its content changed
            mfp.container.prepend(mfp.contentContainer);

            _mfpTrigger("AfterChange");
        },

        /**
         * Set HTML content of popup
         */
        appendContent: function (newContent, type) {
            mfp.content = newContent;

            if (newContent) {
                if (mfp.st.showCloseBtn && mfp.st.closeBtnInside && mfp.currTemplate[type] === true) {
                    // if there is no markup, we just append close button element inside
                    if (!mfp.content.find(".mfp-close").length) {
                        mfp.content.append(_getCloseBtn());
                    }
                } else {
                    mfp.content = newContent;
                }
            } else {
                mfp.content = "";
            }

            _mfpTrigger(BEFORE_APPEND_EVENT);
            mfp.container.addClass("mfp-" + type + "-holder");

            mfp.contentContainer.append(mfp.content);
        },

        /**
         * Creates Magnific Popup data object based on given data
         * @param  {int} index Index of item to parse
         */
        parseEl: function (index) {
            var item = mfp.items[index],
                type;

            if (item.tagName) {
                item = { el: $(item) };
            } else {
                type = item.type;
                item = { data: item, src: item.src };
            }

            if (item.el) {
                var types = mfp.types;

                // check for 'mfp-TYPE' class
                for (var i = 0; i < types.length; i++) {
                    if (item.el.hasClass("mfp-" + types[i])) {
                        type = types[i];
                        break;
                    }
                }

                item.src = item.el.attr("data-mfp-src");
                if (!item.src) {
                    item.src = item.el.attr("href");
                }
            }

            item.type = type || mfp.st.type || "inline";
            item.index = index;
            item.parsed = true;
            mfp.items[index] = item;
            _mfpTrigger("ElementParse", item);

            return mfp.items[index];
        },

        /**
         * Initializes single popup or a group of popups
         */
        addGroup: function (el, options) {
            var eHandler = function (e) {
                e.mfpEl = this;
                mfp._openClick(e, el, options);
            };

            if (!options) {
                options = {};
            }

            var eName = "click.magnificPopup";
            options.mainEl = el;

            if (options.items) {
                options.isObj = true;
                el.off(eName).on(eName, eHandler);
            } else {
                options.isObj = false;
                if (options.delegate) {
                    el.off(eName).on(eName, options.delegate, eHandler);
                } else {
                    options.items = el;
                    el.off(eName).on(eName, eHandler);
                }
            }
        },
        _openClick: function (e, el, options) {
            var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;

            if (!midClick && (e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey)) {
                return;
            }

            var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;

            if (disableOn) {
                if ($.isFunction(disableOn)) {
                    if (!disableOn.call(mfp)) {
                        return true;
                    }
                } else {
                    // else it's number
                    if (_window.width() < disableOn) {
                        return true;
                    }
                }
            }

            if (e.type) {
                e.preventDefault();

                // This will prevent popup from closing if element is inside and popup is already opened
                if (mfp.isOpen) {
                    e.stopPropagation();
                }
            }

            options.el = $(e.mfpEl);
            if (options.delegate) {
                options.items = el.find(options.delegate);
            }
            mfp.open(options);
        },

        /**
         * Updates text on preloader
         */
        updateStatus: function (status, text) {
            if (mfp.preloader) {
                if (_prevStatus !== status) {
                    mfp.container.removeClass("mfp-s-" + _prevStatus);
                }

                if (!text && status === "loading") {
                    text = mfp.st.tLoading;
                }

                var data = {
                    status: status,
                    text: text,
                };
                // allows to modify status
                _mfpTrigger("UpdateStatus", data);

                status = data.status;
                text = data.text;

                mfp.preloader.html(text);

                mfp.preloader.find("a").on("click", function (e) {
                    e.stopImmediatePropagation();
                });

                mfp.container.addClass("mfp-s-" + status);
                _prevStatus = status;
            }
        },

        /*
		"Private" helpers that aren't private at all
	 */
        // Check to close popup or not
        // "target" is an element that was clicked
        _checkIfClose: function (target) {
            if ($(target).hasClass(PREVENT_CLOSE_CLASS)) {
                return;
            }

            var closeOnContent = mfp.st.closeOnContentClick;
            var closeOnBg = mfp.st.closeOnBgClick;

            if (closeOnContent && closeOnBg) {
                return true;
            } else {
                // We close the popup if click is on close button or on preloader. Or if there is no content.
                if (!mfp.content || $(target).hasClass("mfp-close") || (mfp.preloader && target === mfp.preloader[0])) {
                    return true;
                }

                // if click is outside the content
                if (target !== mfp.content[0] && !$.contains(mfp.content[0], target)) {
                    if (closeOnBg) {
                        // last check, if the clicked element is in DOM, (in case it's removed onclick)
                        if ($.contains(document, target)) {
                            return true;
                        }
                    }
                } else if (closeOnContent) {
                    return true;
                }
            }
            return false;
        },
        _addClassToMFP: function (cName) {
            mfp.bgOverlay.addClass(cName);
            mfp.wrap.addClass(cName);
        },
        _removeClassFromMFP: function (cName) {
            this.bgOverlay.removeClass(cName);
            mfp.wrap.removeClass(cName);
        },
        _hasScrollBar: function (winHeight) {
            return (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height());
        },
        _setFocus: function () {
            (mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
        },
        _onFocusIn: function (e) {
            if (e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target)) {
                mfp._setFocus();
                return false;
            }
        },
        _parseMarkup: function (template, values, item) {
            var arr;
            if (item.data) {
                values = $.extend(item.data, values);
            }
            _mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item]);

            $.each(values, function (key, value) {
                if (value === undefined || value === false) {
                    return true;
                }
                arr = key.split("_");
                if (arr.length > 1) {
                    var el = template.find(EVENT_NS + "-" + arr[0]);

                    if (el.length > 0) {
                        var attr = arr[1];
                        if (attr === "replaceWith") {
                            if (el[0] !== value[0]) {
                                el.replaceWith(value);
                            }
                        } else if (attr === "img") {
                            if (el.is("img")) {
                                el.attr("src", value);
                            } else {
                                el.replaceWith($("<img>").attr("src", value).attr("class", el.attr("class")));
                            }
                        } else {
                            el.attr(arr[1], value);
                        }
                    }
                } else {
                    template.find(EVENT_NS + "-" + key).html(value);
                }
            });
        },

        _getScrollbarSize: function () {
            // thx David
            if (mfp.scrollbarSize === undefined) {
                var scrollDiv = document.createElement("div");
                scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
                document.body.appendChild(scrollDiv);
                mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
            }
            return mfp.scrollbarSize;
        },
    }; /* MagnificPopup core prototype end */

    /**
     * Public static functions
     */
    $.magnificPopup = {
        instance: null,
        proto: MagnificPopup.prototype,
        modules: [],

        open: function (options, index) {
            _checkInstance();

            if (!options) {
                options = {};
            } else {
                options = $.extend(true, {}, options);
            }

            options.isObj = true;
            options.index = index || 0;
            return this.instance.open(options);
        },

        close: function () {
            return $.magnificPopup.instance && $.magnificPopup.instance.close();
        },

        registerModule: function (name, module) {
            if (module.options) {
                $.magnificPopup.defaults[name] = module.options;
            }
            $.extend(this.proto, module.proto);
            this.modules.push(name);
        },

        defaults: {
            // Info about options is in docs:
            // http://dimsemenov.com/plugins/magnific-popup/documentation.html#options

            disableOn: 0,

            key: null,

            midClick: false,

            mainClass: "",

            preloader: true,

            focus: "", // CSS selector of input to focus after popup is opened

            closeOnContentClick: false,

            closeOnBgClick: true,

            closeBtnInside: true,

            showCloseBtn: true,

            enableEscapeKey: true,

            modal: false,

            alignTop: false,

            removalDelay: 0,

            prependTo: null,

            fixedContentPos: "auto",

            fixedBgPos: "auto",

            overflowY: "auto",

            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',

            tClose: "Close (Esc)",

            tLoading: "Loading...",

            autoFocusLast: true,
        },
    };

    $.fn.magnificPopup = function (options) {
        _checkInstance();

        var jqEl = $(this);

        // We call some API method of first param is a string
        if (typeof options === "string") {
            if (options === "open") {
                var items,
                    itemOpts = _isJQ ? jqEl.data("magnificPopup") : jqEl[0].magnificPopup,
                    index = parseInt(arguments[1], 10) || 0;

                if (itemOpts.items) {
                    items = itemOpts.items[index];
                } else {
                    items = jqEl;
                    if (itemOpts.delegate) {
                        items = items.find(itemOpts.delegate);
                    }
                    items = items.eq(index);
                }
                mfp._openClick({ mfpEl: items }, jqEl, itemOpts);
            } else {
                if (mfp.isOpen) mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
            }
        } else {
            // clone options obj
            options = $.extend(true, {}, options);

            /*
             * As Zepto doesn't support .data() method for objects
             * and it works only in normal browsers
             * we assign "options" object directly to the DOM element. FTW!
             */
            if (_isJQ) {
                jqEl.data("magnificPopup", options);
            } else {
                jqEl[0].magnificPopup = options;
            }

            mfp.addGroup(jqEl, options);
        }
        return jqEl;
    };

    /*>>core*/

    /*>>inline*/

    var INLINE_NS = "inline",
        _hiddenClass,
        _inlinePlaceholder,
        _lastInlineElement,
        _putInlineElementsBack = function () {
            if (_lastInlineElement) {
                _inlinePlaceholder.after(_lastInlineElement.addClass(_hiddenClass)).detach();
                _lastInlineElement = null;
            }
        };

    $.magnificPopup.registerModule(INLINE_NS, {
        options: {
            hiddenClass: "hide", // will be appended with `mfp-` prefix
            markup: "",
            tNotFound: "Content not found",
        },
        proto: {
            initInline: function () {
                mfp.types.push(INLINE_NS);

                _mfpOn(CLOSE_EVENT + "." + INLINE_NS, function () {
                    _putInlineElementsBack();
                });
            },

            getInline: function (item, template) {
                _putInlineElementsBack();

                if (item.src) {
                    var inlineSt = mfp.st.inline,
                        el = $(item.src);

                    if (el.length) {
                        // If target element has parent - we replace it with placeholder and put it back after popup is closed
                        var parent = el[0].parentNode;
                        if (parent && parent.tagName) {
                            if (!_inlinePlaceholder) {
                                _hiddenClass = inlineSt.hiddenClass;
                                _inlinePlaceholder = _getEl(_hiddenClass);
                                _hiddenClass = "mfp-" + _hiddenClass;
                            }
                            // replace target inline element with placeholder
                            _lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass);
                        }

                        mfp.updateStatus("ready");
                    } else {
                        mfp.updateStatus("error", inlineSt.tNotFound);
                        el = $("<div>");
                    }

                    item.inlineElement = el;
                    return el;
                }

                mfp.updateStatus("ready");
                mfp._parseMarkup(template, {}, item);
                return template;
            },
        },
    });

    /*>>inline*/

    /*>>ajax*/
    var AJAX_NS = "ajax",
        _ajaxCur,
        _removeAjaxCursor = function () {
            if (_ajaxCur) {
                $(document.body).removeClass(_ajaxCur);
            }
        },
        _destroyAjaxRequest = function () {
            _removeAjaxCursor();
            if (mfp.req) {
                mfp.req.abort();
            }
        };

    $.magnificPopup.registerModule(AJAX_NS, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.',
        },

        proto: {
            initAjax: function () {
                mfp.types.push(AJAX_NS);
                _ajaxCur = mfp.st.ajax.cursor;

                _mfpOn(CLOSE_EVENT + "." + AJAX_NS, _destroyAjaxRequest);
                _mfpOn("BeforeChange." + AJAX_NS, _destroyAjaxRequest);
            },
            getAjax: function (item) {
                if (_ajaxCur) {
                    $(document.body).addClass(_ajaxCur);
                }

                mfp.updateStatus("loading");

                var opts = $.extend(
                    {
                        url: item.src,
                        success: function (data, textStatus, jqXHR) {
                            var temp = {
                                data: data,
                                xhr: jqXHR,
                            };

                            _mfpTrigger("ParseAjax", temp);

                            mfp.appendContent($(temp.data), AJAX_NS);

                            item.finished = true;

                            _removeAjaxCursor();

                            mfp._setFocus();

                            setTimeout(function () {
                                mfp.wrap.addClass(READY_CLASS);
                            }, 16);

                            mfp.updateStatus("ready");

                            _mfpTrigger("AjaxContentAdded");
                        },
                        error: function () {
                            _removeAjaxCursor();
                            item.finished = item.loadError = true;
                            mfp.updateStatus("error", mfp.st.ajax.tError.replace("%url%", item.src));
                        },
                    },
                    mfp.st.ajax.settings
                );

                mfp.req = $.ajax(opts);

                return "";
            },
        },
    });

    /*>>ajax*/

    /*>>image*/
    var _imgInterval,
        _getTitle = function (item) {
            if (item.data && item.data.title !== undefined) return item.data.title;

            var src = mfp.st.image.titleSrc;

            if (src) {
                if ($.isFunction(src)) {
                    return src.call(mfp, item);
                } else if (item.el) {
                    return item.el.attr(src) || "";
                }
            }
            return "";
        };

    $.magnificPopup.registerModule("image", {
        options: {
            markup:
                '<div class="mfp-figure">' +
                '<div class="mfp-close"></div>' +
                "<figure>" +
                '<div class="mfp-img"></div>' +
                "<figcaption>" +
                '<div class="mfp-bottom-bar">' +
                '<div class="mfp-title"></div>' +
                '<div class="mfp-counter"></div>' +
                "</div>" +
                "</figcaption>" +
                "</figure>" +
                "</div>",
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: true,
            tError: '<a href="%url%">The image</a> could not be loaded.',
        },

        proto: {
            initImage: function () {
                var imgSt = mfp.st.image,
                    ns = ".image";

                mfp.types.push("image");

                _mfpOn(OPEN_EVENT + ns, function () {
                    if (mfp.currItem.type === "image" && imgSt.cursor) {
                        $(document.body).addClass(imgSt.cursor);
                    }
                });

                _mfpOn(CLOSE_EVENT + ns, function () {
                    if (imgSt.cursor) {
                        $(document.body).removeClass(imgSt.cursor);
                    }
                    _window.off("resize" + EVENT_NS);
                });

                _mfpOn("Resize" + ns, mfp.resizeImage);
                if (mfp.isLowIE) {
                    _mfpOn("AfterChange", mfp.resizeImage);
                }
            },
            resizeImage: function () {
                var item = mfp.currItem;
                if (!item || !item.img) return;

                if (mfp.st.image.verticalFit) {
                    var decr = 0;
                    // fix box-sizing in ie7/8
                    if (mfp.isLowIE) {
                        decr = parseInt(item.img.css("padding-top"), 10) + parseInt(item.img.css("padding-bottom"), 10);
                    }
                    item.img.css("max-height", mfp.wH - decr);
                }
            },
            _onImageHasSize: function (item) {
                if (item.img) {
                    item.hasSize = true;

                    if (_imgInterval) {
                        clearInterval(_imgInterval);
                    }

                    item.isCheckingImgSize = false;

                    _mfpTrigger("ImageHasSize", item);

                    if (item.imgHidden) {
                        if (mfp.content) mfp.content.removeClass("mfp-loading");

                        item.imgHidden = false;
                    }
                }
            },

            /**
             * Function that loops until the image has size to display elements that rely on it asap
             */
            findImageSize: function (item) {
                var counter = 0,
                    img = item.img[0],
                    mfpSetInterval = function (delay) {
                        if (_imgInterval) {
                            clearInterval(_imgInterval);
                        }
                        // decelerating interval that checks for size of an image
                        _imgInterval = setInterval(function () {
                            if (img.naturalWidth > 0) {
                                mfp._onImageHasSize(item);
                                return;
                            }

                            if (counter > 200) {
                                clearInterval(_imgInterval);
                            }

                            counter++;
                            if (counter === 3) {
                                mfpSetInterval(10);
                            } else if (counter === 40) {
                                mfpSetInterval(50);
                            } else if (counter === 100) {
                                mfpSetInterval(500);
                            }
                        }, delay);
                    };

                mfpSetInterval(1);
            },

            getImage: function (item, template) {
                var guard = 0,
                    // image load complete handler
                    onLoadComplete = function () {
                        if (item) {
                            if (item.img[0].complete) {
                                item.img.off(".mfploader");

                                if (item === mfp.currItem) {
                                    mfp._onImageHasSize(item);

                                    mfp.updateStatus("ready");
                                }

                                item.hasSize = true;
                                item.loaded = true;

                                _mfpTrigger("ImageLoadComplete");
                            } else {
                                // if image complete check fails 200 times (20 sec), we assume that there was an error.
                                guard++;
                                if (guard < 200) {
                                    setTimeout(onLoadComplete, 100);
                                } else {
                                    onLoadError();
                                }
                            }
                        }
                    },
                    // image error handler
                    onLoadError = function () {
                        if (item) {
                            item.img.off(".mfploader");
                            if (item === mfp.currItem) {
                                mfp._onImageHasSize(item);
                                mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src));
                            }

                            item.hasSize = true;
                            item.loaded = true;
                            item.loadError = true;
                        }
                    },
                    imgSt = mfp.st.image;

                var el = template.find(".mfp-img");
                if (el.length) {
                    var img = document.createElement("img");
                    img.className = "mfp-img";
                    if (item.el && item.el.find("img").length) {
                        img.alt = item.el.find("img").attr("alt");
                    }
                    item.img = $(img).on("load.mfploader", onLoadComplete).on("error.mfploader", onLoadError);
                    img.src = item.src;

                    // without clone() "error" event is not firing when IMG is replaced by new IMG
                    // TODO: find a way to avoid such cloning
                    if (el.is("img")) {
                        item.img = item.img.clone();
                    }

                    img = item.img[0];
                    if (img.naturalWidth > 0) {
                        item.hasSize = true;
                    } else if (!img.width) {
                        item.hasSize = false;
                    }
                }

                mfp._parseMarkup(
                    template,
                    {
                        title: _getTitle(item),
                        img_replaceWith: item.img,
                    },
                    item
                );

                mfp.resizeImage();

                if (item.hasSize) {
                    if (_imgInterval) clearInterval(_imgInterval);

                    if (item.loadError) {
                        template.addClass("mfp-loading");
                        mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src));
                    } else {
                        template.removeClass("mfp-loading");
                        mfp.updateStatus("ready");
                    }
                    return template;
                }

                mfp.updateStatus("loading");
                item.loading = true;

                if (!item.hasSize) {
                    item.imgHidden = true;
                    template.addClass("mfp-loading");
                    mfp.findImageSize(item);
                }

                return template;
            },
        },
    });

    /*>>image*/

    /*>>zoom*/
    var hasMozTransform,
        getHasMozTransform = function () {
            if (hasMozTransform === undefined) {
                hasMozTransform = document.createElement("p").style.MozTransform !== undefined;
            }
            return hasMozTransform;
        };

    $.magnificPopup.registerModule("zoom", {
        options: {
            enabled: false,
            easing: "ease-in-out",
            duration: 300,
            opener: function (element) {
                return element.is("img") ? element : element.find("img");
            },
        },

        proto: {
            initZoom: function () {
                var zoomSt = mfp.st.zoom,
                    ns = ".zoom",
                    image;

                if (!zoomSt.enabled || !mfp.supportsTransition) {
                    return;
                }

                var duration = zoomSt.duration,
                    getElToAnimate = function (image) {
                        var newImg = image.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                            transition = "all " + zoomSt.duration / 1000 + "s " + zoomSt.easing,
                            cssObj = {
                                position: "fixed",
                                zIndex: 9999,
                                left: 0,
                                top: 0,
                                "-webkit-backface-visibility": "hidden",
                            },
                            t = "transition";

                        cssObj["-webkit-" + t] = cssObj["-moz-" + t] = cssObj["-o-" + t] = cssObj[t] = transition;

                        newImg.css(cssObj);
                        return newImg;
                    },
                    showMainContent = function () {
                        mfp.content.css("visibility", "visible");
                    },
                    openTimeout,
                    animatedImg;

                _mfpOn("BuildControls" + ns, function () {
                    if (mfp._allowZoom()) {
                        clearTimeout(openTimeout);
                        mfp.content.css("visibility", "hidden");

                        // Basically, all code below does is clones existing image, puts in on top of the current one and animated it

                        image = mfp._getItemToZoom();

                        if (!image) {
                            showMainContent();
                            return;
                        }

                        animatedImg = getElToAnimate(image);

                        animatedImg.css(mfp._getOffset());

                        mfp.wrap.append(animatedImg);

                        openTimeout = setTimeout(function () {
                            animatedImg.css(mfp._getOffset(true));
                            openTimeout = setTimeout(function () {
                                showMainContent();

                                setTimeout(function () {
                                    animatedImg.remove();
                                    image = animatedImg = null;
                                    _mfpTrigger("ZoomAnimationEnded");
                                }, 16); // avoid blink when switching images
                            }, duration); // this timeout equals animation duration
                        }, 16); // by adding this timeout we avoid short glitch at the beginning of animation

                        // Lots of timeouts...
                    }
                });
                _mfpOn(BEFORE_CLOSE_EVENT + ns, function () {
                    if (mfp._allowZoom()) {
                        clearTimeout(openTimeout);

                        mfp.st.removalDelay = duration;

                        if (!image) {
                            image = mfp._getItemToZoom();
                            if (!image) {
                                return;
                            }
                            animatedImg = getElToAnimate(image);
                        }

                        animatedImg.css(mfp._getOffset(true));
                        mfp.wrap.append(animatedImg);
                        mfp.content.css("visibility", "hidden");

                        setTimeout(function () {
                            animatedImg.css(mfp._getOffset());
                        }, 16);
                    }
                });

                _mfpOn(CLOSE_EVENT + ns, function () {
                    if (mfp._allowZoom()) {
                        showMainContent();
                        if (animatedImg) {
                            animatedImg.remove();
                        }
                        image = null;
                    }
                });
            },

            _allowZoom: function () {
                return mfp.currItem.type === "image";
            },

            _getItemToZoom: function () {
                if (mfp.currItem.hasSize) {
                    return mfp.currItem.img;
                } else {
                    return false;
                }
            },

            // Get element postion relative to viewport
            _getOffset: function (isLarge) {
                var el;
                if (isLarge) {
                    el = mfp.currItem.img;
                } else {
                    el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
                }

                var offset = el.offset();
                var paddingTop = parseInt(el.css("padding-top"), 10);
                var paddingBottom = parseInt(el.css("padding-bottom"), 10);
                offset.top -= $(window).scrollTop() - paddingTop;

                /*

			Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.

			 */
                var obj = {
                    width: el.width(),
                    // fix Zepto height+padding issue
                    height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop,
                };

                // I hate to do this, but there is no another option
                if (getHasMozTransform()) {
                    obj["-moz-transform"] = obj["transform"] = "translate(" + offset.left + "px," + offset.top + "px)";
                } else {
                    obj.left = offset.left;
                    obj.top = offset.top;
                }
                return obj;
            },
        },
    });

    /*>>zoom*/

    /*>>iframe*/

    var IFRAME_NS = "iframe",
        _emptyPage = "//about:blank",
        _fixIframeBugs = function (isShowing) {
            if (mfp.currTemplate[IFRAME_NS]) {
                var el = mfp.currTemplate[IFRAME_NS].find("iframe");
                if (el.length) {
                    // reset src after the popup is closed to avoid "video keeps playing after popup is closed" bug
                    if (!isShowing) {
                        el[0].src = _emptyPage;
                    }

                    // IE8 black screen bug fix
                    if (mfp.isIE8) {
                        el.css("display", isShowing ? "block" : "none");
                    }
                }
            }
        };

    $.magnificPopup.registerModule(IFRAME_NS, {
        options: {
            markup:
                '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>' +
                "</div>",

            srcAction: "iframe_src",

            // we don't care and support only one default type of URL by default
            patterns: {
                youtube: {
                    index: "youtube.com",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?autoplay=1",
                },
                vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=1",
                },
                gmaps: {
                    index: "//maps.google.",
                    src: "%id%&output=embed",
                },
            },
        },

        proto: {
            initIframe: function () {
                mfp.types.push(IFRAME_NS);

                _mfpOn("BeforeChange", function (e, prevType, newType) {
                    if (prevType !== newType) {
                        if (prevType === IFRAME_NS) {
                            _fixIframeBugs(); // iframe if removed
                        } else if (newType === IFRAME_NS) {
                            _fixIframeBugs(true); // iframe is showing
                        }
                    } // else {
                    // iframe source is switched, don't do anything
                    //}
                });

                _mfpOn(CLOSE_EVENT + "." + IFRAME_NS, function () {
                    _fixIframeBugs();
                });
            },

            getIframe: function (item, template) {
                var embedSrc = item.src;
                var iframeSt = mfp.st.iframe;

                $.each(iframeSt.patterns, function () {
                    if (embedSrc.indexOf(this.index) > -1) {
                        if (this.id) {
                            if (typeof this.id === "string") {
                                embedSrc = embedSrc.substr(embedSrc.lastIndexOf(this.id) + this.id.length, embedSrc.length);
                            } else {
                                embedSrc = this.id.call(this, embedSrc);
                            }
                        }
                        embedSrc = this.src.replace("%id%", embedSrc);
                        return false; // break;
                    }
                });

                var dataObj = {};
                if (iframeSt.srcAction) {
                    dataObj[iframeSt.srcAction] = embedSrc;
                }
                mfp._parseMarkup(template, dataObj, item);

                mfp.updateStatus("ready");

                return template;
            },
        },
    });

    /*>>iframe*/

    /*>>gallery*/
    /**
     * Get looped index depending on number of slides
     */
    var _getLoopedId = function (index) {
            var numSlides = mfp.items.length;
            if (index > numSlides - 1) {
                return index - numSlides;
            } else if (index < 0) {
                return numSlides + index;
            }
            return index;
        },
        _replaceCurrTotal = function (text, curr, total) {
            return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
        };

    $.magnificPopup.registerModule("gallery", {
        options: {
            enabled: false,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: true,
            arrows: true,

            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%",
        },

        proto: {
            initGallery: function () {
                var gSt = mfp.st.gallery,
                    ns = ".mfp-gallery";

                mfp.direction = true; // true - next, false - prev

                if (!gSt || !gSt.enabled) return false;

                _wrapClasses += " mfp-gallery";

                _mfpOn(OPEN_EVENT + ns, function () {
                    if (gSt.navigateByImgClick) {
                        mfp.wrap.on("click" + ns, ".mfp-img", function () {
                            if (mfp.items.length > 1) {
                                mfp.next();
                                return false;
                            }
                        });
                    }

                    _document.on("keydown" + ns, function (e) {
                        if (e.keyCode === 37) {
                            mfp.prev();
                        } else if (e.keyCode === 39) {
                            mfp.next();
                        }
                    });
                });

                _mfpOn("UpdateStatus" + ns, function (e, data) {
                    if (data.text) {
                        data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
                    }
                });

                _mfpOn(MARKUP_PARSE_EVENT + ns, function (e, element, values, item) {
                    var l = mfp.items.length;
                    values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : "";
                });

                _mfpOn("BuildControls" + ns, function () {
                    if (mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
                        var markup = gSt.arrowMarkup,
                            arrowLeft = (mfp.arrowLeft = $(markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, "left")).addClass(
                                PREVENT_CLOSE_CLASS
                            )),
                            arrowRight = (mfp.arrowRight = $(markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, "right")).addClass(
                                PREVENT_CLOSE_CLASS
                            ));

                        arrowLeft.click(function () {
                            mfp.prev();
                        });
                        arrowRight.click(function () {
                            mfp.next();
                        });

                        mfp.container.append(arrowLeft.add(arrowRight));
                    }
                });

                _mfpOn(CHANGE_EVENT + ns, function () {
                    if (mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);

                    mfp._preloadTimeout = setTimeout(function () {
                        mfp.preloadNearbyImages();
                        mfp._preloadTimeout = null;
                    }, 16);
                });

                _mfpOn(CLOSE_EVENT + ns, function () {
                    _document.off(ns);
                    mfp.wrap.off("click" + ns);
                    mfp.arrowRight = mfp.arrowLeft = null;
                });
            },
            next: function () {
                mfp.direction = true;
                mfp.index = _getLoopedId(mfp.index + 1);
                mfp.updateItemHTML();
            },
            prev: function () {
                mfp.direction = false;
                mfp.index = _getLoopedId(mfp.index - 1);
                mfp.updateItemHTML();
            },
            goTo: function (newIndex) {
                mfp.direction = newIndex >= mfp.index;
                mfp.index = newIndex;
                mfp.updateItemHTML();
            },
            preloadNearbyImages: function () {
                var p = mfp.st.gallery.preload,
                    preloadBefore = Math.min(p[0], mfp.items.length),
                    preloadAfter = Math.min(p[1], mfp.items.length),
                    i;

                for (i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
                    mfp._preloadItem(mfp.index + i);
                }
                for (i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
                    mfp._preloadItem(mfp.index - i);
                }
            },
            _preloadItem: function (index) {
                index = _getLoopedId(index);

                if (mfp.items[index].preloaded) {
                    return;
                }

                var item = mfp.items[index];
                if (!item.parsed) {
                    item = mfp.parseEl(index);
                }

                _mfpTrigger("LazyLoad", item);

                if (item.type === "image") {
                    item.img = $('<img class="mfp-img" />')
                        .on("load.mfploader", function () {
                            item.hasSize = true;
                        })
                        .on("error.mfploader", function () {
                            item.hasSize = true;
                            item.loadError = true;
                            _mfpTrigger("LazyLoadError", item);
                        })
                        .attr("src", item.src);
                }

                item.preloaded = true;
            },
        },
    });

    /*>>gallery*/

    /*>>retina*/

    var RETINA_NS = "retina";

    $.magnificPopup.registerModule(RETINA_NS, {
        options: {
            replaceSrc: function (item) {
                return item.src.replace(/\.\w+$/, function (m) {
                    return "@2x" + m;
                });
            },
            ratio: 1, // Function or number.  Set to 1 to disable.
        },
        proto: {
            initRetina: function () {
                if (window.devicePixelRatio > 1) {
                    var st = mfp.st.retina,
                        ratio = st.ratio;

                    ratio = !isNaN(ratio) ? ratio : ratio();

                    if (ratio > 1) {
                        _mfpOn("ImageHasSize" + "." + RETINA_NS, function (e, item) {
                            item.img.css({
                                "max-width": item.img[0].naturalWidth / ratio,
                                width: "100%",
                            });
                        });
                        _mfpOn("ElementParse" + "." + RETINA_NS, function (e, item) {
                            item.src = st.replaceSrc(item, ratio);
                        });
                    }
                }
            },
        },
    });

    /*>>retina*/
    _checkInstance();
});

//P80 Utils
function setCookie(e, t, n) {
    var o = new Date();
    o.setTime(o.getTime() + 24 * n * 60 * 60 * 1e3);
    var i = "expires=" + o.toUTCString();
    document.cookie = e + "=" + t + ";" + i + ";path=/";
}
function getCookie(e) {
    for (var t = e + "=", n = decodeURIComponent(document.cookie).split(";"), o = 0; o < n.length; o++) {
        for (var i = n[o]; " " == i.charAt(0); ) i = i.substring(1);
        if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
    }
    return "";
}

/*! jQuery Validation Plugin - v1.17.0 - 7/29/2017
 * https://jqueryvalidation.org/
 * Copyright (c) 2017 Jörn Zaefferer; Licensed MIT */
!(function (a) {
    "function" == typeof define && define.amd
        ? define(["jquery"], a)
        : "object" == typeof module && module.exports
        ? (module.exports = a(require("jquery")))
        : a(jQuery);
})(function (a) {
    a.extend(a.fn, {
        validate: function (b) {
            if (!this.length) return void (b && b.debug && window.console && console.warn("Nothing selected, can't validate, returning nothing."));
            var c = a.data(this[0], "validator");
            return c
                ? c
                : (this.attr("novalidate", "novalidate"),
                  (c = new a.validator(b, this[0])),
                  a.data(this[0], "validator", c),
                  c.settings.onsubmit &&
                      (this.on("click.validate", ":submit", function (b) {
                          (c.submitButton = b.currentTarget),
                              a(this).hasClass("cancel") && (c.cancelSubmit = !0),
                              void 0 !== a(this).attr("formnovalidate") && (c.cancelSubmit = !0);
                      }),
                      this.on("submit.validate", function (b) {
                          function d() {
                              var d, e;
                              return (
                                  c.submitButton &&
                                      (c.settings.submitHandler || c.formSubmitted) &&
                                      (d = a("<input type='hidden'/>")
                                          .attr("name", c.submitButton.name)
                                          .val(a(c.submitButton).val())
                                          .appendTo(c.currentForm)),
                                  !c.settings.submitHandler ||
                                      ((e = c.settings.submitHandler.call(c, c.currentForm, b)), d && d.remove(), void 0 !== e && e)
                              );
                          }
                          return (
                              c.settings.debug && b.preventDefault(),
                              c.cancelSubmit
                                  ? ((c.cancelSubmit = !1), d())
                                  : c.form()
                                  ? c.pendingRequest
                                      ? ((c.formSubmitted = !0), !1)
                                      : d()
                                  : (c.focusInvalid(), !1)
                          );
                      })),
                  c);
        },
        valid: function () {
            var b, c, d;
            return (
                a(this[0]).is("form")
                    ? (b = this.validate().form())
                    : ((d = []),
                      (b = !0),
                      (c = a(this[0].form).validate()),
                      this.each(function () {
                          (b = c.element(this) && b), b || (d = d.concat(c.errorList));
                      }),
                      (c.errorList = d)),
                b
            );
        },
        rules: function (b, c) {
            var d,
                e,
                f,
                g,
                h,
                i,
                j = this[0];
            if (
                null != j &&
                (!j.form && j.hasAttribute("contenteditable") && ((j.form = this.closest("form")[0]), (j.name = this.attr("name"))), null != j.form)
            ) {
                if (b)
                    switch (((d = a.data(j.form, "validator").settings), (e = d.rules), (f = a.validator.staticRules(j)), b)) {
                        case "add":
                            a.extend(f, a.validator.normalizeRule(c)),
                                delete f.messages,
                                (e[j.name] = f),
                                c.messages && (d.messages[j.name] = a.extend(d.messages[j.name], c.messages));
                            break;
                        case "remove":
                            return c
                                ? ((i = {}),
                                  a.each(c.split(/\s/), function (a, b) {
                                      (i[b] = f[b]), delete f[b];
                                  }),
                                  i)
                                : (delete e[j.name], f);
                    }
                return (
                    (g = a.validator.normalizeRules(
                        a.extend({}, a.validator.classRules(j), a.validator.attributeRules(j), a.validator.dataRules(j), a.validator.staticRules(j)),
                        j
                    )),
                    g.required && ((h = g.required), delete g.required, (g = a.extend({ required: h }, g))),
                    g.remote && ((h = g.remote), delete g.remote, (g = a.extend(g, { remote: h }))),
                    g
                );
            }
        },
    }),
        a.extend(a.expr.pseudos || a.expr[":"], {
            blank: function (b) {
                return !a.trim("" + a(b).val());
            },
            filled: function (b) {
                var c = a(b).val();
                return null !== c && !!a.trim("" + c);
            },
            unchecked: function (b) {
                return !a(b).prop("checked");
            },
        }),
        (a.validator = function (b, c) {
            (this.settings = a.extend(!0, {}, a.validator.defaults, b)), (this.currentForm = c), this.init();
        }),
        (a.validator.format = function (b, c) {
            return 1 === arguments.length
                ? function () {
                      var c = a.makeArray(arguments);
                      return c.unshift(b), a.validator.format.apply(this, c);
                  }
                : void 0 === c
                ? b
                : (arguments.length > 2 && c.constructor !== Array && (c = a.makeArray(arguments).slice(1)),
                  c.constructor !== Array && (c = [c]),
                  a.each(c, function (a, c) {
                      b = b.replace(new RegExp("\\{" + a + "\\}", "g"), function () {
                          return c;
                      });
                  }),
                  b);
        }),
        a.extend(a.validator, {
            defaults: {
                messages: {},
                groups: {},
                rules: {},
                errorClass: "error",
                pendingClass: "pending",
                validClass: "valid",
                errorElement: "label",
                focusCleanup: !1,
                focusInvalid: !0,
                errorContainer: a([]),
                errorLabelContainer: a([]),
                onsubmit: !0,
                ignore: ":hidden",
                ignoreTitle: !1,
                onfocusin: function (a) {
                    (this.lastActive = a),
                        this.settings.focusCleanup &&
                            (this.settings.unhighlight && this.settings.unhighlight.call(this, a, this.settings.errorClass, this.settings.validClass),
                            this.hideThese(this.errorsFor(a)));
                },
                onfocusout: function (a) {
                    this.checkable(a) || (!(a.name in this.submitted) && this.optional(a)) || this.element(a);
                },
                onkeyup: function (b, c) {
                    var d = [16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225];
                    (9 === c.which && "" === this.elementValue(b)) ||
                        a.inArray(c.keyCode, d) !== -1 ||
                        ((b.name in this.submitted || b.name in this.invalid) && this.element(b));
                },
                onclick: function (a) {
                    a.name in this.submitted ? this.element(a) : a.parentNode.name in this.submitted && this.element(a.parentNode);
                },
                highlight: function (b, c, d) {
                    "radio" === b.type ? this.findByName(b.name).addClass(c).removeClass(d) : a(b).addClass(c).removeClass(d);
                },
                unhighlight: function (b, c, d) {
                    "radio" === b.type ? this.findByName(b.name).removeClass(c).addClass(d) : a(b).removeClass(c).addClass(d);
                },
            },
            setDefaults: function (b) {
                a.extend(a.validator.defaults, b);
            },
            messages: {
                required: "This field is required.",
                remote: "Please fix this field.",
                email: "Please enter a valid email address.",
                url: "Please enter a valid URL.",
                date: "Please enter a valid date.",
                dateISO: "Please enter a valid date (ISO).",
                number: "Please enter a valid number.",
                digits: "Please enter only digits.",
                equalTo: "Please enter the same value again.",
                maxlength: a.validator.format("Please enter no more than {0} characters."),
                minlength: a.validator.format("Please enter at least {0} characters."),
                rangelength: a.validator.format("Please enter a value between {0} and {1} characters long."),
                range: a.validator.format("Please enter a value between {0} and {1}."),
                max: a.validator.format("Please enter a value less than or equal to {0}."),
                min: a.validator.format("Please enter a value greater than or equal to {0}."),
                step: a.validator.format("Please enter a multiple of {0}."),
            },
            autoCreateRanges: !1,
            prototype: {
                init: function () {
                    function b(b) {
                        !this.form &&
                            this.hasAttribute("contenteditable") &&
                            ((this.form = a(this).closest("form")[0]), (this.name = a(this).attr("name")));
                        var c = a.data(this.form, "validator"),
                            d = "on" + b.type.replace(/^validate/, ""),
                            e = c.settings;
                        e[d] && !a(this).is(e.ignore) && e[d].call(c, this, b);
                    }
                    (this.labelContainer = a(this.settings.errorLabelContainer)),
                        (this.errorContext = (this.labelContainer.length && this.labelContainer) || a(this.currentForm)),
                        (this.containers = a(this.settings.errorContainer).add(this.settings.errorLabelContainer)),
                        (this.submitted = {}),
                        (this.valueCache = {}),
                        (this.pendingRequest = 0),
                        (this.pending = {}),
                        (this.invalid = {}),
                        this.reset();
                    var c,
                        d = (this.groups = {});
                    a.each(this.settings.groups, function (b, c) {
                        "string" == typeof c && (c = c.split(/\s/)),
                            a.each(c, function (a, c) {
                                d[c] = b;
                            });
                    }),
                        (c = this.settings.rules),
                        a.each(c, function (b, d) {
                            c[b] = a.validator.normalizeRule(d);
                        }),
                        a(this.currentForm)
                            .on(
                                "focusin.validate focusout.validate keyup.validate",
                                ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']",
                                b
                            )
                            .on("click.validate", "select, option, [type='radio'], [type='checkbox']", b),
                        this.settings.invalidHandler && a(this.currentForm).on("invalid-form.validate", this.settings.invalidHandler);
                },
                form: function () {
                    return (
                        this.checkForm(),
                        a.extend(this.submitted, this.errorMap),
                        (this.invalid = a.extend({}, this.errorMap)),
                        this.valid() || a(this.currentForm).triggerHandler("invalid-form", [this]),
                        this.showErrors(),
                        this.valid()
                    );
                },
                checkForm: function () {
                    this.prepareForm();
                    for (var a = 0, b = (this.currentElements = this.elements()); b[a]; a++) this.check(b[a]);
                    return this.valid();
                },
                element: function (b) {
                    var c,
                        d,
                        e = this.clean(b),
                        f = this.validationTargetFor(e),
                        g = this,
                        h = !0;
                    return (
                        void 0 === f
                            ? delete this.invalid[e.name]
                            : (this.prepareElement(f),
                              (this.currentElements = a(f)),
                              (d = this.groups[f.name]),
                              d &&
                                  a.each(this.groups, function (a, b) {
                                      b === d &&
                                          a !== f.name &&
                                          ((e = g.validationTargetFor(g.clean(g.findByName(a)))),
                                          e && e.name in g.invalid && (g.currentElements.push(e), (h = g.check(e) && h)));
                                  }),
                              (c = this.check(f) !== !1),
                              (h = h && c),
                              c ? (this.invalid[f.name] = !1) : (this.invalid[f.name] = !0),
                              this.numberOfInvalids() || (this.toHide = this.toHide.add(this.containers)),
                              this.showErrors(),
                              a(b).attr("aria-invalid", !c)),
                        h
                    );
                },
                showErrors: function (b) {
                    if (b) {
                        var c = this;
                        a.extend(this.errorMap, b),
                            (this.errorList = a.map(this.errorMap, function (a, b) {
                                return { message: a, element: c.findByName(b)[0] };
                            })),
                            (this.successList = a.grep(this.successList, function (a) {
                                return !(a.name in b);
                            }));
                    }
                    this.settings.showErrors ? this.settings.showErrors.call(this, this.errorMap, this.errorList) : this.defaultShowErrors();
                },
                resetForm: function () {
                    a.fn.resetForm && a(this.currentForm).resetForm(),
                        (this.invalid = {}),
                        (this.submitted = {}),
                        this.prepareForm(),
                        this.hideErrors();
                    var b = this.elements().removeData("previousValue").removeAttr("aria-invalid");
                    this.resetElements(b);
                },
                resetElements: function (a) {
                    var b;
                    if (this.settings.unhighlight)
                        for (b = 0; a[b]; b++)
                            this.settings.unhighlight.call(this, a[b], this.settings.errorClass, ""),
                                this.findByName(a[b].name).removeClass(this.settings.validClass);
                    else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass);
                },
                numberOfInvalids: function () {
                    return this.objectLength(this.invalid);
                },
                objectLength: function (a) {
                    var b,
                        c = 0;
                    for (b in a) void 0 !== a[b] && null !== a[b] && a[b] !== !1 && c++;
                    return c;
                },
                hideErrors: function () {
                    this.hideThese(this.toHide);
                },
                hideThese: function (a) {
                    a.not(this.containers).text(""), this.addWrapper(a).hide();
                },
                valid: function () {
                    return 0 === this.size();
                },
                size: function () {
                    return this.errorList.length;
                },
                focusInvalid: function () {
                    if (this.settings.focusInvalid)
                        try {
                            a(this.findLastActive() || (this.errorList.length && this.errorList[0].element) || [])
                                .filter(":visible")
                                .focus()
                                .trigger("focusin");
                        } catch (b) {}
                },
                findLastActive: function () {
                    var b = this.lastActive;
                    return (
                        b &&
                        1 ===
                            a.grep(this.errorList, function (a) {
                                return a.element.name === b.name;
                            }).length &&
                        b
                    );
                },
                elements: function () {
                    var b = this,
                        c = {};
                    return a(this.currentForm)
                        .find("input, select, textarea, [contenteditable]")
                        .not(":submit, :reset, :image, :disabled")
                        .not(this.settings.ignore)
                        .filter(function () {
                            var d = this.name || a(this).attr("name");
                            return (
                                !d && b.settings.debug && window.console && console.error("%o has no name assigned", this),
                                this.hasAttribute("contenteditable") && ((this.form = a(this).closest("form")[0]), (this.name = d)),
                                !(d in c || !b.objectLength(a(this).rules())) && ((c[d] = !0), !0)
                            );
                        });
                },
                clean: function (b) {
                    return a(b)[0];
                },
                errors: function () {
                    var b = this.settings.errorClass.split(" ").join(".");
                    return a(this.settings.errorElement + "." + b, this.errorContext);
                },
                resetInternals: function () {
                    (this.successList = []), (this.errorList = []), (this.errorMap = {}), (this.toShow = a([])), (this.toHide = a([]));
                },
                reset: function () {
                    this.resetInternals(), (this.currentElements = a([]));
                },
                prepareForm: function () {
                    this.reset(), (this.toHide = this.errors().add(this.containers));
                },
                prepareElement: function (a) {
                    this.reset(), (this.toHide = this.errorsFor(a));
                },
                elementValue: function (b) {
                    var c,
                        d,
                        e = a(b),
                        f = b.type;
                    return "radio" === f || "checkbox" === f
                        ? this.findByName(b.name).filter(":checked").val()
                        : "number" === f && "undefined" != typeof b.validity
                        ? b.validity.badInput
                            ? "NaN"
                            : e.val()
                        : ((c = b.hasAttribute("contenteditable") ? e.text() : e.val()),
                          "file" === f
                              ? "C:\\fakepath\\" === c.substr(0, 12)
                                  ? c.substr(12)
                                  : ((d = c.lastIndexOf("/")), d >= 0 ? c.substr(d + 1) : ((d = c.lastIndexOf("\\")), d >= 0 ? c.substr(d + 1) : c))
                              : "string" == typeof c
                              ? c.replace(/\r/g, "")
                              : c);
                },
                check: function (b) {
                    b = this.validationTargetFor(this.clean(b));
                    var c,
                        d,
                        e,
                        f,
                        g = a(b).rules(),
                        h = a.map(g, function (a, b) {
                            return b;
                        }).length,
                        i = !1,
                        j = this.elementValue(b);
                    if (
                        ("function" == typeof g.normalizer
                            ? (f = g.normalizer)
                            : "function" == typeof this.settings.normalizer && (f = this.settings.normalizer),
                        f)
                    ) {
                        if (((j = f.call(b, j)), "string" != typeof j)) throw new TypeError("The normalizer should return a string value.");
                        delete g.normalizer;
                    }
                    for (d in g) {
                        e = { method: d, parameters: g[d] };
                        try {
                            if (((c = a.validator.methods[d].call(this, j, b, e.parameters)), "dependency-mismatch" === c && 1 === h)) {
                                i = !0;
                                continue;
                            }
                            if (((i = !1), "pending" === c)) return void (this.toHide = this.toHide.not(this.errorsFor(b)));
                            if (!c) return this.formatAndAdd(b, e), !1;
                        } catch (k) {
                            throw (
                                (this.settings.debug &&
                                    window.console &&
                                    console.log("Exception occurred when checking element " + b.id + ", check the '" + e.method + "' method.", k),
                                k instanceof TypeError &&
                                    (k.message += ".  Exception occurred when checking element " + b.id + ", check the '" + e.method + "' method."),
                                k)
                            );
                        }
                    }
                    if (!i) return this.objectLength(g) && this.successList.push(b), !0;
                },
                customDataMessage: function (b, c) {
                    return a(b).data("msg" + c.charAt(0).toUpperCase() + c.substring(1).toLowerCase()) || a(b).data("msg");
                },
                customMessage: function (a, b) {
                    var c = this.settings.messages[a];
                    return c && (c.constructor === String ? c : c[b]);
                },
                findDefined: function () {
                    for (var a = 0; a < arguments.length; a++) if (void 0 !== arguments[a]) return arguments[a];
                },
                defaultMessage: function (b, c) {
                    "string" == typeof c && (c = { method: c });
                    var d = this.findDefined(
                            this.customMessage(b.name, c.method),
                            this.customDataMessage(b, c.method),
                            (!this.settings.ignoreTitle && b.title) || void 0,
                            a.validator.messages[c.method],
                            "<strong>Warning: No message defined for " + b.name + "</strong>"
                        ),
                        e = /\$?\{(\d+)\}/g;
                    return (
                        "function" == typeof d
                            ? (d = d.call(this, c.parameters, b))
                            : e.test(d) && (d = a.validator.format(d.replace(e, "{$1}"), c.parameters)),
                        d
                    );
                },
                formatAndAdd: function (a, b) {
                    var c = this.defaultMessage(a, b);
                    this.errorList.push({ message: c, element: a, method: b.method }), (this.errorMap[a.name] = c), (this.submitted[a.name] = c);
                },
                addWrapper: function (a) {
                    return this.settings.wrapper && (a = a.add(a.parent(this.settings.wrapper))), a;
                },
                defaultShowErrors: function () {
                    var a, b, c;
                    for (a = 0; this.errorList[a]; a++)
                        (c = this.errorList[a]),
                            this.settings.highlight &&
                                this.settings.highlight.call(this, c.element, this.settings.errorClass, this.settings.validClass),
                            this.showLabel(c.element, c.message);
                    if ((this.errorList.length && (this.toShow = this.toShow.add(this.containers)), this.settings.success))
                        for (a = 0; this.successList[a]; a++) this.showLabel(this.successList[a]);
                    if (this.settings.unhighlight)
                        for (a = 0, b = this.validElements(); b[a]; a++)
                            this.settings.unhighlight.call(this, b[a], this.settings.errorClass, this.settings.validClass);
                    (this.toHide = this.toHide.not(this.toShow)), this.hideErrors(), this.addWrapper(this.toShow).show();
                },
                validElements: function () {
                    return this.currentElements.not(this.invalidElements());
                },
                invalidElements: function () {
                    return a(this.errorList).map(function () {
                        return this.element;
                    });
                },
                showLabel: function (b, c) {
                    var d,
                        e,
                        f,
                        g,
                        h = this.errorsFor(b),
                        i = this.idOrName(b),
                        j = a(b).attr("aria-describedby");
                    h.length
                        ? (h.removeClass(this.settings.validClass).addClass(this.settings.errorClass), h.html(c))
                        : ((h = a("<" + this.settings.errorElement + ">")
                              .attr("id", i + "-error")
                              .addClass(this.settings.errorClass)
                              .html(c || "")),
                          (d = h),
                          this.settings.wrapper &&
                              (d = h
                                  .hide()
                                  .show()
                                  .wrap("<" + this.settings.wrapper + "/>")
                                  .parent()),
                          this.labelContainer.length
                              ? this.labelContainer.append(d)
                              : this.settings.errorPlacement
                              ? this.settings.errorPlacement.call(this, d, a(b))
                              : d.insertAfter(b),
                          h.is("label")
                              ? h.attr("for", i)
                              : 0 === h.parents("label[for='" + this.escapeCssMeta(i) + "']").length &&
                                ((f = h.attr("id")),
                                j ? j.match(new RegExp("\\b" + this.escapeCssMeta(f) + "\\b")) || (j += " " + f) : (j = f),
                                a(b).attr("aria-describedby", j),
                                (e = this.groups[b.name]),
                                e &&
                                    ((g = this),
                                    a.each(g.groups, function (b, c) {
                                        c === e && a("[name='" + g.escapeCssMeta(b) + "']", g.currentForm).attr("aria-describedby", h.attr("id"));
                                    })))),
                        !c &&
                            this.settings.success &&
                            (h.text(""), "string" == typeof this.settings.success ? h.addClass(this.settings.success) : this.settings.success(h, b)),
                        (this.toShow = this.toShow.add(h));
                },
                errorsFor: function (b) {
                    var c = this.escapeCssMeta(this.idOrName(b)),
                        d = a(b).attr("aria-describedby"),
                        e = "label[for='" + c + "'], label[for='" + c + "'] *";
                    return d && (e = e + ", #" + this.escapeCssMeta(d).replace(/\s+/g, ", #")), this.errors().filter(e);
                },
                escapeCssMeta: function (a) {
                    return a.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g, "\\$1");
                },
                idOrName: function (a) {
                    return this.groups[a.name] || (this.checkable(a) ? a.name : a.id || a.name);
                },
                validationTargetFor: function (b) {
                    return this.checkable(b) && (b = this.findByName(b.name)), a(b).not(this.settings.ignore)[0];
                },
                checkable: function (a) {
                    return /radio|checkbox/i.test(a.type);
                },
                findByName: function (b) {
                    return a(this.currentForm).find("[name='" + this.escapeCssMeta(b) + "']");
                },
                getLength: function (b, c) {
                    switch (c.nodeName.toLowerCase()) {
                        case "select":
                            return a("option:selected", c).length;
                        case "input":
                            if (this.checkable(c)) return this.findByName(c.name).filter(":checked").length;
                    }
                    return b.length;
                },
                depend: function (a, b) {
                    return !this.dependTypes[typeof a] || this.dependTypes[typeof a](a, b);
                },
                dependTypes: {
                    boolean: function (a) {
                        return a;
                    },
                    string: function (b, c) {
                        return !!a(b, c.form).length;
                    },
                    function: function (a, b) {
                        return a(b);
                    },
                },
                optional: function (b) {
                    var c = this.elementValue(b);
                    return !a.validator.methods.required.call(this, c, b) && "dependency-mismatch";
                },
                startRequest: function (b) {
                    this.pending[b.name] || (this.pendingRequest++, a(b).addClass(this.settings.pendingClass), (this.pending[b.name] = !0));
                },
                stopRequest: function (b, c) {
                    this.pendingRequest--,
                        this.pendingRequest < 0 && (this.pendingRequest = 0),
                        delete this.pending[b.name],
                        a(b).removeClass(this.settings.pendingClass),
                        c && 0 === this.pendingRequest && this.formSubmitted && this.form()
                            ? (a(this.currentForm).submit(),
                              this.submitButton && a("input:hidden[name='" + this.submitButton.name + "']", this.currentForm).remove(),
                              (this.formSubmitted = !1))
                            : !c &&
                              0 === this.pendingRequest &&
                              this.formSubmitted &&
                              (a(this.currentForm).triggerHandler("invalid-form", [this]), (this.formSubmitted = !1));
                },
                previousValue: function (b, c) {
                    return (
                        (c = ("string" == typeof c && c) || "remote"),
                        a.data(b, "previousValue") ||
                            a.data(b, "previousValue", { old: null, valid: !0, message: this.defaultMessage(b, { method: c }) })
                    );
                },
                destroy: function () {
                    this.resetForm(),
                        a(this.currentForm)
                            .off(".validate")
                            .removeData("validator")
                            .find(".validate-equalTo-blur")
                            .off(".validate-equalTo")
                            .removeClass("validate-equalTo-blur");
                },
            },
            classRuleSettings: {
                required: { required: !0 },
                email: { email: !0 },
                url: { url: !0 },
                date: { date: !0 },
                dateISO: { dateISO: !0 },
                number: { number: !0 },
                digits: { digits: !0 },
                creditcard: { creditcard: !0 },
            },
            addClassRules: function (b, c) {
                b.constructor === String ? (this.classRuleSettings[b] = c) : a.extend(this.classRuleSettings, b);
            },
            classRules: function (b) {
                var c = {},
                    d = a(b).attr("class");
                return (
                    d &&
                        a.each(d.split(" "), function () {
                            this in a.validator.classRuleSettings && a.extend(c, a.validator.classRuleSettings[this]);
                        }),
                    c
                );
            },
            normalizeAttributeRule: function (a, b, c, d) {
                /min|max|step/.test(c) && (null === b || /number|range|text/.test(b)) && ((d = Number(d)), isNaN(d) && (d = void 0)),
                    d || 0 === d ? (a[c] = d) : b === c && "range" !== b && (a[c] = !0);
            },
            attributeRules: function (b) {
                var c,
                    d,
                    e = {},
                    f = a(b),
                    g = b.getAttribute("type");
                for (c in a.validator.methods)
                    "required" === c ? ((d = b.getAttribute(c)), "" === d && (d = !0), (d = !!d)) : (d = f.attr(c)),
                        this.normalizeAttributeRule(e, g, c, d);
                return e.maxlength && /-1|2147483647|524288/.test(e.maxlength) && delete e.maxlength, e;
            },
            dataRules: function (b) {
                var c,
                    d,
                    e = {},
                    f = a(b),
                    g = b.getAttribute("type");
                for (c in a.validator.methods)
                    (d = f.data("rule" + c.charAt(0).toUpperCase() + c.substring(1).toLowerCase())), this.normalizeAttributeRule(e, g, c, d);
                return e;
            },
            staticRules: function (b) {
                var c = {},
                    d = a.data(b.form, "validator");
                return d.settings.rules && (c = a.validator.normalizeRule(d.settings.rules[b.name]) || {}), c;
            },
            normalizeRules: function (b, c) {
                return (
                    a.each(b, function (d, e) {
                        if (e === !1) return void delete b[d];
                        if (e.param || e.depends) {
                            var f = !0;
                            switch (typeof e.depends) {
                                case "string":
                                    f = !!a(e.depends, c.form).length;
                                    break;
                                case "function":
                                    f = e.depends.call(c, c);
                            }
                            f ? (b[d] = void 0 === e.param || e.param) : (a.data(c.form, "validator").resetElements(a(c)), delete b[d]);
                        }
                    }),
                    a.each(b, function (d, e) {
                        b[d] = a.isFunction(e) && "normalizer" !== d ? e(c) : e;
                    }),
                    a.each(["minlength", "maxlength"], function () {
                        b[this] && (b[this] = Number(b[this]));
                    }),
                    a.each(["rangelength", "range"], function () {
                        var c;
                        b[this] &&
                            (a.isArray(b[this])
                                ? (b[this] = [Number(b[this][0]), Number(b[this][1])])
                                : "string" == typeof b[this] &&
                                  ((c = b[this].replace(/[\[\]]/g, "").split(/[\s,]+/)), (b[this] = [Number(c[0]), Number(c[1])])));
                    }),
                    a.validator.autoCreateRanges &&
                        (null != b.min && null != b.max && ((b.range = [b.min, b.max]), delete b.min, delete b.max),
                        null != b.minlength &&
                            null != b.maxlength &&
                            ((b.rangelength = [b.minlength, b.maxlength]), delete b.minlength, delete b.maxlength)),
                    b
                );
            },
            normalizeRule: function (b) {
                if ("string" == typeof b) {
                    var c = {};
                    a.each(b.split(/\s/), function () {
                        c[this] = !0;
                    }),
                        (b = c);
                }
                return b;
            },
            addMethod: function (b, c, d) {
                (a.validator.methods[b] = c),
                    (a.validator.messages[b] = void 0 !== d ? d : a.validator.messages[b]),
                    c.length < 3 && a.validator.addClassRules(b, a.validator.normalizeRule(b));
            },
            methods: {
                required: function (b, c, d) {
                    if (!this.depend(d, c)) return "dependency-mismatch";
                    if ("select" === c.nodeName.toLowerCase()) {
                        var e = a(c).val();
                        return e && e.length > 0;
                    }
                    return this.checkable(c) ? this.getLength(b, c) > 0 : b.length > 0;
                },
                email: function (a, b) {
                    return (
                        this.optional(b) ||
                        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
                            a
                        )
                    );
                },
                url: function (a, b) {
                    return (
                        this.optional(b) ||
                        /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(
                            a
                        )
                    );
                },
                date: function (a, b) {
                    return this.optional(b) || !/Invalid|NaN/.test(new Date(a).toString());
                },
                dateISO: function (a, b) {
                    return this.optional(b) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a);
                },
                number: function (a, b) {
                    return this.optional(b) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a);
                },
                digits: function (a, b) {
                    return this.optional(b) || /^\d+$/.test(a);
                },
                minlength: function (b, c, d) {
                    var e = a.isArray(b) ? b.length : this.getLength(b, c);
                    return this.optional(c) || e >= d;
                },
                maxlength: function (b, c, d) {
                    var e = a.isArray(b) ? b.length : this.getLength(b, c);
                    return this.optional(c) || e <= d;
                },
                rangelength: function (b, c, d) {
                    var e = a.isArray(b) ? b.length : this.getLength(b, c);
                    return this.optional(c) || (e >= d[0] && e <= d[1]);
                },
                min: function (a, b, c) {
                    return this.optional(b) || a >= c;
                },
                max: function (a, b, c) {
                    return this.optional(b) || a <= c;
                },
                range: function (a, b, c) {
                    return this.optional(b) || (a >= c[0] && a <= c[1]);
                },
                step: function (b, c, d) {
                    var e,
                        f = a(c).attr("type"),
                        g = "Step attribute on input type " + f + " is not supported.",
                        h = ["text", "number", "range"],
                        i = new RegExp("\\b" + f + "\\b"),
                        j = f && !i.test(h.join()),
                        k = function (a) {
                            var b = ("" + a).match(/(?:\.(\d+))?$/);
                            return b && b[1] ? b[1].length : 0;
                        },
                        l = function (a) {
                            return Math.round(a * Math.pow(10, e));
                        },
                        m = !0;
                    if (j) throw new Error(g);
                    return (e = k(d)), (k(b) > e || l(b) % l(d) !== 0) && (m = !1), this.optional(c) || m;
                },
                equalTo: function (b, c, d) {
                    var e = a(d);
                    return (
                        this.settings.onfocusout &&
                            e.not(".validate-equalTo-blur").length &&
                            e.addClass("validate-equalTo-blur").on("blur.validate-equalTo", function () {
                                a(c).valid();
                            }),
                        b === e.val()
                    );
                },
                remote: function (b, c, d, e) {
                    if (this.optional(c)) return "dependency-mismatch";
                    e = ("string" == typeof e && e) || "remote";
                    var f,
                        g,
                        h,
                        i = this.previousValue(c, e);
                    return (
                        this.settings.messages[c.name] || (this.settings.messages[c.name] = {}),
                        (i.originalMessage = i.originalMessage || this.settings.messages[c.name][e]),
                        (this.settings.messages[c.name][e] = i.message),
                        (d = ("string" == typeof d && { url: d }) || d),
                        (h = a.param(a.extend({ data: b }, d.data))),
                        i.old === h
                            ? i.valid
                            : ((i.old = h),
                              (f = this),
                              this.startRequest(c),
                              (g = {}),
                              (g[c.name] = b),
                              a.ajax(
                                  a.extend(
                                      !0,
                                      {
                                          mode: "abort",
                                          port: "validate" + c.name,
                                          dataType: "json",
                                          data: g,
                                          context: f.currentForm,
                                          success: function (a) {
                                              var d,
                                                  g,
                                                  h,
                                                  j = a === !0 || "true" === a;
                                              (f.settings.messages[c.name][e] = i.originalMessage),
                                                  j
                                                      ? ((h = f.formSubmitted),
                                                        f.resetInternals(),
                                                        (f.toHide = f.errorsFor(c)),
                                                        (f.formSubmitted = h),
                                                        f.successList.push(c),
                                                        (f.invalid[c.name] = !1),
                                                        f.showErrors())
                                                      : ((d = {}),
                                                        (g = a || f.defaultMessage(c, { method: e, parameters: b })),
                                                        (d[c.name] = i.message = g),
                                                        (f.invalid[c.name] = !0),
                                                        f.showErrors(d)),
                                                  (i.valid = j),
                                                  f.stopRequest(c, j);
                                          },
                                      },
                                      d
                                  )
                              ),
                              "pending")
                    );
                },
            },
        });
    var b,
        c = {};
    return (
        a.ajaxPrefilter
            ? a.ajaxPrefilter(function (a, b, d) {
                  var e = a.port;
                  "abort" === a.mode && (c[e] && c[e].abort(), (c[e] = d));
              })
            : ((b = a.ajax),
              (a.ajax = function (d) {
                  var e = ("mode" in d ? d : a.ajaxSettings).mode,
                      f = ("port" in d ? d : a.ajaxSettings).port;
                  return "abort" === e ? (c[f] && c[f].abort(), (c[f] = b.apply(this, arguments)), c[f]) : b.apply(this, arguments);
              })),
        a
    );
});
